/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Swipe4Work Employer API
 * OpenAPI spec version: 0.1.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AddOrUpdateDefaultMessageCommandDto,
  AddOrUpdateDefaultMessageResult,
  AddUserCommentCommandDto,
  BuyCreditsCommandDto,
  ChatMessageDto,
  ChatWithJobAgentCommandDto,
  ChatWithJobAgentResult,
  CloseJobCommandDto,
  CloseMatchCommandDto,
  ComposeAiJobCommandDto,
  ComposeAiJobResult,
  ConnectMySolutionIntegrationDto,
  ConnectMySolutionIntegrationResult,
  ConvertLeadCompanyToCustomerCommandDto,
  CreateCompanyForEmployerCommandDto,
  CreateCompanyHireReport,
  CreateCompanyHireReportCommandDto,
  CreateEmployerCommandDto,
  CreateEmployerInviteCommandDto,
  CreateEmployerResponse,
  CreateFirebaseAccountForLeadCommandDto,
  CreateFirebaseAccountForLeadResult,
  CreateJobCommandDto,
  CreatePhoneContactAttemptCommandDto,
  CreateTeammateInviteCommandDto,
  DeleteDefaultMessageResult,
  DeleteEmployerCommandDto,
  DetermineAiJobDataCommandDto,
  DetermineAiJobDataResult,
  DetermineJobFunctionCommandDto,
  DetermineJobFunctionResult,
  EditUserCommentCommandDto,
  ExtractVacancyFromPageCommandDto,
  ExtractVacancyFromPageResult,
  FindBestCandidateResult,
  GetAtsConnectionSyncStatusResult,
  GetAtsIntegrationConnectionResultCarerixConnectionConfig,
  GetAtsIntegrationConnectionResultHomerunConnectionConfig,
  GetAtsIntegrationConnectionResultMySolutionConnectionConfig,
  GetAtsIntegrationConnectionResultOtysConnectionConfig,
  GetAtsIntegrationConnectionResultRecruitNowConnectionConfig,
  GetAtsIntegrationConnectionResultRecruiteeConnectionConfig,
  GetAtsIntegrationConnectionResultUbeeoConnectionConfig,
  GetAutoCompleteLocationsParams,
  GetAutoCompleteLocationsResult,
  GetCompanyFromPortalResult,
  GetCompanyHireReportInfoResult,
  GetCompanyJobsNotificationSettingsResult,
  GetCompanyMatchingConfigurationResult,
  GetCompanyPlanResult,
  GetCompanyStatisticsResult,
  GetConferenceChatWithMessagesForEmployerResult,
  GetConferenceInfoResult,
  GetCreditNoteFileUrlResult,
  GetEmployerAccessResult,
  GetEmployerOnboardingStatusParams,
  GetEmployerOnboardingStatusResult,
  GetEmployerProfileResult,
  GetInvoiceFileUrlResult,
  GetJobApplicationResult,
  GetJobApplicationTabCountsParams,
  GetJobApplicationTabCountsResult,
  GetJobNotificationSettingsResult,
  GetJobResult,
  GetLeadEmployerResult,
  GetLocationDetailsParams,
  GetLocationDetailsResult,
  GetLocationGeocodeParams,
  GetLocationGeocodeResult,
  GetMatchChatWithMessagesResult,
  GetMatchedUserResult,
  GetMySolutionApplyConfigurationParams,
  GetMySolutionApplyConfigurationResult,
  GetMySolutionWebhookInfoResult,
  GetOrCreateAtsIntegrationConnectionCommandDtoCarerixConnectionSecrets,
  GetOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecrets,
  GetOrCreateAtsIntegrationConnectionCommandDtoOtysConnectionSecrets,
  GetOrCreateAtsIntegrationConnectionCommandDtoRecruitNowConnectionSecrets,
  GetOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecrets,
  GetOrCreateAtsIntegrationConnectionCommandDtoUbeeoConnectionSecrets,
  GetRecruiteeJobLocationsResult,
  GetRoleResult,
  GetSubscriptionResult,
  GetUserCommentsResult,
  ImageDto,
  ImportAtsJobCommandDto,
  IntegrationConnectionDto,
  ItemInput,
  JobCategoryCrudJobCategoryDto,
  JobCategoryCrudListResult,
  JobFunctionCrudListResult,
  ListAllMatchesParams,
  ListAllSkillsResult,
  ListAtsJobsParams,
  ListAtsJobsResult,
  ListAtsVacanciesParams,
  ListAtsVacanciesResult,
  ListCarerixOwnersResult,
  ListCarerixSourceNodesResult,
  ListCarerixStatusInfosResult,
  ListCertificatesResult,
  ListCompanySubscriptionsResult,
  ListConferenceChatsEmployerParams,
  ListConferenceChatsResult,
  ListCreditNotesForCompanyResult,
  ListCreditTransactionsResult,
  ListEducationLevelsResult,
  ListEducationLevelsWithTrackCategoryResult,
  ListIntegrationsResult,
  ListInterestsResult,
  ListInvoicesForCompanyResult,
  ListJobApplicationCandidatesParams,
  ListJobApplicationCandidatesResult,
  ListJobApplicationRejectionReasonsResult,
  ListJobFunctionsParams,
  ListJobsInPortalResult,
  ListJobsParams,
  ListManagedCompaniesResult,
  ListMatchesByStageParams,
  ListMatchesByStageResult,
  ListMatchesResult,
  ListNewJobReasonsResult,
  ListOtherEmployersForCompanyResult,
  ListOtysPortalsResult,
  ListPaymentOptionsResult,
  ListPersonalCharacteristicsResult,
  ListPersonalityTypesResult,
  ListReferralInvitesResult,
  ListSimilarJobFunctionsParams,
  ListSimilarJobFunctionsResult,
  ListSkillsCertificatesAndLanguagesResult,
  ListSkillsForJobCategoriesParams,
  ListSkillsForJobCategoriesResult,
  ListUnhandledJobsParams,
  ListUnhandledJobsResult,
  ListUnreadConferenceChatsEmployerParams,
  ListUnreadConferenceChatsResult,
  MapJobWithAtsJobCommandDto,
  ProblemDetails,
  ReactToCandidateCommandDto,
  ReactToCandidateResult,
  RejectJobApplicationCommandDto,
  RejectJobApplicationResult,
  RepublishJobCommandDto,
  ResendAtsJobApplicationsResult,
  ReviewAiJobCommandDto,
  RewriteJobSectionCommandDto,
  RewriteJobSectionResult,
  SendCompleteProfileRequestCommandDto,
  SendMessageCommandDto,
  SendPasswordResetEmailCommandDto,
  SendPollCommandDto,
  SendPollResult,
  SendRequestToAccountManagerCommandDto,
  SetCompanyMatchingConfigurationCommandDto,
  StartMatchCommandDto,
  StartMatchResult,
  Unit,
  UpdateAtsIntegrationConnectionCommandDtoCarerixConnectionConfig,
  UpdateAtsIntegrationConnectionCommandDtoHomerunConnectionConfig,
  UpdateAtsIntegrationConnectionCommandDtoMySolutionConnectionConfig,
  UpdateAtsIntegrationConnectionCommandDtoOtysConnectionConfig,
  UpdateAtsIntegrationConnectionCommandDtoRecruitNowConnectionConfig,
  UpdateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfig,
  UpdateAtsIntegrationConnectionCommandDtoUbeeoConnectionConfig,
  UpdateCalendarInviteBodyCommandDto,
  UpdateCarerixJobMappingCommandDto,
  UpdateCompanyFromPortalCommandDto,
  UpdateDefaultCandidatePoolCommandDto,
  UpdateEmployerCompanyAccessCommandDto,
  UpdateEmployerCompanyAccessResult,
  UpdateEmployerProfileCommandDto,
  UpdateJobCandidatePoolCommandDto,
  UpdateJobCommandDto,
  UpdateJobNotificationSettingsCommandDto,
  UpdateJobPublishedCommandDto,
  UpdateJobPublishedResult,
  UpdateJobsNotificationSettingsCommandDto,
  UpdateMatchCommandDto,
  UpdateOtysPortalCommandDto,
  UploadEmployerProfilePictureBody,
  UploadProvisionalImageBody,
  WriteAiJobSectionsResult
} from './models';

import {
  faker
} from '@faker-js/faker';

import {
  HttpResponse,
  delay,
  http
} from 'msw';
import type {
  HttpResponseResolver,
  PathParams,
  RequestHandlerOptions
} from 'msw';

import {
  AiJobDataField,
  AtsJobMappingStatus,
  AtsSendFlow,
  AtsVacancyImportState,
  CandidatePoolSize,
  CharacteristicColor,
  ChatMessagePhase,
  ChatMessageSenderRole,
  ConnectionStatus,
  DefaultMessageType,
  DeterminationSource,
  EmployerInviteType,
  EmployerOnboardingStatus,
  EmployerRole,
  ExperienceLevel,
  FeatureImportance,
  IntegrationType,
  IntegrationVisibility,
  InvoiceStatus,
  JobApplicationClosureReasonCode,
  JobApplicationState,
  JobClosureReason,
  JobStatus,
  MatchCloseReason,
  MatchStatus,
  NormalizedOfferStatus,
  Periodicity,
  PermissionLevel,
  PermissionResource,
  ReportingPeriodicity,
  Role,
  SkillType,
  SubscriptionStatus,
  TrackCategory,
  WorkExperienceType
} from './models';

import { fetchWithAuth } from '../../../src/modules/orval/fetch-with-auth';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getAddUserCommentUrl = () => {




  return `/v1/employer/user/comments`
}

/**
 * @summary Add a new internal comment about a user (candidate).
 */
export const addUserComment = async (addUserCommentCommandDto?: AddUserCommentCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<void>(getAddUserCommentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addUserCommentCommandDto)
  }
);}





export const getAddUserCommentMutationKey = () => ['addUserComment'] as const;

export const getAddUserCommentMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addUserComment>>, TError,AddUserCommentMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof addUserComment>>, TError,AddUserCommentMutationVariables, TContext> => {

const mutationKey = getAddUserCommentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addUserComment>>, AddUserCommentMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  addUserComment(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddUserCommentMutationResult = NonNullable<Awaited<ReturnType<typeof addUserComment>>>
    export type AddUserCommentMutationBody = AddUserCommentCommandDto | undefined
    export type AddUserCommentMutationError = ProblemDetails
    export type AddUserCommentMutationVariables = {data?: AddUserCommentCommandDto}

    /**
 * @summary Add a new internal comment about a user (candidate).
 */
export const useAddUserComment = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addUserComment>>, TError,AddUserCommentMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof addUserComment>>,
        TError,
        AddUserCommentMutationVariables,
        TContext
      > => {
      return useMutation(getAddUserCommentMutationOptions(options), queryClient);
    }

export const getGetUserCommentsUrl = (userId: number,) => {




  return `/v1/employer/user/comments/${userId}`
}

/**
 * @summary Get all comments for a user (candidate) visible to the current employer's company.
 */
export const getUserComments = async (userId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetUserCommentsResult> => {

  return fetchWithAuth<GetUserCommentsResult>(getGetUserCommentsUrl(userId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUserCommentsQueryKey = (userId: MaybeRefOrGetter<number>,) => {
    return [
    'v1','employer','user','comments',userId
    ] as const;
    }


export const getGetUserCommentsQueryOptions = <TData = Awaited<ReturnType<typeof getUserComments>>, TError = ProblemDetails>(userId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserComments>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetUserCommentsQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserComments>>> = ({ signal }) => getUserComments(toValue(userId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(userId) !== null && toValue(userId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserComments>>, TError, TData>
}

export type GetUserCommentsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserComments>>>
export type GetUserCommentsQueryError = ProblemDetails


/**
 * @summary Get all comments for a user (candidate) visible to the current employer's company.
 */

export function useGetUserComments<TData = Awaited<ReturnType<typeof getUserComments>>, TError = ProblemDetails>(
 userId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserComments>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserCommentsQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getEditUserCommentUrl = (commentId: number,) => {




  return `/v1/employer/user/comments/${commentId}`
}

/**
 * @summary Edit an existing comment (only by the author).
 */
export const editUserComment = async (commentId: number,
    editUserCommentCommandDto?: EditUserCommentCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<void>(getEditUserCommentUrl(commentId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(editUserCommentCommandDto)
  }
);}





export const getEditUserCommentMutationKey = () => ['editUserComment'] as const;

export const getEditUserCommentMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editUserComment>>, TError,EditUserCommentMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof editUserComment>>, TError,EditUserCommentMutationVariables, TContext> => {

const mutationKey = getEditUserCommentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editUserComment>>, EditUserCommentMutationVariables> = (props) => {
          const {commentId,data} = props ?? {};

          return  editUserComment(commentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditUserCommentMutationResult = NonNullable<Awaited<ReturnType<typeof editUserComment>>>
    export type EditUserCommentMutationBody = EditUserCommentCommandDto | undefined
    export type EditUserCommentMutationError = ProblemDetails
    export type EditUserCommentMutationVariables = {commentId: number;data?: EditUserCommentCommandDto}

    /**
 * @summary Edit an existing comment (only by the author).
 */
export const useEditUserComment = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editUserComment>>, TError,EditUserCommentMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof editUserComment>>,
        TError,
        EditUserCommentMutationVariables,
        TContext
      > => {
      return useMutation(getEditUserCommentMutationOptions(options), queryClient);
    }

export const getDeleteUserCommentUrl = (commentId: number,) => {




  return `/v1/employer/user/comments/${commentId}`
}

/**
 * @summary Soft-delete a comment (only by the author).
 */
export const deleteUserComment = async (commentId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getDeleteUserCommentUrl(commentId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteUserCommentMutationKey = () => ['deleteUserComment'] as const;

export const getDeleteUserCommentMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserComment>>, TError,DeleteUserCommentMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserComment>>, TError,DeleteUserCommentMutationVariables, TContext> => {

const mutationKey = getDeleteUserCommentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserComment>>, DeleteUserCommentMutationVariables> = (props) => {
          const {commentId} = props ?? {};

          return  deleteUserComment(commentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserCommentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserComment>>>

    export type DeleteUserCommentMutationError = ProblemDetails
    export type DeleteUserCommentMutationVariables = {commentId: number}

    /**
 * @summary Soft-delete a comment (only by the author).
 */
export const useDeleteUserComment = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserComment>>, TError,DeleteUserCommentMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteUserComment>>,
        TError,
        DeleteUserCommentMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteUserCommentMutationOptions(options), queryClient);
    }

export const getResetEmployerAccountForTestingUrl = () => {




  return `/testing-employer/reset`
}

/**
 * @summary [TESTING ONLY] Resets the account state for the currently logged-in employer.
Deletes the Employer record, resets the associated EmployerInvite, and removes the Firebase user
so the employer can go through onboarding again via the same invite link.
 */
export const resetEmployerAccountForTesting = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getResetEmployerAccountForTestingUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getResetEmployerAccountForTestingMutationKey = () => ['resetEmployerAccountForTesting'] as const;

export const getResetEmployerAccountForTestingMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetEmployerAccountForTesting>>, TError,void, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof resetEmployerAccountForTesting>>, TError,void, TContext> => {

const mutationKey = getResetEmployerAccountForTestingMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetEmployerAccountForTesting>>, void> = () => {


          return  resetEmployerAccountForTesting(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetEmployerAccountForTestingMutationResult = NonNullable<Awaited<ReturnType<typeof resetEmployerAccountForTesting>>>

    export type ResetEmployerAccountForTestingMutationError = ProblemDetails


    /**
 * @summary [TESTING ONLY] Resets the account state for the currently logged-in employer.
Deletes the Employer record, resets the associated EmployerInvite, and removes the Firebase user
so the employer can go through onboarding again via the same invite link.
 */
export const useResetEmployerAccountForTesting = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetEmployerAccountForTesting>>, TError,void, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof resetEmployerAccountForTesting>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getResetEmployerAccountForTestingMutationOptions(options), queryClient);
    }

export const getListEducationLevelsWithTrackCategoryUrl = () => {




  return `/employer/static-data/education-levels`
}

/**
 * @summary List all education levels
 */
export const listEducationLevelsWithTrackCategory = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListEducationLevelsWithTrackCategoryResult> => {

  return fetchWithAuth<ListEducationLevelsWithTrackCategoryResult>(getListEducationLevelsWithTrackCategoryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEducationLevelsWithTrackCategoryQueryKey = () => {
    return [
    'employer','static-data','education-levels'
    ] as const;
    }


export const getListEducationLevelsWithTrackCategoryQueryOptions = <TData = Awaited<ReturnType<typeof listEducationLevelsWithTrackCategory>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEducationLevelsWithTrackCategory>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListEducationLevelsWithTrackCategoryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEducationLevelsWithTrackCategory>>> = ({ signal }) => listEducationLevelsWithTrackCategory({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEducationLevelsWithTrackCategory>>, TError, TData>
}

export type ListEducationLevelsWithTrackCategoryQueryResult = NonNullable<Awaited<ReturnType<typeof listEducationLevelsWithTrackCategory>>>
export type ListEducationLevelsWithTrackCategoryQueryError = unknown


/**
 * @summary List all education levels
 */

export function useListEducationLevelsWithTrackCategory<TData = Awaited<ReturnType<typeof listEducationLevelsWithTrackCategory>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEducationLevelsWithTrackCategory>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEducationLevelsWithTrackCategoryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getCreateCompanyForEmployerUrl = () => {




  return `/employer/employer-onboarding/create-company`
}

export const createCompanyForEmployer = async (createCompanyForEmployerCommandDto?: CreateCompanyForEmployerCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<void>(getCreateCompanyForEmployerUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createCompanyForEmployerCommandDto)
  }
);}





export const getCreateCompanyForEmployerMutationKey = () => ['createCompanyForEmployer'] as const;

export const getCreateCompanyForEmployerMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompanyForEmployer>>, TError,CreateCompanyForEmployerMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof createCompanyForEmployer>>, TError,CreateCompanyForEmployerMutationVariables, TContext> => {

const mutationKey = getCreateCompanyForEmployerMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCompanyForEmployer>>, CreateCompanyForEmployerMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createCompanyForEmployer(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCompanyForEmployerMutationResult = NonNullable<Awaited<ReturnType<typeof createCompanyForEmployer>>>
    export type CreateCompanyForEmployerMutationBody = CreateCompanyForEmployerCommandDto | undefined
    export type CreateCompanyForEmployerMutationError = ProblemDetails
    export type CreateCompanyForEmployerMutationVariables = {data?: CreateCompanyForEmployerCommandDto}

    export const useCreateCompanyForEmployer = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompanyForEmployer>>, TError,CreateCompanyForEmployerMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createCompanyForEmployer>>,
        TError,
        CreateCompanyForEmployerMutationVariables,
        TContext
      > => {
      return useMutation(getCreateCompanyForEmployerMutationOptions(options), queryClient);
    }

export const getListPaymentOptionsUrl = () => {




  return `/employer/employer-onboarding/payment-options`
}

/**
 * @summary List Payment options.
Contains subscriptions and credit packages.
 */
export const listPaymentOptions = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListPaymentOptionsResult> => {

  return fetchWithAuth<ListPaymentOptionsResult>(getListPaymentOptionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPaymentOptionsQueryKey = () => {
    return [
    'employer','employer-onboarding','payment-options'
    ] as const;
    }


export const getListPaymentOptionsQueryOptions = <TData = Awaited<ReturnType<typeof listPaymentOptions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPaymentOptions>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListPaymentOptionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPaymentOptions>>> = ({ signal }) => listPaymentOptions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPaymentOptions>>, TError, TData>
}

export type ListPaymentOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof listPaymentOptions>>>
export type ListPaymentOptionsQueryError = unknown


/**
 * @summary List Payment options.
Contains subscriptions and credit packages.
 */

export function useListPaymentOptions<TData = Awaited<ReturnType<typeof listPaymentOptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPaymentOptions>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPaymentOptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getCreateEmployerUrl = () => {




  return `/employer/v2/onboarding/register`
}

export const createEmployer = async (createEmployerCommandDto?: CreateEmployerCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<CreateEmployerResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<CreateEmployerResponse>(getCreateEmployerUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createEmployerCommandDto)
  }
);}





export const getCreateEmployerMutationKey = () => ['createEmployer'] as const;

export const getCreateEmployerMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployer>>, TError,CreateEmployerMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof createEmployer>>, TError,CreateEmployerMutationVariables, TContext> => {

const mutationKey = getCreateEmployerMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEmployer>>, CreateEmployerMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createEmployer(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateEmployerMutationResult = NonNullable<Awaited<ReturnType<typeof createEmployer>>>
    export type CreateEmployerMutationBody = CreateEmployerCommandDto | undefined
    export type CreateEmployerMutationError = ProblemDetails
    export type CreateEmployerMutationVariables = {data?: CreateEmployerCommandDto}

    export const useCreateEmployer = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployer>>, TError,CreateEmployerMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createEmployer>>,
        TError,
        CreateEmployerMutationVariables,
        TContext
      > => {
      return useMutation(getCreateEmployerMutationOptions(options), queryClient);
    }

export const getGetEmployerOnboardingStatusUrl = (params?: GetEmployerOnboardingStatusParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/employer/v2/onboarding?${stringifiedParams}` : `/employer/v2/onboarding`
}

export const getEmployerOnboardingStatus = async (params?: GetEmployerOnboardingStatusParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetEmployerOnboardingStatusResult> => {

  return fetchWithAuth<GetEmployerOnboardingStatusResult>(getGetEmployerOnboardingStatusUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEmployerOnboardingStatusQueryKey = (params?: MaybeRefOrGetter<GetEmployerOnboardingStatusParams>,) => {
    return [
    'employer','v2','onboarding', ...(params ? [params] : [])
    ] as const;
    }


export const getGetEmployerOnboardingStatusQueryOptions = <TData = Awaited<ReturnType<typeof getEmployerOnboardingStatus>>, TError = ProblemDetails>(params?: MaybeRefOrGetter<GetEmployerOnboardingStatusParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerOnboardingStatus>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetEmployerOnboardingStatusQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployerOnboardingStatus>>> = ({ signal }) => getEmployerOnboardingStatus(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployerOnboardingStatus>>, TError, TData>
}

export type GetEmployerOnboardingStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployerOnboardingStatus>>>
export type GetEmployerOnboardingStatusQueryError = ProblemDetails



export function useGetEmployerOnboardingStatus<TData = Awaited<ReturnType<typeof getEmployerOnboardingStatus>>, TError = ProblemDetails>(
 params?: MaybeRefOrGetter<GetEmployerOnboardingStatusParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerOnboardingStatus>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployerOnboardingStatusQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListAllMatchesUrl = (params: ListAllMatchesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/employer/match?${stringifiedParams}` : `/employer/match`
}

/**
 * @summary List one page of the current company's matches, filtered and ordered as requested
 */
export const listAllMatches = async (params: ListAllMatchesParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListMatchesResult> => {

  return fetchWithAuth<ListMatchesResult>(getListAllMatchesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAllMatchesQueryKey = (params?: MaybeRefOrGetter<ListAllMatchesParams>,) => {
    return [
    'employer','match', ...(params ? [params] : [])
    ] as const;
    }


export const getListAllMatchesQueryOptions = <TData = Awaited<ReturnType<typeof listAllMatches>>, TError = unknown>(params: MaybeRefOrGetter<ListAllMatchesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllMatches>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListAllMatchesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllMatches>>> = ({ signal }) => listAllMatches(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAllMatches>>, TError, TData>
}

export type ListAllMatchesQueryResult = NonNullable<Awaited<ReturnType<typeof listAllMatches>>>
export type ListAllMatchesQueryError = unknown


/**
 * @summary List one page of the current company's matches, filtered and ordered as requested
 */

export function useListAllMatches<TData = Awaited<ReturnType<typeof listAllMatches>>, TError = unknown>(
 params: MaybeRefOrGetter<ListAllMatchesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllMatches>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAllMatchesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getHasUnreadMatchesUrl = () => {




  return `/employer/match/has-unread`
}

/**
 * @summary Whether any open match of the current company has unread messages
 */
export const hasUnreadMatches = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<boolean> => {

  return fetchWithAuth<boolean>(getHasUnreadMatchesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHasUnreadMatchesQueryKey = () => {
    return [
    'employer','match','has-unread'
    ] as const;
    }


export const getHasUnreadMatchesQueryOptions = <TData = Awaited<ReturnType<typeof hasUnreadMatches>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hasUnreadMatches>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getHasUnreadMatchesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hasUnreadMatches>>> = ({ signal }) => hasUnreadMatches({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hasUnreadMatches>>, TError, TData>
}

export type HasUnreadMatchesQueryResult = NonNullable<Awaited<ReturnType<typeof hasUnreadMatches>>>
export type HasUnreadMatchesQueryError = unknown


/**
 * @summary Whether any open match of the current company has unread messages
 */

export function useHasUnreadMatches<TData = Awaited<ReturnType<typeof hasUnreadMatches>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hasUnreadMatches>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHasUnreadMatchesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetMatchedUserUrl = (id: number,) => {




  return `/employer/match/${id}/user`
}

export const getMatchedUser = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetMatchedUserResult> => {

  return fetchWithAuth<GetMatchedUserResult>(getGetMatchedUserUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMatchedUserQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'employer','match',id,'user'
    ] as const;
    }


export const getGetMatchedUserQueryOptions = <TData = Awaited<ReturnType<typeof getMatchedUser>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMatchedUser>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetMatchedUserQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMatchedUser>>> = ({ signal }) => getMatchedUser(toValue(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMatchedUser>>, TError, TData>
}

export type GetMatchedUserQueryResult = NonNullable<Awaited<ReturnType<typeof getMatchedUser>>>
export type GetMatchedUserQueryError = ProblemDetails



export function useGetMatchedUser<TData = Awaited<ReturnType<typeof getMatchedUser>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMatchedUser>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMatchedUserQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getDownloadCandidatePdfUrl = (id: number,) => {




  return `/employer/match/${id}/candidate-pdf`
}

/**
 * @summary Download a candidate's profile as a PDF file.
 */
export const downloadCandidatePdf = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Blob> => {

  return fetchWithAuth<Blob>(getDownloadCandidatePdfUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadCandidatePdfQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'employer','match',id,'candidate-pdf'
    ] as const;
    }


export const getDownloadCandidatePdfQueryOptions = <TData = Awaited<ReturnType<typeof downloadCandidatePdf>>, TError = Blob>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadCandidatePdf>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getDownloadCandidatePdfQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadCandidatePdf>>> = ({ signal }) => downloadCandidatePdf(toValue(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadCandidatePdf>>, TError, TData>
}

export type DownloadCandidatePdfQueryResult = NonNullable<Awaited<ReturnType<typeof downloadCandidatePdf>>>
export type DownloadCandidatePdfQueryError = Blob


/**
 * @summary Download a candidate's profile as a PDF file.
 */

export function useDownloadCandidatePdf<TData = Awaited<ReturnType<typeof downloadCandidatePdf>>, TError = Blob>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadCandidatePdf>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadCandidatePdfQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getCreatePhoneContactAttemptUrl = () => {




  return `/employer/match/phone-contact-attempt`
}

export const createPhoneContactAttempt = async (createPhoneContactAttemptCommandDto?: CreatePhoneContactAttemptCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<void>(getCreatePhoneContactAttemptUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createPhoneContactAttemptCommandDto)
  }
);}





export const getCreatePhoneContactAttemptMutationKey = () => ['createPhoneContactAttempt'] as const;

export const getCreatePhoneContactAttemptMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPhoneContactAttempt>>, TError,CreatePhoneContactAttemptMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof createPhoneContactAttempt>>, TError,CreatePhoneContactAttemptMutationVariables, TContext> => {

const mutationKey = getCreatePhoneContactAttemptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPhoneContactAttempt>>, CreatePhoneContactAttemptMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createPhoneContactAttempt(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePhoneContactAttemptMutationResult = NonNullable<Awaited<ReturnType<typeof createPhoneContactAttempt>>>
    export type CreatePhoneContactAttemptMutationBody = CreatePhoneContactAttemptCommandDto | undefined
    export type CreatePhoneContactAttemptMutationError = ProblemDetails
    export type CreatePhoneContactAttemptMutationVariables = {data?: CreatePhoneContactAttemptCommandDto}

    export const useCreatePhoneContactAttempt = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPhoneContactAttempt>>, TError,CreatePhoneContactAttemptMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createPhoneContactAttempt>>,
        TError,
        CreatePhoneContactAttemptMutationVariables,
        TContext
      > => {
      return useMutation(getCreatePhoneContactAttemptMutationOptions(options), queryClient);
    }

export const getCloseMatchUrl = () => {




  return `/employer/match/close`
}

export const closeMatch = async (closeMatchCommandDto?: CloseMatchCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<void>(getCloseMatchUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(closeMatchCommandDto)
  }
);}





export const getCloseMatchMutationKey = () => ['closeMatch'] as const;

export const getCloseMatchMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeMatch>>, TError,CloseMatchMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof closeMatch>>, TError,CloseMatchMutationVariables, TContext> => {

const mutationKey = getCloseMatchMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closeMatch>>, CloseMatchMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  closeMatch(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CloseMatchMutationResult = NonNullable<Awaited<ReturnType<typeof closeMatch>>>
    export type CloseMatchMutationBody = CloseMatchCommandDto | undefined
    export type CloseMatchMutationError = ProblemDetails
    export type CloseMatchMutationVariables = {data?: CloseMatchCommandDto}

    export const useCloseMatch = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeMatch>>, TError,CloseMatchMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof closeMatch>>,
        TError,
        CloseMatchMutationVariables,
        TContext
      > => {
      return useMutation(getCloseMatchMutationOptions(options), queryClient);
    }

export const getUpdateMatchUrl = () => {




  return `/employer/match/status`
}

export const updateMatch = async (updateMatchCommandDto?: UpdateMatchCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<void>(getUpdateMatchUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateMatchCommandDto)
  }
);}





export const getUpdateMatchMutationKey = () => ['updateMatch'] as const;

export const getUpdateMatchMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMatch>>, TError,UpdateMatchMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMatch>>, TError,UpdateMatchMutationVariables, TContext> => {

const mutationKey = getUpdateMatchMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMatch>>, UpdateMatchMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateMatch(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMatchMutationResult = NonNullable<Awaited<ReturnType<typeof updateMatch>>>
    export type UpdateMatchMutationBody = UpdateMatchCommandDto | undefined
    export type UpdateMatchMutationError = ProblemDetails
    export type UpdateMatchMutationVariables = {data?: UpdateMatchCommandDto}

    export const useUpdateMatch = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMatch>>, TError,UpdateMatchMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateMatch>>,
        TError,
        UpdateMatchMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateMatchMutationOptions(options), queryClient);
    }

export const getListMatchesByStageUrl = (params?: ListMatchesByStageParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/employer/match/dashboard?${stringifiedParams}` : `/employer/match/dashboard`
}

export const listMatchesByStage = async (params?: ListMatchesByStageParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListMatchesByStageResult> => {

  return fetchWithAuth<ListMatchesByStageResult>(getListMatchesByStageUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMatchesByStageQueryKey = (params?: MaybeRefOrGetter<ListMatchesByStageParams>,) => {
    return [
    'employer','match','dashboard', ...(params ? [params] : [])
    ] as const;
    }


export const getListMatchesByStageQueryOptions = <TData = Awaited<ReturnType<typeof listMatchesByStage>>, TError = unknown>(params?: MaybeRefOrGetter<ListMatchesByStageParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMatchesByStage>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListMatchesByStageQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMatchesByStage>>> = ({ signal }) => listMatchesByStage(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMatchesByStage>>, TError, TData>
}

export type ListMatchesByStageQueryResult = NonNullable<Awaited<ReturnType<typeof listMatchesByStage>>>
export type ListMatchesByStageQueryError = unknown



export function useListMatchesByStage<TData = Awaited<ReturnType<typeof listMatchesByStage>>, TError = unknown>(
 params?: MaybeRefOrGetter<ListMatchesByStageParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMatchesByStage>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMatchesByStageQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetMatchChatWithMessagesForEmployerUrl = (id: number,) => {




  return `/employer/match/${id}/chat`
}

export const getMatchChatWithMessagesForEmployer = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetMatchChatWithMessagesResult> => {

  return fetchWithAuth<GetMatchChatWithMessagesResult>(getGetMatchChatWithMessagesForEmployerUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMatchChatWithMessagesForEmployerQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'employer','match',id,'chat'
    ] as const;
    }


export const getGetMatchChatWithMessagesForEmployerQueryOptions = <TData = Awaited<ReturnType<typeof getMatchChatWithMessagesForEmployer>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMatchChatWithMessagesForEmployer>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetMatchChatWithMessagesForEmployerQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMatchChatWithMessagesForEmployer>>> = ({ signal }) => getMatchChatWithMessagesForEmployer(toValue(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMatchChatWithMessagesForEmployer>>, TError, TData>
}

export type GetMatchChatWithMessagesForEmployerQueryResult = NonNullable<Awaited<ReturnType<typeof getMatchChatWithMessagesForEmployer>>>
export type GetMatchChatWithMessagesForEmployerQueryError = ProblemDetails



export function useGetMatchChatWithMessagesForEmployer<TData = Awaited<ReturnType<typeof getMatchChatWithMessagesForEmployer>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMatchChatWithMessagesForEmployer>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMatchChatWithMessagesForEmployerQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getSendMatchChatMessageForEmployerUrl = () => {




  return `/employer/match/chat`
}

export const sendMatchChatMessageForEmployer = async (sendMessageCommandDto?: SendMessageCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ChatMessageDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<ChatMessageDto>(getSendMatchChatMessageForEmployerUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(sendMessageCommandDto)
  }
);}





export const getSendMatchChatMessageForEmployerMutationKey = () => ['sendMatchChatMessageForEmployer'] as const;

export const getSendMatchChatMessageForEmployerMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendMatchChatMessageForEmployer>>, TError,SendMatchChatMessageForEmployerMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof sendMatchChatMessageForEmployer>>, TError,SendMatchChatMessageForEmployerMutationVariables, TContext> => {

const mutationKey = getSendMatchChatMessageForEmployerMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendMatchChatMessageForEmployer>>, SendMatchChatMessageForEmployerMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  sendMatchChatMessageForEmployer(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendMatchChatMessageForEmployerMutationResult = NonNullable<Awaited<ReturnType<typeof sendMatchChatMessageForEmployer>>>
    export type SendMatchChatMessageForEmployerMutationBody = SendMessageCommandDto | undefined
    export type SendMatchChatMessageForEmployerMutationError = ProblemDetails
    export type SendMatchChatMessageForEmployerMutationVariables = {data?: SendMessageCommandDto}

    export const useSendMatchChatMessageForEmployer = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendMatchChatMessageForEmployer>>, TError,SendMatchChatMessageForEmployerMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sendMatchChatMessageForEmployer>>,
        TError,
        SendMatchChatMessageForEmployerMutationVariables,
        TContext
      > => {
      return useMutation(getSendMatchChatMessageForEmployerMutationOptions(options), queryClient);
    }

export const getSendPollUrl = () => {




  return `/employer/match/poll`
}

export const sendPoll = async (sendPollCommandDto?: SendPollCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<SendPollResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<SendPollResult>(getSendPollUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(sendPollCommandDto)
  }
);}





export const getSendPollMutationKey = () => ['sendPoll'] as const;

export const getSendPollMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendPoll>>, TError,SendPollMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof sendPoll>>, TError,SendPollMutationVariables, TContext> => {

const mutationKey = getSendPollMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendPoll>>, SendPollMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  sendPoll(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendPollMutationResult = NonNullable<Awaited<ReturnType<typeof sendPoll>>>
    export type SendPollMutationBody = SendPollCommandDto | undefined
    export type SendPollMutationError = ProblemDetails
    export type SendPollMutationVariables = {data?: SendPollCommandDto}

    export const useSendPoll = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendPoll>>, TError,SendPollMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sendPoll>>,
        TError,
        SendPollMutationVariables,
        TContext
      > => {
      return useMutation(getSendPollMutationOptions(options), queryClient);
    }

export const getGetLeadEmployerUrl = () => {




  return `/employer/lead/account`
}

export const getLeadEmployer = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetLeadEmployerResult> => {

  return fetchWithAuth<GetLeadEmployerResult>(getGetLeadEmployerUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLeadEmployerQueryKey = () => {
    return [
    'employer','lead','account'
    ] as const;
    }


export const getGetLeadEmployerQueryOptions = <TData = Awaited<ReturnType<typeof getLeadEmployer>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeadEmployer>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetLeadEmployerQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeadEmployer>>> = ({ signal }) => getLeadEmployer({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeadEmployer>>, TError, TData>
}

export type GetLeadEmployerQueryResult = NonNullable<Awaited<ReturnType<typeof getLeadEmployer>>>
export type GetLeadEmployerQueryError = ProblemDetails



export function useGetLeadEmployer<TData = Awaited<ReturnType<typeof getLeadEmployer>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeadEmployer>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeadEmployerQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getCreateFirebaseAccountForLeadUrl = () => {




  return `/employer/lead/account`
}

export const createFirebaseAccountForLead = async (createFirebaseAccountForLeadCommandDto?: CreateFirebaseAccountForLeadCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<CreateFirebaseAccountForLeadResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<CreateFirebaseAccountForLeadResult>(getCreateFirebaseAccountForLeadUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createFirebaseAccountForLeadCommandDto)
  }
);}





export const getCreateFirebaseAccountForLeadMutationKey = () => ['createFirebaseAccountForLead'] as const;

export const getCreateFirebaseAccountForLeadMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFirebaseAccountForLead>>, TError,CreateFirebaseAccountForLeadMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof createFirebaseAccountForLead>>, TError,CreateFirebaseAccountForLeadMutationVariables, TContext> => {

const mutationKey = getCreateFirebaseAccountForLeadMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFirebaseAccountForLead>>, CreateFirebaseAccountForLeadMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createFirebaseAccountForLead(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFirebaseAccountForLeadMutationResult = NonNullable<Awaited<ReturnType<typeof createFirebaseAccountForLead>>>
    export type CreateFirebaseAccountForLeadMutationBody = CreateFirebaseAccountForLeadCommandDto | undefined
    export type CreateFirebaseAccountForLeadMutationError = ProblemDetails
    export type CreateFirebaseAccountForLeadMutationVariables = {data?: CreateFirebaseAccountForLeadCommandDto}

    export const useCreateFirebaseAccountForLead = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFirebaseAccountForLead>>, TError,CreateFirebaseAccountForLeadMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFirebaseAccountForLead>>,
        TError,
        CreateFirebaseAccountForLeadMutationVariables,
        TContext
      > => {
      return useMutation(getCreateFirebaseAccountForLeadMutationOptions(options), queryClient);
    }

export const getConvertLeadCompanyToRegularUrl = () => {




  return `/employer/lead/company`
}

export const convertLeadCompanyToRegular = async (convertLeadCompanyToCustomerCommandDto?: ConvertLeadCompanyToCustomerCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<void>(getConvertLeadCompanyToRegularUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(convertLeadCompanyToCustomerCommandDto)
  }
);}





export const getConvertLeadCompanyToRegularMutationKey = () => ['convertLeadCompanyToRegular'] as const;

export const getConvertLeadCompanyToRegularMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof convertLeadCompanyToRegular>>, TError,ConvertLeadCompanyToRegularMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof convertLeadCompanyToRegular>>, TError,ConvertLeadCompanyToRegularMutationVariables, TContext> => {

const mutationKey = getConvertLeadCompanyToRegularMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof convertLeadCompanyToRegular>>, ConvertLeadCompanyToRegularMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  convertLeadCompanyToRegular(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConvertLeadCompanyToRegularMutationResult = NonNullable<Awaited<ReturnType<typeof convertLeadCompanyToRegular>>>
    export type ConvertLeadCompanyToRegularMutationBody = ConvertLeadCompanyToCustomerCommandDto | undefined
    export type ConvertLeadCompanyToRegularMutationError = ProblemDetails
    export type ConvertLeadCompanyToRegularMutationVariables = {data?: ConvertLeadCompanyToCustomerCommandDto}

    export const useConvertLeadCompanyToRegular = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof convertLeadCompanyToRegular>>, TError,ConvertLeadCompanyToRegularMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof convertLeadCompanyToRegular>>,
        TError,
        ConvertLeadCompanyToRegularMutationVariables,
        TContext
      > => {
      return useMutation(getConvertLeadCompanyToRegularMutationOptions(options), queryClient);
    }

export const getListJobsUrl = (params?: ListJobsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/employer/job?${stringifiedParams}` : `/employer/job`
}

/**
 * @summary List all jobs for the current company
 */
export const listJobs = async (params?: ListJobsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListJobsInPortalResult> => {

  return fetchWithAuth<ListJobsInPortalResult>(getListJobsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListJobsQueryKey = (params?: MaybeRefOrGetter<ListJobsParams>,) => {
    return [
    'employer','job', ...(params ? [params] : [])
    ] as const;
    }


export const getListJobsQueryOptions = <TData = Awaited<ReturnType<typeof listJobs>>, TError = unknown>(params?: MaybeRefOrGetter<ListJobsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobs>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListJobsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listJobs>>> = ({ signal }) => listJobs(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listJobs>>, TError, TData>
}

export type ListJobsQueryResult = NonNullable<Awaited<ReturnType<typeof listJobs>>>
export type ListJobsQueryError = unknown


/**
 * @summary List all jobs for the current company
 */

export function useListJobs<TData = Awaited<ReturnType<typeof listJobs>>, TError = unknown>(
 params?: MaybeRefOrGetter<ListJobsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobs>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListJobsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getCreateJobUrl = () => {




  return `/employer/job`
}

/**
 * @summary Create a Job post
 */
export const createJob = async (createJobCommandDto?: CreateJobCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<number> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<number>(getCreateJobUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createJobCommandDto)
  }
);}





export const getCreateJobMutationKey = () => ['createJob'] as const;

export const getCreateJobMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createJob>>, TError,CreateJobMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof createJob>>, TError,CreateJobMutationVariables, TContext> => {

const mutationKey = getCreateJobMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createJob>>, CreateJobMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createJob(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateJobMutationResult = NonNullable<Awaited<ReturnType<typeof createJob>>>
    export type CreateJobMutationBody = CreateJobCommandDto | undefined
    export type CreateJobMutationError = ProblemDetails
    export type CreateJobMutationVariables = {data?: CreateJobCommandDto}

    /**
 * @summary Create a Job post
 */
export const useCreateJob = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createJob>>, TError,CreateJobMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createJob>>,
        TError,
        CreateJobMutationVariables,
        TContext
      > => {
      return useMutation(getCreateJobMutationOptions(options), queryClient);
    }

export const getUpdateJobUrl = () => {




  return `/employer/job`
}

/**
 * @summary Update a job
 */
export const updateJob = async (updateJobCommandDto?: UpdateJobCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<number> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<number>(getUpdateJobUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateJobCommandDto)
  }
);}





export const getUpdateJobMutationKey = () => ['updateJob'] as const;

export const getUpdateJobMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJob>>, TError,UpdateJobMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateJob>>, TError,UpdateJobMutationVariables, TContext> => {

const mutationKey = getUpdateJobMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateJob>>, UpdateJobMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateJob(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateJobMutationResult = NonNullable<Awaited<ReturnType<typeof updateJob>>>
    export type UpdateJobMutationBody = UpdateJobCommandDto | undefined
    export type UpdateJobMutationError = ProblemDetails
    export type UpdateJobMutationVariables = {data?: UpdateJobCommandDto}

    /**
 * @summary Update a job
 */
export const useUpdateJob = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJob>>, TError,UpdateJobMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateJob>>,
        TError,
        UpdateJobMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateJobMutationOptions(options), queryClient);
    }

export const getGetJobUrl = (id: number,) => {




  return `/employer/job/${id}`
}

export const getJob = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetJobResult> => {

  return fetchWithAuth<GetJobResult>(getGetJobUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetJobQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'employer','job',id
    ] as const;
    }


export const getGetJobQueryOptions = <TData = Awaited<ReturnType<typeof getJob>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetJobQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJob>>> = ({ signal }) => getJob(toValue(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData>
}

export type GetJobQueryResult = NonNullable<Awaited<ReturnType<typeof getJob>>>
export type GetJobQueryError = ProblemDetails



export function useGetJob<TData = Awaited<ReturnType<typeof getJob>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getRepublishJobUrl = () => {




  return `/employer/job/republish`
}

/**
 * @summary Republish a Job post
 */
export const republishJob = async (republishJobCommandDto?: RepublishJobCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<number> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<number>(getRepublishJobUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(republishJobCommandDto)
  }
);}





export const getRepublishJobMutationKey = () => ['republishJob'] as const;

export const getRepublishJobMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof republishJob>>, TError,RepublishJobMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof republishJob>>, TError,RepublishJobMutationVariables, TContext> => {

const mutationKey = getRepublishJobMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof republishJob>>, RepublishJobMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  republishJob(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RepublishJobMutationResult = NonNullable<Awaited<ReturnType<typeof republishJob>>>
    export type RepublishJobMutationBody = RepublishJobCommandDto | undefined
    export type RepublishJobMutationError = ProblemDetails
    export type RepublishJobMutationVariables = {data?: RepublishJobCommandDto}

    /**
 * @summary Republish a Job post
 */
export const useRepublishJob = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof republishJob>>, TError,RepublishJobMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof republishJob>>,
        TError,
        RepublishJobMutationVariables,
        TContext
      > => {
      return useMutation(getRepublishJobMutationOptions(options), queryClient);
    }

export const getUpdateJobPublishedUrl = () => {




  return `/employer/job/update-published`
}

/**
 * @summary Update the published status of a job
 */
export const updateJobPublished = async (updateJobPublishedCommandDto?: UpdateJobPublishedCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<UpdateJobPublishedResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<UpdateJobPublishedResult>(getUpdateJobPublishedUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateJobPublishedCommandDto)
  }
);}





export const getUpdateJobPublishedMutationKey = () => ['updateJobPublished'] as const;

export const getUpdateJobPublishedMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJobPublished>>, TError,UpdateJobPublishedMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateJobPublished>>, TError,UpdateJobPublishedMutationVariables, TContext> => {

const mutationKey = getUpdateJobPublishedMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateJobPublished>>, UpdateJobPublishedMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateJobPublished(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateJobPublishedMutationResult = NonNullable<Awaited<ReturnType<typeof updateJobPublished>>>
    export type UpdateJobPublishedMutationBody = UpdateJobPublishedCommandDto | undefined
    export type UpdateJobPublishedMutationError = ProblemDetails
    export type UpdateJobPublishedMutationVariables = {data?: UpdateJobPublishedCommandDto}

    /**
 * @summary Update the published status of a job
 */
export const useUpdateJobPublished = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJobPublished>>, TError,UpdateJobPublishedMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateJobPublished>>,
        TError,
        UpdateJobPublishedMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateJobPublishedMutationOptions(options), queryClient);
    }

export const getUpdateJobCandidatePoolUrl = () => {




  return `/employer/job/update-candidate-pool`
}

/**
 * @summary Update the candidate pool size for a job
 */
export const updateJobCandidatePool = async (updateJobCandidatePoolCommandDto?: UpdateJobCandidatePoolCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<Unit>(getUpdateJobCandidatePoolUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateJobCandidatePoolCommandDto)
  }
);}





export const getUpdateJobCandidatePoolMutationKey = () => ['updateJobCandidatePool'] as const;

export const getUpdateJobCandidatePoolMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJobCandidatePool>>, TError,UpdateJobCandidatePoolMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateJobCandidatePool>>, TError,UpdateJobCandidatePoolMutationVariables, TContext> => {

const mutationKey = getUpdateJobCandidatePoolMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateJobCandidatePool>>, UpdateJobCandidatePoolMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateJobCandidatePool(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateJobCandidatePoolMutationResult = NonNullable<Awaited<ReturnType<typeof updateJobCandidatePool>>>
    export type UpdateJobCandidatePoolMutationBody = UpdateJobCandidatePoolCommandDto | undefined
    export type UpdateJobCandidatePoolMutationError = ProblemDetails
    export type UpdateJobCandidatePoolMutationVariables = {data?: UpdateJobCandidatePoolCommandDto}

    /**
 * @summary Update the candidate pool size for a job
 */
export const useUpdateJobCandidatePool = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJobCandidatePool>>, TError,UpdateJobCandidatePoolMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateJobCandidatePool>>,
        TError,
        UpdateJobCandidatePoolMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateJobCandidatePoolMutationOptions(options), queryClient);
    }

export const getCloseJobUrl = () => {




  return `/employer/job/close`
}

/**
 * @summary Close a Job, this will make it unavailable for new matches
 */
export const closeJob = async (closeJobCommandDto?: CloseJobCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<void>(getCloseJobUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(closeJobCommandDto)
  }
);}





export const getCloseJobMutationKey = () => ['closeJob'] as const;

export const getCloseJobMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeJob>>, TError,CloseJobMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof closeJob>>, TError,CloseJobMutationVariables, TContext> => {

const mutationKey = getCloseJobMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closeJob>>, CloseJobMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  closeJob(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CloseJobMutationResult = NonNullable<Awaited<ReturnType<typeof closeJob>>>
    export type CloseJobMutationBody = CloseJobCommandDto | undefined
    export type CloseJobMutationError = ProblemDetails
    export type CloseJobMutationVariables = {data?: CloseJobCommandDto}

    /**
 * @summary Close a Job, this will make it unavailable for new matches
 */
export const useCloseJob = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeJob>>, TError,CloseJobMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof closeJob>>,
        TError,
        CloseJobMutationVariables,
        TContext
      > => {
      return useMutation(getCloseJobMutationOptions(options), queryClient);
    }

export const getFindBestCandidateUrl = (jobId: number,) => {




  return `/employer/job/${jobId}/find-best-candidate`
}

/**
 * @summary Find the best candidate for the specified job
 */
export const findBestCandidate = async (jobId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<FindBestCandidateResult> => {

  return fetchWithAuth<FindBestCandidateResult>(getFindBestCandidateUrl(jobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindBestCandidateQueryKey = (jobId: MaybeRefOrGetter<number>,) => {
    return [
    'employer','job',jobId,'find-best-candidate'
    ] as const;
    }


export const getFindBestCandidateQueryOptions = <TData = Awaited<ReturnType<typeof findBestCandidate>>, TError = ProblemDetails>(jobId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findBestCandidate>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getFindBestCandidateQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findBestCandidate>>> = ({ signal }) => findBestCandidate(toValue(jobId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(jobId) !== null && toValue(jobId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findBestCandidate>>, TError, TData>
}

export type FindBestCandidateQueryResult = NonNullable<Awaited<ReturnType<typeof findBestCandidate>>>
export type FindBestCandidateQueryError = ProblemDetails


/**
 * @summary Find the best candidate for the specified job
 */

export function useFindBestCandidate<TData = Awaited<ReturnType<typeof findBestCandidate>>, TError = ProblemDetails>(
 jobId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findBestCandidate>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindBestCandidateQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getReactToBestCandidateUrl = () => {




  return `/employer/job/react-best-candidate`
}

/**
 * @summary An employer reacts to the best found candidate.
The employee will get notified that the Employer is interested in the Employee's profile.
 */
export const reactToBestCandidate = async (reactToCandidateCommandDto?: ReactToCandidateCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ReactToCandidateResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<ReactToCandidateResult>(getReactToBestCandidateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reactToCandidateCommandDto)
  }
);}





export const getReactToBestCandidateMutationKey = () => ['reactToBestCandidate'] as const;

export const getReactToBestCandidateMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactToBestCandidate>>, TError,ReactToBestCandidateMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof reactToBestCandidate>>, TError,ReactToBestCandidateMutationVariables, TContext> => {

const mutationKey = getReactToBestCandidateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reactToBestCandidate>>, ReactToBestCandidateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  reactToBestCandidate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReactToBestCandidateMutationResult = NonNullable<Awaited<ReturnType<typeof reactToBestCandidate>>>
    export type ReactToBestCandidateMutationBody = ReactToCandidateCommandDto | undefined
    export type ReactToBestCandidateMutationError = ProblemDetails
    export type ReactToBestCandidateMutationVariables = {data?: ReactToCandidateCommandDto}

    /**
 * @summary An employer reacts to the best found candidate.
The employee will get notified that the Employer is interested in the Employee's profile.
 */
export const useReactToBestCandidate = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactToBestCandidate>>, TError,ReactToBestCandidateMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof reactToBestCandidate>>,
        TError,
        ReactToBestCandidateMutationVariables,
        TContext
      > => {
      return useMutation(getReactToBestCandidateMutationOptions(options), queryClient);
    }

export const getGetJobNotificationSettingsUrl = (jobId: number,) => {




  return `/employer/job/${jobId}/notification-settings`
}

/**
 * @summary Get notification settings for a job, showing all teammates and their current subscription status
 */
export const getJobNotificationSettings = async (jobId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetJobNotificationSettingsResult> => {

  return fetchWithAuth<GetJobNotificationSettingsResult>(getGetJobNotificationSettingsUrl(jobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetJobNotificationSettingsQueryKey = (jobId: MaybeRefOrGetter<number>,) => {
    return [
    'employer','job',jobId,'notification-settings'
    ] as const;
    }


export const getGetJobNotificationSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getJobNotificationSettings>>, TError = ProblemDetails>(jobId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobNotificationSettings>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetJobNotificationSettingsQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobNotificationSettings>>> = ({ signal }) => getJobNotificationSettings(toValue(jobId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(jobId) !== null && toValue(jobId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobNotificationSettings>>, TError, TData>
}

export type GetJobNotificationSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getJobNotificationSettings>>>
export type GetJobNotificationSettingsQueryError = ProblemDetails


/**
 * @summary Get notification settings for a job, showing all teammates and their current subscription status
 */

export function useGetJobNotificationSettings<TData = Awaited<ReturnType<typeof getJobNotificationSettings>>, TError = ProblemDetails>(
 jobId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobNotificationSettings>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobNotificationSettingsQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetCompanyJobsNotificationSettingsUrl = () => {




  return `/employer/job/notification-settings`
}

/**
 * @summary Get the notification settings for all (non-closed) jobs of the current company, including the teammates that can be subscribed
 */
export const getCompanyJobsNotificationSettings = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetCompanyJobsNotificationSettingsResult> => {

  return fetchWithAuth<GetCompanyJobsNotificationSettingsResult>(getGetCompanyJobsNotificationSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCompanyJobsNotificationSettingsQueryKey = () => {
    return [
    'employer','job','notification-settings'
    ] as const;
    }


export const getGetCompanyJobsNotificationSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyJobsNotificationSettings>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyJobsNotificationSettings>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetCompanyJobsNotificationSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyJobsNotificationSettings>>> = ({ signal }) => getCompanyJobsNotificationSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyJobsNotificationSettings>>, TError, TData>
}

export type GetCompanyJobsNotificationSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyJobsNotificationSettings>>>
export type GetCompanyJobsNotificationSettingsQueryError = ProblemDetails


/**
 * @summary Get the notification settings for all (non-closed) jobs of the current company, including the teammates that can be subscribed
 */

export function useGetCompanyJobsNotificationSettings<TData = Awaited<ReturnType<typeof getCompanyJobsNotificationSettings>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyJobsNotificationSettings>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyJobsNotificationSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getUpdateJobNotificationSettingsUrl = () => {




  return `/employer/job/notification-settings`
}

/**
 * @summary Update notification settings for a job, setting which teammates should receive notifications
 */
export const updateJobNotificationSettings = async (updateJobNotificationSettingsCommandDto?: UpdateJobNotificationSettingsCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<void>(getUpdateJobNotificationSettingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateJobNotificationSettingsCommandDto)
  }
);}





export const getUpdateJobNotificationSettingsMutationKey = () => ['updateJobNotificationSettings'] as const;

export const getUpdateJobNotificationSettingsMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJobNotificationSettings>>, TError,UpdateJobNotificationSettingsMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateJobNotificationSettings>>, TError,UpdateJobNotificationSettingsMutationVariables, TContext> => {

const mutationKey = getUpdateJobNotificationSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateJobNotificationSettings>>, UpdateJobNotificationSettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateJobNotificationSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateJobNotificationSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateJobNotificationSettings>>>
    export type UpdateJobNotificationSettingsMutationBody = UpdateJobNotificationSettingsCommandDto | undefined
    export type UpdateJobNotificationSettingsMutationError = ProblemDetails
    export type UpdateJobNotificationSettingsMutationVariables = {data?: UpdateJobNotificationSettingsCommandDto}

    /**
 * @summary Update notification settings for a job, setting which teammates should receive notifications
 */
export const useUpdateJobNotificationSettings = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJobNotificationSettings>>, TError,UpdateJobNotificationSettingsMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateJobNotificationSettings>>,
        TError,
        UpdateJobNotificationSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateJobNotificationSettingsMutationOptions(options), queryClient);
    }

export const getUpdateJobsNotificationSettingsUrl = () => {




  return `/employer/job/notification-settings/bulk`
}

/**
 * @summary Update notification settings for multiple jobs at once, replacing the subscribed teammates of each job
 */
export const updateJobsNotificationSettings = async (updateJobsNotificationSettingsCommandDto?: UpdateJobsNotificationSettingsCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<void>(getUpdateJobsNotificationSettingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateJobsNotificationSettingsCommandDto)
  }
);}





export const getUpdateJobsNotificationSettingsMutationKey = () => ['updateJobsNotificationSettings'] as const;

export const getUpdateJobsNotificationSettingsMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJobsNotificationSettings>>, TError,UpdateJobsNotificationSettingsMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateJobsNotificationSettings>>, TError,UpdateJobsNotificationSettingsMutationVariables, TContext> => {

const mutationKey = getUpdateJobsNotificationSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateJobsNotificationSettings>>, UpdateJobsNotificationSettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateJobsNotificationSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateJobsNotificationSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateJobsNotificationSettings>>>
    export type UpdateJobsNotificationSettingsMutationBody = UpdateJobsNotificationSettingsCommandDto | undefined
    export type UpdateJobsNotificationSettingsMutationError = ProblemDetails
    export type UpdateJobsNotificationSettingsMutationVariables = {data?: UpdateJobsNotificationSettingsCommandDto}

    /**
 * @summary Update notification settings for multiple jobs at once, replacing the subscribed teammates of each job
 */
export const useUpdateJobsNotificationSettings = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJobsNotificationSettings>>, TError,UpdateJobsNotificationSettingsMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateJobsNotificationSettings>>,
        TError,
        UpdateJobsNotificationSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateJobsNotificationSettingsMutationOptions(options), queryClient);
    }

export const getGetJobApplicationUrl = (jobApplicationId: number,) => {




  return `/employer/job-application/${jobApplicationId}`
}

/**
 * @summary Get a specific job application
 */
export const getJobApplication = async (jobApplicationId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetJobApplicationResult> => {

  return fetchWithAuth<GetJobApplicationResult>(getGetJobApplicationUrl(jobApplicationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetJobApplicationQueryKey = (jobApplicationId: MaybeRefOrGetter<number>,) => {
    return [
    'employer','job-application',jobApplicationId
    ] as const;
    }


export const getGetJobApplicationQueryOptions = <TData = Awaited<ReturnType<typeof getJobApplication>>, TError = ProblemDetails>(jobApplicationId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobApplication>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetJobApplicationQueryKey(jobApplicationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobApplication>>> = ({ signal }) => getJobApplication(toValue(jobApplicationId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(jobApplicationId) !== null && toValue(jobApplicationId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobApplication>>, TError, TData>
}

export type GetJobApplicationQueryResult = NonNullable<Awaited<ReturnType<typeof getJobApplication>>>
export type GetJobApplicationQueryError = ProblemDetails


/**
 * @summary Get a specific job application
 */

export function useGetJobApplication<TData = Awaited<ReturnType<typeof getJobApplication>>, TError = ProblemDetails>(
 jobApplicationId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobApplication>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobApplicationQueryOptions(jobApplicationId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetJobApplicationTabCountsUrl = (params?: GetJobApplicationTabCountsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/employer/job-application/tab-counts?${stringifiedParams}` : `/employer/job-application/tab-counts`
}

/**
 * @summary Get the applicant-overview tab badge counts (To review / Matches) plus whether the Rejected tab has
any applications from the last 7 days, for the current company.
 */
export const getJobApplicationTabCounts = async (params?: GetJobApplicationTabCountsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetJobApplicationTabCountsResult> => {

  return fetchWithAuth<GetJobApplicationTabCountsResult>(getGetJobApplicationTabCountsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetJobApplicationTabCountsQueryKey = (params?: MaybeRefOrGetter<GetJobApplicationTabCountsParams>,) => {
    return [
    'employer','job-application','tab-counts', ...(params ? [params] : [])
    ] as const;
    }


export const getGetJobApplicationTabCountsQueryOptions = <TData = Awaited<ReturnType<typeof getJobApplicationTabCounts>>, TError = unknown>(params?: MaybeRefOrGetter<GetJobApplicationTabCountsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobApplicationTabCounts>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetJobApplicationTabCountsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobApplicationTabCounts>>> = ({ signal }) => getJobApplicationTabCounts(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobApplicationTabCounts>>, TError, TData>
}

export type GetJobApplicationTabCountsQueryResult = NonNullable<Awaited<ReturnType<typeof getJobApplicationTabCounts>>>
export type GetJobApplicationTabCountsQueryError = unknown


/**
 * @summary Get the applicant-overview tab badge counts (To review / Matches) plus whether the Rejected tab has
any applications from the last 7 days, for the current company.
 */

export function useGetJobApplicationTabCounts<TData = Awaited<ReturnType<typeof getJobApplicationTabCounts>>, TError = unknown>(
 params?: MaybeRefOrGetter<GetJobApplicationTabCountsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobApplicationTabCounts>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobApplicationTabCountsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListJobApplicationCandidatesUrl = (params?: ListJobApplicationCandidatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/employer/job-application/candidates?${stringifiedParams}` : `/employer/job-application/candidates`
}

/**
 * @summary List Candidates (grouped by their full JobApplication history at the company) for one applicant-overview tab.
 */
export const listJobApplicationCandidates = async (params?: ListJobApplicationCandidatesParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListJobApplicationCandidatesResult> => {

  return fetchWithAuth<ListJobApplicationCandidatesResult>(getListJobApplicationCandidatesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListJobApplicationCandidatesQueryKey = (params?: MaybeRefOrGetter<ListJobApplicationCandidatesParams>,) => {
    return [
    'employer','job-application','candidates', ...(params ? [params] : [])
    ] as const;
    }


export const getListJobApplicationCandidatesQueryOptions = <TData = Awaited<ReturnType<typeof listJobApplicationCandidates>>, TError = unknown>(params?: MaybeRefOrGetter<ListJobApplicationCandidatesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobApplicationCandidates>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListJobApplicationCandidatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listJobApplicationCandidates>>> = ({ signal }) => listJobApplicationCandidates(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listJobApplicationCandidates>>, TError, TData>
}

export type ListJobApplicationCandidatesQueryResult = NonNullable<Awaited<ReturnType<typeof listJobApplicationCandidates>>>
export type ListJobApplicationCandidatesQueryError = unknown


/**
 * @summary List Candidates (grouped by their full JobApplication history at the company) for one applicant-overview tab.
 */

export function useListJobApplicationCandidates<TData = Awaited<ReturnType<typeof listJobApplicationCandidates>>, TError = unknown>(
 params?: MaybeRefOrGetter<ListJobApplicationCandidatesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobApplicationCandidates>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListJobApplicationCandidatesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListJobApplicationRejectionReasonsUrl = () => {




  return `/employer/job-application/rejection-reasons`
}

/**
 * @summary List all rejection reasons for job applications of a company.
 */
export const listJobApplicationRejectionReasons = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListJobApplicationRejectionReasonsResult> => {

  return fetchWithAuth<ListJobApplicationRejectionReasonsResult>(getListJobApplicationRejectionReasonsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListJobApplicationRejectionReasonsQueryKey = () => {
    return [
    'employer','job-application','rejection-reasons'
    ] as const;
    }


export const getListJobApplicationRejectionReasonsQueryOptions = <TData = Awaited<ReturnType<typeof listJobApplicationRejectionReasons>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobApplicationRejectionReasons>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListJobApplicationRejectionReasonsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listJobApplicationRejectionReasons>>> = ({ signal }) => listJobApplicationRejectionReasons({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listJobApplicationRejectionReasons>>, TError, TData>
}

export type ListJobApplicationRejectionReasonsQueryResult = NonNullable<Awaited<ReturnType<typeof listJobApplicationRejectionReasons>>>
export type ListJobApplicationRejectionReasonsQueryError = unknown


/**
 * @summary List all rejection reasons for job applications of a company.
 */

export function useListJobApplicationRejectionReasons<TData = Awaited<ReturnType<typeof listJobApplicationRejectionReasons>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobApplicationRejectionReasons>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListJobApplicationRejectionReasonsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getRejectJobApplicationUrl = () => {




  return `/employer/job-application/reject`
}

/**
 * @summary An employer rejects a job application
 */
export const rejectJobApplication = async (rejectJobApplicationCommandDto?: RejectJobApplicationCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<RejectJobApplicationResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<RejectJobApplicationResult>(getRejectJobApplicationUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(rejectJobApplicationCommandDto)
  }
);}





export const getRejectJobApplicationMutationKey = () => ['rejectJobApplication'] as const;

export const getRejectJobApplicationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectJobApplication>>, TError,RejectJobApplicationMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectJobApplication>>, TError,RejectJobApplicationMutationVariables, TContext> => {

const mutationKey = getRejectJobApplicationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectJobApplication>>, RejectJobApplicationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  rejectJobApplication(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectJobApplicationMutationResult = NonNullable<Awaited<ReturnType<typeof rejectJobApplication>>>
    export type RejectJobApplicationMutationBody = RejectJobApplicationCommandDto | undefined
    export type RejectJobApplicationMutationError = ProblemDetails
    export type RejectJobApplicationMutationVariables = {data?: RejectJobApplicationCommandDto}

    /**
 * @summary An employer rejects a job application
 */
export const useRejectJobApplication = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectJobApplication>>, TError,RejectJobApplicationMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof rejectJobApplication>>,
        TError,
        RejectJobApplicationMutationVariables,
        TContext
      > => {
      return useMutation(getRejectJobApplicationMutationOptions(options), queryClient);
    }

export const getStartMatchUrl = () => {




  return `/employer/job-application/start-match`
}

/**
 * @summary An employer starts a match for a job application
 */
export const startMatch = async (startMatchCommandDto?: StartMatchCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<StartMatchResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<StartMatchResult>(getStartMatchUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(startMatchCommandDto)
  }
);}





export const getStartMatchMutationKey = () => ['startMatch'] as const;

export const getStartMatchMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startMatch>>, TError,StartMatchMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof startMatch>>, TError,StartMatchMutationVariables, TContext> => {

const mutationKey = getStartMatchMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startMatch>>, StartMatchMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  startMatch(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartMatchMutationResult = NonNullable<Awaited<ReturnType<typeof startMatch>>>
    export type StartMatchMutationBody = StartMatchCommandDto | undefined
    export type StartMatchMutationError = ProblemDetails
    export type StartMatchMutationVariables = {data?: StartMatchCommandDto}

    /**
 * @summary An employer starts a match for a job application
 */
export const useStartMatch = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startMatch>>, TError,StartMatchMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof startMatch>>,
        TError,
        StartMatchMutationVariables,
        TContext
      > => {
      return useMutation(getStartMatchMutationOptions(options), queryClient);
    }

export const getSendCompleteProfileRequestUrl = () => {




  return `/employer/job-application/complete-profile-request`
}

/**
 * @summary Send a Complete Profile Request to the anonymous user.
 */
export const sendCompleteProfileRequest = async (sendCompleteProfileRequestCommandDto?: SendCompleteProfileRequestCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<void>(getSendCompleteProfileRequestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(sendCompleteProfileRequestCommandDto)
  }
);}





export const getSendCompleteProfileRequestMutationKey = () => ['sendCompleteProfileRequest'] as const;

export const getSendCompleteProfileRequestMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendCompleteProfileRequest>>, TError,SendCompleteProfileRequestMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof sendCompleteProfileRequest>>, TError,SendCompleteProfileRequestMutationVariables, TContext> => {

const mutationKey = getSendCompleteProfileRequestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendCompleteProfileRequest>>, SendCompleteProfileRequestMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  sendCompleteProfileRequest(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendCompleteProfileRequestMutationResult = NonNullable<Awaited<ReturnType<typeof sendCompleteProfileRequest>>>
    export type SendCompleteProfileRequestMutationBody = SendCompleteProfileRequestCommandDto | undefined
    export type SendCompleteProfileRequestMutationError = ProblemDetails
    export type SendCompleteProfileRequestMutationVariables = {data?: SendCompleteProfileRequestCommandDto}

    /**
 * @summary Send a Complete Profile Request to the anonymous user.
 */
export const useSendCompleteProfileRequest = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendCompleteProfileRequest>>, TError,SendCompleteProfileRequestMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sendCompleteProfileRequest>>,
        TError,
        SendCompleteProfileRequestMutationVariables,
        TContext
      > => {
      return useMutation(getSendCompleteProfileRequestMutationOptions(options), queryClient);
    }

export const getBuyCreditsUrl = () => {




  return `/employer/invoice/credits`
}

export const buyCredits = async (buyCreditsCommandDto?: BuyCreditsCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<void>(getBuyCreditsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(buyCreditsCommandDto)
  }
);}





export const getBuyCreditsMutationKey = () => ['buyCredits'] as const;

export const getBuyCreditsMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof buyCredits>>, TError,BuyCreditsMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof buyCredits>>, TError,BuyCreditsMutationVariables, TContext> => {

const mutationKey = getBuyCreditsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof buyCredits>>, BuyCreditsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  buyCredits(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BuyCreditsMutationResult = NonNullable<Awaited<ReturnType<typeof buyCredits>>>
    export type BuyCreditsMutationBody = BuyCreditsCommandDto | undefined
    export type BuyCreditsMutationError = ProblemDetails
    export type BuyCreditsMutationVariables = {data?: BuyCreditsCommandDto}

    export const useBuyCredits = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof buyCredits>>, TError,BuyCreditsMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof buyCredits>>,
        TError,
        BuyCreditsMutationVariables,
        TContext
      > => {
      return useMutation(getBuyCreditsMutationOptions(options), queryClient);
    }

export const getListCreditTransactionsUrl = () => {




  return `/employer/invoice/credits`
}

export const listCreditTransactions = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListCreditTransactionsResult> => {

  return fetchWithAuth<ListCreditTransactionsResult>(getListCreditTransactionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCreditTransactionsQueryKey = () => {
    return [
    'employer','invoice','credits'
    ] as const;
    }


export const getListCreditTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof listCreditTransactions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCreditTransactions>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListCreditTransactionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCreditTransactions>>> = ({ signal }) => listCreditTransactions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCreditTransactions>>, TError, TData>
}

export type ListCreditTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof listCreditTransactions>>>
export type ListCreditTransactionsQueryError = unknown



export function useListCreditTransactions<TData = Awaited<ReturnType<typeof listCreditTransactions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCreditTransactions>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCreditTransactionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetSubscriptionUrl = () => {




  return `/employer/invoice/subscription`
}

export const getSubscription = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetSubscriptionResult> => {

  return fetchWithAuth<GetSubscriptionResult>(getGetSubscriptionUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSubscriptionQueryKey = () => {
    return [
    'employer','invoice','subscription'
    ] as const;
    }


export const getGetSubscriptionQueryOptions = <TData = Awaited<ReturnType<typeof getSubscription>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetSubscriptionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscription>>> = ({ signal }) => getSubscription({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData>
}

export type GetSubscriptionQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscription>>>
export type GetSubscriptionQueryError = unknown



export function useGetSubscription<TData = Awaited<ReturnType<typeof getSubscription>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSubscriptionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListCompanySubscriptionsUrl = () => {




  return `/employer/invoice/subscriptions`
}

export const listCompanySubscriptions = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListCompanySubscriptionsResult> => {

  return fetchWithAuth<ListCompanySubscriptionsResult>(getListCompanySubscriptionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCompanySubscriptionsQueryKey = () => {
    return [
    'employer','invoice','subscriptions'
    ] as const;
    }


export const getListCompanySubscriptionsQueryOptions = <TData = Awaited<ReturnType<typeof listCompanySubscriptions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCompanySubscriptions>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListCompanySubscriptionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCompanySubscriptions>>> = ({ signal }) => listCompanySubscriptions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCompanySubscriptions>>, TError, TData>
}

export type ListCompanySubscriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof listCompanySubscriptions>>>
export type ListCompanySubscriptionsQueryError = unknown



export function useListCompanySubscriptions<TData = Awaited<ReturnType<typeof listCompanySubscriptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCompanySubscriptions>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCompanySubscriptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListInvoicesForCompanyUrl = () => {




  return `/employer/invoice`
}

export const listInvoicesForCompany = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListInvoicesForCompanyResult> => {

  return fetchWithAuth<ListInvoicesForCompanyResult>(getListInvoicesForCompanyUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInvoicesForCompanyQueryKey = () => {
    return [
    'employer','invoice'
    ] as const;
    }


export const getListInvoicesForCompanyQueryOptions = <TData = Awaited<ReturnType<typeof listInvoicesForCompany>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvoicesForCompany>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListInvoicesForCompanyQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInvoicesForCompany>>> = ({ signal }) => listInvoicesForCompany({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInvoicesForCompany>>, TError, TData>
}

export type ListInvoicesForCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof listInvoicesForCompany>>>
export type ListInvoicesForCompanyQueryError = unknown



export function useListInvoicesForCompany<TData = Awaited<ReturnType<typeof listInvoicesForCompany>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvoicesForCompany>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInvoicesForCompanyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListCreditNotesForCompanyUrl = () => {




  return `/employer/invoice/credit-notes`
}

export const listCreditNotesForCompany = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListCreditNotesForCompanyResult> => {

  return fetchWithAuth<ListCreditNotesForCompanyResult>(getListCreditNotesForCompanyUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCreditNotesForCompanyQueryKey = () => {
    return [
    'employer','invoice','credit-notes'
    ] as const;
    }


export const getListCreditNotesForCompanyQueryOptions = <TData = Awaited<ReturnType<typeof listCreditNotesForCompany>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCreditNotesForCompany>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListCreditNotesForCompanyQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCreditNotesForCompany>>> = ({ signal }) => listCreditNotesForCompany({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCreditNotesForCompany>>, TError, TData>
}

export type ListCreditNotesForCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof listCreditNotesForCompany>>>
export type ListCreditNotesForCompanyQueryError = unknown



export function useListCreditNotesForCompany<TData = Awaited<ReturnType<typeof listCreditNotesForCompany>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCreditNotesForCompany>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCreditNotesForCompanyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetInvoiceFileUrlUrl = (fileId: string,) => {




  return `/employer/invoice/${fileId}`
}

export const getInvoiceFileUrl = async (fileId: string, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetInvoiceFileUrlResult> => {

  return fetchWithAuth<GetInvoiceFileUrlResult>(getGetInvoiceFileUrlUrl(fileId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInvoiceFileUrlQueryKey = (fileId: MaybeRefOrGetter<string>,) => {
    return [
    'employer','invoice',fileId
    ] as const;
    }


export const getGetInvoiceFileUrlQueryOptions = <TData = Awaited<ReturnType<typeof getInvoiceFileUrl>>, TError = unknown>(fileId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoiceFileUrl>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetInvoiceFileUrlQueryKey(fileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoiceFileUrl>>> = ({ signal }) => getInvoiceFileUrl(toValue(fileId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(fileId) !== null && toValue(fileId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoiceFileUrl>>, TError, TData>
}

export type GetInvoiceFileUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoiceFileUrl>>>
export type GetInvoiceFileUrlQueryError = unknown



export function useGetInvoiceFileUrl<TData = Awaited<ReturnType<typeof getInvoiceFileUrl>>, TError = unknown>(
 fileId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoiceFileUrl>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvoiceFileUrlQueryOptions(fileId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetCreditNoteFileUrlUrl = (creditNoteId: string,) => {




  return `/employer/invoice/credit-notes/${creditNoteId}`
}

export const getCreditNoteFileUrl = async (creditNoteId: string, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetCreditNoteFileUrlResult> => {

  return fetchWithAuth<GetCreditNoteFileUrlResult>(getGetCreditNoteFileUrlUrl(creditNoteId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCreditNoteFileUrlQueryKey = (creditNoteId: MaybeRefOrGetter<string>,) => {
    return [
    'employer','invoice','credit-notes',creditNoteId
    ] as const;
    }


export const getGetCreditNoteFileUrlQueryOptions = <TData = Awaited<ReturnType<typeof getCreditNoteFileUrl>>, TError = unknown>(creditNoteId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditNoteFileUrl>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetCreditNoteFileUrlQueryKey(creditNoteId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCreditNoteFileUrl>>> = ({ signal }) => getCreditNoteFileUrl(toValue(creditNoteId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(creditNoteId) !== null && toValue(creditNoteId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCreditNoteFileUrl>>, TError, TData>
}

export type GetCreditNoteFileUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getCreditNoteFileUrl>>>
export type GetCreditNoteFileUrlQueryError = unknown



export function useGetCreditNoteFileUrl<TData = Awaited<ReturnType<typeof getCreditNoteFileUrl>>, TError = unknown>(
 creditNoteId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditNoteFileUrl>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCreditNoteFileUrlQueryOptions(creditNoteId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListIntegrationsUrl = () => {




  return `/employer/integration`
}

export const listIntegrations = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListIntegrationsResult> => {

  return fetchWithAuth<ListIntegrationsResult>(getListIntegrationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListIntegrationsQueryKey = () => {
    return [
    'employer','integration'
    ] as const;
    }


export const getListIntegrationsQueryOptions = <TData = Awaited<ReturnType<typeof listIntegrations>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIntegrations>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListIntegrationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listIntegrations>>> = ({ signal }) => listIntegrations({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listIntegrations>>, TError, TData>
}

export type ListIntegrationsQueryResult = NonNullable<Awaited<ReturnType<typeof listIntegrations>>>
export type ListIntegrationsQueryError = ProblemDetails



export function useListIntegrations<TData = Awaited<ReturnType<typeof listIntegrations>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIntegrations>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListIntegrationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getConnectCarerixIntegrationUrl = () => {




  return `/employer/carerix-connection`
}

export const connectCarerixIntegration = async (getOrCreateAtsIntegrationConnectionCommandDtoCarerixConnectionSecrets?: GetOrCreateAtsIntegrationConnectionCommandDtoCarerixConnectionSecrets, options?: Parameters<typeof fetchWithAuth>[1]): Promise<IntegrationConnectionDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<IntegrationConnectionDto>(getConnectCarerixIntegrationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getOrCreateAtsIntegrationConnectionCommandDtoCarerixConnectionSecrets)
  }
);}





export const getConnectCarerixIntegrationMutationKey = () => ['connectCarerixIntegration'] as const;

export const getConnectCarerixIntegrationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectCarerixIntegration>>, TError,ConnectCarerixIntegrationMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof connectCarerixIntegration>>, TError,ConnectCarerixIntegrationMutationVariables, TContext> => {

const mutationKey = getConnectCarerixIntegrationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof connectCarerixIntegration>>, ConnectCarerixIntegrationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  connectCarerixIntegration(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConnectCarerixIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof connectCarerixIntegration>>>
    export type ConnectCarerixIntegrationMutationBody = GetOrCreateAtsIntegrationConnectionCommandDtoCarerixConnectionSecrets | undefined
    export type ConnectCarerixIntegrationMutationError = ProblemDetails
    export type ConnectCarerixIntegrationMutationVariables = {data?: GetOrCreateAtsIntegrationConnectionCommandDtoCarerixConnectionSecrets}

    export const useConnectCarerixIntegration = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectCarerixIntegration>>, TError,ConnectCarerixIntegrationMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof connectCarerixIntegration>>,
        TError,
        ConnectCarerixIntegrationMutationVariables,
        TContext
      > => {
      return useMutation(getConnectCarerixIntegrationMutationOptions(options), queryClient);
    }

export const getUpdateCarerixConnectionUrl = (connectionId: number,) => {




  return `/employer/carerix-connection/carerix/${connectionId}`
}

export const updateCarerixConnection = async (connectionId: number,
    updateAtsIntegrationConnectionCommandDtoCarerixConnectionConfig?: UpdateAtsIntegrationConnectionCommandDtoCarerixConnectionConfig, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<Unit>(getUpdateCarerixConnectionUrl(connectionId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateAtsIntegrationConnectionCommandDtoCarerixConnectionConfig)
  }
);}





export const getUpdateCarerixConnectionMutationKey = () => ['updateCarerixConnection'] as const;

export const getUpdateCarerixConnectionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCarerixConnection>>, TError,UpdateCarerixConnectionMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCarerixConnection>>, TError,UpdateCarerixConnectionMutationVariables, TContext> => {

const mutationKey = getUpdateCarerixConnectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCarerixConnection>>, UpdateCarerixConnectionMutationVariables> = (props) => {
          const {connectionId,data} = props ?? {};

          return  updateCarerixConnection(connectionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCarerixConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof updateCarerixConnection>>>
    export type UpdateCarerixConnectionMutationBody = UpdateAtsIntegrationConnectionCommandDtoCarerixConnectionConfig | undefined
    export type UpdateCarerixConnectionMutationError = ProblemDetails
    export type UpdateCarerixConnectionMutationVariables = {connectionId: number;data?: UpdateAtsIntegrationConnectionCommandDtoCarerixConnectionConfig}

    export const useUpdateCarerixConnection = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCarerixConnection>>, TError,UpdateCarerixConnectionMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateCarerixConnection>>,
        TError,
        UpdateCarerixConnectionMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateCarerixConnectionMutationOptions(options), queryClient);
    }

export const getGetCarerixConnectionUrl = (connectionId: number,) => {




  return `/employer/carerix-connection/carerix/${connectionId}`
}

export const getCarerixConnection = async (connectionId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetAtsIntegrationConnectionResultCarerixConnectionConfig> => {

  return fetchWithAuth<GetAtsIntegrationConnectionResultCarerixConnectionConfig>(getGetCarerixConnectionUrl(connectionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCarerixConnectionQueryKey = (connectionId: MaybeRefOrGetter<number>,) => {
    return [
    'employer','carerix-connection','carerix',connectionId
    ] as const;
    }


export const getGetCarerixConnectionQueryOptions = <TData = Awaited<ReturnType<typeof getCarerixConnection>>, TError = ProblemDetails>(connectionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCarerixConnection>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetCarerixConnectionQueryKey(connectionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCarerixConnection>>> = ({ signal }) => getCarerixConnection(toValue(connectionId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(connectionId) !== null && toValue(connectionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCarerixConnection>>, TError, TData>
}

export type GetCarerixConnectionQueryResult = NonNullable<Awaited<ReturnType<typeof getCarerixConnection>>>
export type GetCarerixConnectionQueryError = ProblemDetails



export function useGetCarerixConnection<TData = Awaited<ReturnType<typeof getCarerixConnection>>, TError = ProblemDetails>(
 connectionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCarerixConnection>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCarerixConnectionQueryOptions(connectionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListCarerixStatusInfosUrl = (connectionId: number,) => {




  return `/employer/carerix-connection/carerix/${connectionId}/status-infos`
}

export const listCarerixStatusInfos = async (connectionId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListCarerixStatusInfosResult> => {

  return fetchWithAuth<ListCarerixStatusInfosResult>(getListCarerixStatusInfosUrl(connectionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCarerixStatusInfosQueryKey = (connectionId: MaybeRefOrGetter<number>,) => {
    return [
    'employer','carerix-connection','carerix',connectionId,'status-infos'
    ] as const;
    }


export const getListCarerixStatusInfosQueryOptions = <TData = Awaited<ReturnType<typeof listCarerixStatusInfos>>, TError = ProblemDetails>(connectionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCarerixStatusInfos>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListCarerixStatusInfosQueryKey(connectionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCarerixStatusInfos>>> = ({ signal }) => listCarerixStatusInfos(toValue(connectionId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(connectionId) !== null && toValue(connectionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCarerixStatusInfos>>, TError, TData>
}

export type ListCarerixStatusInfosQueryResult = NonNullable<Awaited<ReturnType<typeof listCarerixStatusInfos>>>
export type ListCarerixStatusInfosQueryError = ProblemDetails



export function useListCarerixStatusInfos<TData = Awaited<ReturnType<typeof listCarerixStatusInfos>>, TError = ProblemDetails>(
 connectionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCarerixStatusInfos>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCarerixStatusInfosQueryOptions(connectionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListCarerixSourceNodesUrl = (connectionId: number,) => {




  return `/employer/carerix-connection/carerix/${connectionId}/source-nodes`
}

export const listCarerixSourceNodes = async (connectionId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListCarerixSourceNodesResult> => {

  return fetchWithAuth<ListCarerixSourceNodesResult>(getListCarerixSourceNodesUrl(connectionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCarerixSourceNodesQueryKey = (connectionId: MaybeRefOrGetter<number>,) => {
    return [
    'employer','carerix-connection','carerix',connectionId,'source-nodes'
    ] as const;
    }


export const getListCarerixSourceNodesQueryOptions = <TData = Awaited<ReturnType<typeof listCarerixSourceNodes>>, TError = ProblemDetails>(connectionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCarerixSourceNodes>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListCarerixSourceNodesQueryKey(connectionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCarerixSourceNodes>>> = ({ signal }) => listCarerixSourceNodes(toValue(connectionId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(connectionId) !== null && toValue(connectionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCarerixSourceNodes>>, TError, TData>
}

export type ListCarerixSourceNodesQueryResult = NonNullable<Awaited<ReturnType<typeof listCarerixSourceNodes>>>
export type ListCarerixSourceNodesQueryError = ProblemDetails



export function useListCarerixSourceNodes<TData = Awaited<ReturnType<typeof listCarerixSourceNodes>>, TError = ProblemDetails>(
 connectionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCarerixSourceNodes>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCarerixSourceNodesQueryOptions(connectionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListCarerixOwnersUrl = (connectionId: number,) => {




  return `/employer/carerix-connection/carerix/${connectionId}/owners`
}

export const listCarerixOwners = async (connectionId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListCarerixOwnersResult> => {

  return fetchWithAuth<ListCarerixOwnersResult>(getListCarerixOwnersUrl(connectionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCarerixOwnersQueryKey = (connectionId: MaybeRefOrGetter<number>,) => {
    return [
    'employer','carerix-connection','carerix',connectionId,'owners'
    ] as const;
    }


export const getListCarerixOwnersQueryOptions = <TData = Awaited<ReturnType<typeof listCarerixOwners>>, TError = ProblemDetails>(connectionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCarerixOwners>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListCarerixOwnersQueryKey(connectionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCarerixOwners>>> = ({ signal }) => listCarerixOwners(toValue(connectionId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(connectionId) !== null && toValue(connectionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCarerixOwners>>, TError, TData>
}

export type ListCarerixOwnersQueryResult = NonNullable<Awaited<ReturnType<typeof listCarerixOwners>>>
export type ListCarerixOwnersQueryError = ProblemDetails



export function useListCarerixOwners<TData = Awaited<ReturnType<typeof listCarerixOwners>>, TError = ProblemDetails>(
 connectionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCarerixOwners>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCarerixOwnersQueryOptions(connectionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getUpdateCarerixJobMappingUrl = (connectionId: number,
    jobId: number,) => {




  return `/employer/carerix-connection/carerix/${connectionId}/job-mappings/${jobId}`
}

export const updateCarerixJobMapping = async (connectionId: number,
    jobId: number,
    updateCarerixJobMappingCommandDto?: UpdateCarerixJobMappingCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<Unit>(getUpdateCarerixJobMappingUrl(connectionId,jobId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateCarerixJobMappingCommandDto)
  }
);}





export const getUpdateCarerixJobMappingMutationKey = () => ['updateCarerixJobMapping'] as const;

export const getUpdateCarerixJobMappingMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCarerixJobMapping>>, TError,UpdateCarerixJobMappingMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCarerixJobMapping>>, TError,UpdateCarerixJobMappingMutationVariables, TContext> => {

const mutationKey = getUpdateCarerixJobMappingMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCarerixJobMapping>>, UpdateCarerixJobMappingMutationVariables> = (props) => {
          const {connectionId,jobId,data} = props ?? {};

          return  updateCarerixJobMapping(connectionId,jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCarerixJobMappingMutationResult = NonNullable<Awaited<ReturnType<typeof updateCarerixJobMapping>>>
    export type UpdateCarerixJobMappingMutationBody = UpdateCarerixJobMappingCommandDto | undefined
    export type UpdateCarerixJobMappingMutationError = ProblemDetails
    export type UpdateCarerixJobMappingMutationVariables = {connectionId: number;jobId: number;data?: UpdateCarerixJobMappingCommandDto}

    export const useUpdateCarerixJobMapping = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCarerixJobMapping>>, TError,UpdateCarerixJobMappingMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateCarerixJobMapping>>,
        TError,
        UpdateCarerixJobMappingMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateCarerixJobMappingMutationOptions(options), queryClient);
    }

export const getConnectHomerunIntegrationUrl = () => {




  return `/employer/homerun-connection`
}

export const connectHomerunIntegration = async (getOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecrets?: GetOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecrets, options?: Parameters<typeof fetchWithAuth>[1]): Promise<IntegrationConnectionDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<IntegrationConnectionDto>(getConnectHomerunIntegrationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecrets)
  }
);}





export const getConnectHomerunIntegrationMutationKey = () => ['connectHomerunIntegration'] as const;

export const getConnectHomerunIntegrationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectHomerunIntegration>>, TError,ConnectHomerunIntegrationMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof connectHomerunIntegration>>, TError,ConnectHomerunIntegrationMutationVariables, TContext> => {

const mutationKey = getConnectHomerunIntegrationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof connectHomerunIntegration>>, ConnectHomerunIntegrationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  connectHomerunIntegration(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConnectHomerunIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof connectHomerunIntegration>>>
    export type ConnectHomerunIntegrationMutationBody = GetOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecrets | undefined
    export type ConnectHomerunIntegrationMutationError = ProblemDetails
    export type ConnectHomerunIntegrationMutationVariables = {data?: GetOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecrets}

    export const useConnectHomerunIntegration = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectHomerunIntegration>>, TError,ConnectHomerunIntegrationMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof connectHomerunIntegration>>,
        TError,
        ConnectHomerunIntegrationMutationVariables,
        TContext
      > => {
      return useMutation(getConnectHomerunIntegrationMutationOptions(options), queryClient);
    }

export const getUpdateHomerunConnectionUrl = (connectionId: number,) => {




  return `/employer/homerun-connection/${connectionId}`
}

export const updateHomerunConnection = async (connectionId: number,
    updateAtsIntegrationConnectionCommandDtoHomerunConnectionConfig?: UpdateAtsIntegrationConnectionCommandDtoHomerunConnectionConfig, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<Unit>(getUpdateHomerunConnectionUrl(connectionId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateAtsIntegrationConnectionCommandDtoHomerunConnectionConfig)
  }
);}





export const getUpdateHomerunConnectionMutationKey = () => ['updateHomerunConnection'] as const;

export const getUpdateHomerunConnectionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHomerunConnection>>, TError,UpdateHomerunConnectionMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateHomerunConnection>>, TError,UpdateHomerunConnectionMutationVariables, TContext> => {

const mutationKey = getUpdateHomerunConnectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHomerunConnection>>, UpdateHomerunConnectionMutationVariables> = (props) => {
          const {connectionId,data} = props ?? {};

          return  updateHomerunConnection(connectionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHomerunConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof updateHomerunConnection>>>
    export type UpdateHomerunConnectionMutationBody = UpdateAtsIntegrationConnectionCommandDtoHomerunConnectionConfig | undefined
    export type UpdateHomerunConnectionMutationError = ProblemDetails
    export type UpdateHomerunConnectionMutationVariables = {connectionId: number;data?: UpdateAtsIntegrationConnectionCommandDtoHomerunConnectionConfig}

    export const useUpdateHomerunConnection = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHomerunConnection>>, TError,UpdateHomerunConnectionMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateHomerunConnection>>,
        TError,
        UpdateHomerunConnectionMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateHomerunConnectionMutationOptions(options), queryClient);
    }

export const getGetHomerunConnectionUrl = (connectionId: number,) => {




  return `/employer/homerun-connection/${connectionId}`
}

export const getHomerunConnection = async (connectionId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetAtsIntegrationConnectionResultHomerunConnectionConfig> => {

  return fetchWithAuth<GetAtsIntegrationConnectionResultHomerunConnectionConfig>(getGetHomerunConnectionUrl(connectionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetHomerunConnectionQueryKey = (connectionId: MaybeRefOrGetter<number>,) => {
    return [
    'employer','homerun-connection',connectionId
    ] as const;
    }


export const getGetHomerunConnectionQueryOptions = <TData = Awaited<ReturnType<typeof getHomerunConnection>>, TError = ProblemDetails>(connectionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHomerunConnection>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetHomerunConnectionQueryKey(connectionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHomerunConnection>>> = ({ signal }) => getHomerunConnection(toValue(connectionId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(connectionId) !== null && toValue(connectionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHomerunConnection>>, TError, TData>
}

export type GetHomerunConnectionQueryResult = NonNullable<Awaited<ReturnType<typeof getHomerunConnection>>>
export type GetHomerunConnectionQueryError = ProblemDetails



export function useGetHomerunConnection<TData = Awaited<ReturnType<typeof getHomerunConnection>>, TError = ProblemDetails>(
 connectionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHomerunConnection>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHomerunConnectionQueryOptions(connectionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getDeleteIntegrationConnectionUrl = (connectionId: number,) => {




  return `/employer/integration-connection/${connectionId}`
}

export const deleteIntegrationConnection = async (connectionId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getDeleteIntegrationConnectionUrl(connectionId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteIntegrationConnectionMutationKey = () => ['deleteIntegrationConnection'] as const;

export const getDeleteIntegrationConnectionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationConnection>>, TError,DeleteIntegrationConnectionMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationConnection>>, TError,DeleteIntegrationConnectionMutationVariables, TContext> => {

const mutationKey = getDeleteIntegrationConnectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteIntegrationConnection>>, DeleteIntegrationConnectionMutationVariables> = (props) => {
          const {connectionId} = props ?? {};

          return  deleteIntegrationConnection(connectionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteIntegrationConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteIntegrationConnection>>>

    export type DeleteIntegrationConnectionMutationError = ProblemDetails
    export type DeleteIntegrationConnectionMutationVariables = {connectionId: number}

    export const useDeleteIntegrationConnection = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationConnection>>, TError,DeleteIntegrationConnectionMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteIntegrationConnection>>,
        TError,
        DeleteIntegrationConnectionMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteIntegrationConnectionMutationOptions(options), queryClient);
    }

export const getListAtsJobsUrl = (connectionId: number,
    params?: ListAtsJobsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/employer/integration-connection/ats-jobs/${connectionId}?${stringifiedParams}` : `/employer/integration-connection/ats-jobs/${connectionId}`
}

export const listAtsJobs = async (connectionId: number,
    params?: ListAtsJobsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListAtsJobsResult> => {

  return fetchWithAuth<ListAtsJobsResult>(getListAtsJobsUrl(connectionId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAtsJobsQueryKey = (connectionId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListAtsJobsParams>,) => {
    return [
    'employer','integration-connection','ats-jobs',connectionId, ...(params ? [params] : [])
    ] as const;
    }


export const getListAtsJobsQueryOptions = <TData = Awaited<ReturnType<typeof listAtsJobs>>, TError = ProblemDetails>(connectionId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListAtsJobsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAtsJobs>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListAtsJobsQueryKey(connectionId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAtsJobs>>> = ({ signal }) => listAtsJobs(toValue(connectionId),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(connectionId) !== null && toValue(connectionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAtsJobs>>, TError, TData>
}

export type ListAtsJobsQueryResult = NonNullable<Awaited<ReturnType<typeof listAtsJobs>>>
export type ListAtsJobsQueryError = ProblemDetails



export function useListAtsJobs<TData = Awaited<ReturnType<typeof listAtsJobs>>, TError = ProblemDetails>(
 connectionId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListAtsJobsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAtsJobs>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAtsJobsQueryOptions(connectionId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getMapJobWithAtsJobUrl = (connectionId: number,) => {




  return `/employer/integration-connection/ats-jobs/${connectionId}`
}

export const mapJobWithAtsJob = async (connectionId: number,
    mapJobWithAtsJobCommandDto?: MapJobWithAtsJobCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<Unit>(getMapJobWithAtsJobUrl(connectionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(mapJobWithAtsJobCommandDto)
  }
);}





export const getMapJobWithAtsJobMutationKey = () => ['mapJobWithAtsJob'] as const;

export const getMapJobWithAtsJobMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mapJobWithAtsJob>>, TError,MapJobWithAtsJobMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof mapJobWithAtsJob>>, TError,MapJobWithAtsJobMutationVariables, TContext> => {

const mutationKey = getMapJobWithAtsJobMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mapJobWithAtsJob>>, MapJobWithAtsJobMutationVariables> = (props) => {
          const {connectionId,data} = props ?? {};

          return  mapJobWithAtsJob(connectionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MapJobWithAtsJobMutationResult = NonNullable<Awaited<ReturnType<typeof mapJobWithAtsJob>>>
    export type MapJobWithAtsJobMutationBody = MapJobWithAtsJobCommandDto | undefined
    export type MapJobWithAtsJobMutationError = ProblemDetails
    export type MapJobWithAtsJobMutationVariables = {connectionId: number;data?: MapJobWithAtsJobCommandDto}

    export const useMapJobWithAtsJob = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mapJobWithAtsJob>>, TError,MapJobWithAtsJobMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof mapJobWithAtsJob>>,
        TError,
        MapJobWithAtsJobMutationVariables,
        TContext
      > => {
      return useMutation(getMapJobWithAtsJobMutationOptions(options), queryClient);
    }

export const getListAtsVacanciesUrl = (connectionId: number,
    params?: ListAtsVacanciesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/employer/integration-connection/ats-vacancies/${connectionId}?${stringifiedParams}` : `/employer/integration-connection/ats-vacancies/${connectionId}`
}

/**
 * @summary The vacancies in the employer's ATS, each with the Swipe4Work vacancy it is coupled to. Backs the
ATS vacancy table, from which an uncoupled vacancy can be imported.
 */
export const listAtsVacancies = async (connectionId: number,
    params?: ListAtsVacanciesParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListAtsVacanciesResult> => {

  return fetchWithAuth<ListAtsVacanciesResult>(getListAtsVacanciesUrl(connectionId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAtsVacanciesQueryKey = (connectionId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListAtsVacanciesParams>,) => {
    return [
    'employer','integration-connection','ats-vacancies',connectionId, ...(params ? [params] : [])
    ] as const;
    }


export const getListAtsVacanciesQueryOptions = <TData = Awaited<ReturnType<typeof listAtsVacancies>>, TError = ProblemDetails>(connectionId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListAtsVacanciesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAtsVacancies>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListAtsVacanciesQueryKey(connectionId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAtsVacancies>>> = ({ signal }) => listAtsVacancies(toValue(connectionId),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(connectionId) !== null && toValue(connectionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAtsVacancies>>, TError, TData>
}

export type ListAtsVacanciesQueryResult = NonNullable<Awaited<ReturnType<typeof listAtsVacancies>>>
export type ListAtsVacanciesQueryError = ProblemDetails


/**
 * @summary The vacancies in the employer's ATS, each with the Swipe4Work vacancy it is coupled to. Backs the
ATS vacancy table, from which an uncoupled vacancy can be imported.
 */

export function useListAtsVacancies<TData = Awaited<ReturnType<typeof listAtsVacancies>>, TError = ProblemDetails>(
 connectionId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListAtsVacanciesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAtsVacancies>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAtsVacanciesQueryOptions(connectionId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getImportAtsJobUrl = (connectionId: number,) => {




  return `/employer/integration-connection/ats-vacancies/${connectionId}/import`
}

/**
 * @summary Imports one ATS vacancy as a published Swipe4Work vacancy, composed by the job agent and coupled
to the ATS vacancy. Refused when the company has no free job slot, because the import publishes.
 */
export const importAtsJob = async (connectionId: number,
    importAtsJobCommandDto?: ImportAtsJobCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<number> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<number>(getImportAtsJobUrl(connectionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(importAtsJobCommandDto)
  }
);}





export const getImportAtsJobMutationKey = () => ['importAtsJob'] as const;

export const getImportAtsJobMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importAtsJob>>, TError,ImportAtsJobMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof importAtsJob>>, TError,ImportAtsJobMutationVariables, TContext> => {

const mutationKey = getImportAtsJobMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importAtsJob>>, ImportAtsJobMutationVariables> = (props) => {
          const {connectionId,data} = props ?? {};

          return  importAtsJob(connectionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportAtsJobMutationResult = NonNullable<Awaited<ReturnType<typeof importAtsJob>>>
    export type ImportAtsJobMutationBody = ImportAtsJobCommandDto | undefined
    export type ImportAtsJobMutationError = ProblemDetails
    export type ImportAtsJobMutationVariables = {connectionId: number;data?: ImportAtsJobCommandDto}

    /**
 * @summary Imports one ATS vacancy as a published Swipe4Work vacancy, composed by the job agent and coupled
to the ATS vacancy. Refused when the company has no free job slot, because the import publishes.
 */
export const useImportAtsJob = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importAtsJob>>, TError,ImportAtsJobMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof importAtsJob>>,
        TError,
        ImportAtsJobMutationVariables,
        TContext
      > => {
      return useMutation(getImportAtsJobMutationOptions(options), queryClient);
    }

export const getGetAtsConnectionSyncStatusUrl = (connectionId: number,) => {




  return `/employer/integration-connection/ats-sync-status/${connectionId}`
}

/**
 * @summary The counts backing the ATS sync button: how many of the company's own candidates are still
open or errored for this connection.
 */
export const getAtsConnectionSyncStatus = async (connectionId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetAtsConnectionSyncStatusResult> => {

  return fetchWithAuth<GetAtsConnectionSyncStatusResult>(getGetAtsConnectionSyncStatusUrl(connectionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAtsConnectionSyncStatusQueryKey = (connectionId: MaybeRefOrGetter<number>,) => {
    return [
    'employer','integration-connection','ats-sync-status',connectionId
    ] as const;
    }


export const getGetAtsConnectionSyncStatusQueryOptions = <TData = Awaited<ReturnType<typeof getAtsConnectionSyncStatus>>, TError = ProblemDetails>(connectionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsConnectionSyncStatus>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetAtsConnectionSyncStatusQueryKey(connectionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAtsConnectionSyncStatus>>> = ({ signal }) => getAtsConnectionSyncStatus(toValue(connectionId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(connectionId) !== null && toValue(connectionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAtsConnectionSyncStatus>>, TError, TData>
}

export type GetAtsConnectionSyncStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getAtsConnectionSyncStatus>>>
export type GetAtsConnectionSyncStatusQueryError = ProblemDetails


/**
 * @summary The counts backing the ATS sync button: how many of the company's own candidates are still
open or errored for this connection.
 */

export function useGetAtsConnectionSyncStatus<TData = Awaited<ReturnType<typeof getAtsConnectionSyncStatus>>, TError = ProblemDetails>(
 connectionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAtsConnectionSyncStatus>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAtsConnectionSyncStatusQueryOptions(connectionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getResendOwnAtsJobApplicationsUrl = (connectionId: number,) => {




  return `/employer/integration-connection/${connectionId}/resend-open-candidates`
}

/**
 * @summary Re-send all of the company's own open and errored candidates of an ATS integration connection
back to the ATS.
 */
export const resendOwnAtsJobApplications = async (connectionId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ResendAtsJobApplicationsResult> => {

  return fetchWithAuth<ResendAtsJobApplicationsResult>(getResendOwnAtsJobApplicationsUrl(connectionId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getResendOwnAtsJobApplicationsMutationKey = () => ['resendOwnAtsJobApplications'] as const;

export const getResendOwnAtsJobApplicationsMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendOwnAtsJobApplications>>, TError,ResendOwnAtsJobApplicationsMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof resendOwnAtsJobApplications>>, TError,ResendOwnAtsJobApplicationsMutationVariables, TContext> => {

const mutationKey = getResendOwnAtsJobApplicationsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendOwnAtsJobApplications>>, ResendOwnAtsJobApplicationsMutationVariables> = (props) => {
          const {connectionId} = props ?? {};

          return  resendOwnAtsJobApplications(connectionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendOwnAtsJobApplicationsMutationResult = NonNullable<Awaited<ReturnType<typeof resendOwnAtsJobApplications>>>

    export type ResendOwnAtsJobApplicationsMutationError = ProblemDetails
    export type ResendOwnAtsJobApplicationsMutationVariables = {connectionId: number}

    /**
 * @summary Re-send all of the company's own open and errored candidates of an ATS integration connection
back to the ATS.
 */
export const useResendOwnAtsJobApplications = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendOwnAtsJobApplications>>, TError,ResendOwnAtsJobApplicationsMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof resendOwnAtsJobApplications>>,
        TError,
        ResendOwnAtsJobApplicationsMutationVariables,
        TContext
      > => {
      return useMutation(getResendOwnAtsJobApplicationsMutationOptions(options), queryClient);
    }

export const getConnectMySolutionIntegrationUrl = () => {




  return `/employer/my-solution-connection`
}

/**
 * @summary Starts the Mysolution OAuth2 authorization-code flow. Stores the connection's credentials and
returns the Salesforce authorization URL the portal should redirect the user to.
 */
export const connectMySolutionIntegration = async (connectMySolutionIntegrationDto?: ConnectMySolutionIntegrationDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ConnectMySolutionIntegrationResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<ConnectMySolutionIntegrationResult>(getConnectMySolutionIntegrationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(connectMySolutionIntegrationDto)
  }
);}





export const getConnectMySolutionIntegrationMutationKey = () => ['connectMySolutionIntegration'] as const;

export const getConnectMySolutionIntegrationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectMySolutionIntegration>>, TError,ConnectMySolutionIntegrationMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof connectMySolutionIntegration>>, TError,ConnectMySolutionIntegrationMutationVariables, TContext> => {

const mutationKey = getConnectMySolutionIntegrationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof connectMySolutionIntegration>>, ConnectMySolutionIntegrationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  connectMySolutionIntegration(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConnectMySolutionIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof connectMySolutionIntegration>>>
    export type ConnectMySolutionIntegrationMutationBody = ConnectMySolutionIntegrationDto | undefined
    export type ConnectMySolutionIntegrationMutationError = ProblemDetails
    export type ConnectMySolutionIntegrationMutationVariables = {data?: ConnectMySolutionIntegrationDto}

    /**
 * @summary Starts the Mysolution OAuth2 authorization-code flow. Stores the connection's credentials and
returns the Salesforce authorization URL the portal should redirect the user to.
 */
export const useConnectMySolutionIntegration = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectMySolutionIntegration>>, TError,ConnectMySolutionIntegrationMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof connectMySolutionIntegration>>,
        TError,
        ConnectMySolutionIntegrationMutationVariables,
        TContext
      > => {
      return useMutation(getConnectMySolutionIntegrationMutationOptions(options), queryClient);
    }

export const getUpdateMySolutionConnectionUrl = (connectionId: number,) => {




  return `/employer/my-solution-connection/mysolution/${connectionId}`
}

export const updateMySolutionConnection = async (connectionId: number,
    updateAtsIntegrationConnectionCommandDtoMySolutionConnectionConfig?: UpdateAtsIntegrationConnectionCommandDtoMySolutionConnectionConfig, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<Unit>(getUpdateMySolutionConnectionUrl(connectionId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateAtsIntegrationConnectionCommandDtoMySolutionConnectionConfig)
  }
);}





export const getUpdateMySolutionConnectionMutationKey = () => ['updateMySolutionConnection'] as const;

export const getUpdateMySolutionConnectionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMySolutionConnection>>, TError,UpdateMySolutionConnectionMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMySolutionConnection>>, TError,UpdateMySolutionConnectionMutationVariables, TContext> => {

const mutationKey = getUpdateMySolutionConnectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMySolutionConnection>>, UpdateMySolutionConnectionMutationVariables> = (props) => {
          const {connectionId,data} = props ?? {};

          return  updateMySolutionConnection(connectionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMySolutionConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof updateMySolutionConnection>>>
    export type UpdateMySolutionConnectionMutationBody = UpdateAtsIntegrationConnectionCommandDtoMySolutionConnectionConfig | undefined
    export type UpdateMySolutionConnectionMutationError = ProblemDetails
    export type UpdateMySolutionConnectionMutationVariables = {connectionId: number;data?: UpdateAtsIntegrationConnectionCommandDtoMySolutionConnectionConfig}

    export const useUpdateMySolutionConnection = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMySolutionConnection>>, TError,UpdateMySolutionConnectionMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateMySolutionConnection>>,
        TError,
        UpdateMySolutionConnectionMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateMySolutionConnectionMutationOptions(options), queryClient);
    }

export const getGetMySolutionConnectionUrl = (connectionId: number,) => {




  return `/employer/my-solution-connection/mysolution/${connectionId}`
}

export const getMySolutionConnection = async (connectionId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetAtsIntegrationConnectionResultMySolutionConnectionConfig> => {

  return fetchWithAuth<GetAtsIntegrationConnectionResultMySolutionConnectionConfig>(getGetMySolutionConnectionUrl(connectionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMySolutionConnectionQueryKey = (connectionId: MaybeRefOrGetter<number>,) => {
    return [
    'employer','my-solution-connection','mysolution',connectionId
    ] as const;
    }


export const getGetMySolutionConnectionQueryOptions = <TData = Awaited<ReturnType<typeof getMySolutionConnection>>, TError = ProblemDetails>(connectionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMySolutionConnection>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetMySolutionConnectionQueryKey(connectionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMySolutionConnection>>> = ({ signal }) => getMySolutionConnection(toValue(connectionId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(connectionId) !== null && toValue(connectionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMySolutionConnection>>, TError, TData>
}

export type GetMySolutionConnectionQueryResult = NonNullable<Awaited<ReturnType<typeof getMySolutionConnection>>>
export type GetMySolutionConnectionQueryError = ProblemDetails



export function useGetMySolutionConnection<TData = Awaited<ReturnType<typeof getMySolutionConnection>>, TError = ProblemDetails>(
 connectionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMySolutionConnection>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMySolutionConnectionQueryOptions(connectionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetMySolutionApplyConfigurationUrl = (connectionId: number,
    params?: GetMySolutionApplyConfigurationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/employer/my-solution-connection/mysolution/${connectionId}/apply-configuration?${stringifiedParams}` : `/employer/my-solution-connection/mysolution/${connectionId}/apply-configuration`
}

/**
 * @summary Diagnostic: reads the Mysolution portal configuration and — when setApiName is
supplied — the apply-form field-set configuration, so the correct portal domain, apply controller
and field labels can be discovered and set on the connection. Call once without setApiName to find
the valid controllers/domain, then again with a setApiName to see its expected field labels.
 */
export const getMySolutionApplyConfiguration = async (connectionId: number,
    params?: GetMySolutionApplyConfigurationParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetMySolutionApplyConfigurationResult> => {

  return fetchWithAuth<GetMySolutionApplyConfigurationResult>(getGetMySolutionApplyConfigurationUrl(connectionId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMySolutionApplyConfigurationQueryKey = (connectionId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetMySolutionApplyConfigurationParams>,) => {
    return [
    'employer','my-solution-connection','mysolution',connectionId,'apply-configuration', ...(params ? [params] : [])
    ] as const;
    }


export const getGetMySolutionApplyConfigurationQueryOptions = <TData = Awaited<ReturnType<typeof getMySolutionApplyConfiguration>>, TError = ProblemDetails>(connectionId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetMySolutionApplyConfigurationParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMySolutionApplyConfiguration>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetMySolutionApplyConfigurationQueryKey(connectionId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMySolutionApplyConfiguration>>> = ({ signal }) => getMySolutionApplyConfiguration(toValue(connectionId),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(connectionId) !== null && toValue(connectionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMySolutionApplyConfiguration>>, TError, TData>
}

export type GetMySolutionApplyConfigurationQueryResult = NonNullable<Awaited<ReturnType<typeof getMySolutionApplyConfiguration>>>
export type GetMySolutionApplyConfigurationQueryError = ProblemDetails


/**
 * @summary Diagnostic: reads the Mysolution portal configuration and — when setApiName is
supplied — the apply-form field-set configuration, so the correct portal domain, apply controller
and field labels can be discovered and set on the connection. Call once without setApiName to find
the valid controllers/domain, then again with a setApiName to see its expected field labels.
 */

export function useGetMySolutionApplyConfiguration<TData = Awaited<ReturnType<typeof getMySolutionApplyConfiguration>>, TError = ProblemDetails>(
 connectionId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetMySolutionApplyConfigurationParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMySolutionApplyConfiguration>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMySolutionApplyConfigurationQueryOptions(connectionId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetMySolutionWebhookInfoUrl = (connectionId: number,) => {




  return `/employer/my-solution-connection/mysolution/${connectionId}/webhook-info`
}

/**
 * @summary Returns the inbound-webhook URL and per-connection token for this connection, to paste into the
customer's Salesforce Flow (HTTP callout URL + `X-S4W-Webhook-Token` header).
 */
export const getMySolutionWebhookInfo = async (connectionId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetMySolutionWebhookInfoResult> => {

  return fetchWithAuth<GetMySolutionWebhookInfoResult>(getGetMySolutionWebhookInfoUrl(connectionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMySolutionWebhookInfoQueryKey = (connectionId: MaybeRefOrGetter<number>,) => {
    return [
    'employer','my-solution-connection','mysolution',connectionId,'webhook-info'
    ] as const;
    }


export const getGetMySolutionWebhookInfoQueryOptions = <TData = Awaited<ReturnType<typeof getMySolutionWebhookInfo>>, TError = ProblemDetails>(connectionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMySolutionWebhookInfo>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetMySolutionWebhookInfoQueryKey(connectionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMySolutionWebhookInfo>>> = ({ signal }) => getMySolutionWebhookInfo(toValue(connectionId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(connectionId) !== null && toValue(connectionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMySolutionWebhookInfo>>, TError, TData>
}

export type GetMySolutionWebhookInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getMySolutionWebhookInfo>>>
export type GetMySolutionWebhookInfoQueryError = ProblemDetails


/**
 * @summary Returns the inbound-webhook URL and per-connection token for this connection, to paste into the
customer's Salesforce Flow (HTTP callout URL + `X-S4W-Webhook-Token` header).
 */

export function useGetMySolutionWebhookInfo<TData = Awaited<ReturnType<typeof getMySolutionWebhookInfo>>, TError = ProblemDetails>(
 connectionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMySolutionWebhookInfo>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMySolutionWebhookInfoQueryOptions(connectionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getConnectOtysIntegrationUrl = () => {




  return `/employer/otys-connection`
}

export const connectOtysIntegration = async (getOrCreateAtsIntegrationConnectionCommandDtoOtysConnectionSecrets?: GetOrCreateAtsIntegrationConnectionCommandDtoOtysConnectionSecrets, options?: Parameters<typeof fetchWithAuth>[1]): Promise<IntegrationConnectionDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<IntegrationConnectionDto>(getConnectOtysIntegrationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getOrCreateAtsIntegrationConnectionCommandDtoOtysConnectionSecrets)
  }
);}





export const getConnectOtysIntegrationMutationKey = () => ['connectOtysIntegration'] as const;

export const getConnectOtysIntegrationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectOtysIntegration>>, TError,ConnectOtysIntegrationMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof connectOtysIntegration>>, TError,ConnectOtysIntegrationMutationVariables, TContext> => {

const mutationKey = getConnectOtysIntegrationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof connectOtysIntegration>>, ConnectOtysIntegrationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  connectOtysIntegration(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConnectOtysIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof connectOtysIntegration>>>
    export type ConnectOtysIntegrationMutationBody = GetOrCreateAtsIntegrationConnectionCommandDtoOtysConnectionSecrets | undefined
    export type ConnectOtysIntegrationMutationError = ProblemDetails
    export type ConnectOtysIntegrationMutationVariables = {data?: GetOrCreateAtsIntegrationConnectionCommandDtoOtysConnectionSecrets}

    export const useConnectOtysIntegration = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectOtysIntegration>>, TError,ConnectOtysIntegrationMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof connectOtysIntegration>>,
        TError,
        ConnectOtysIntegrationMutationVariables,
        TContext
      > => {
      return useMutation(getConnectOtysIntegrationMutationOptions(options), queryClient);
    }

export const getUpdateOtysConnectionUrl = (connectionId: number,) => {




  return `/employer/otys-connection/otys/${connectionId}`
}

export const updateOtysConnection = async (connectionId: number,
    updateAtsIntegrationConnectionCommandDtoOtysConnectionConfig?: UpdateAtsIntegrationConnectionCommandDtoOtysConnectionConfig, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<Unit>(getUpdateOtysConnectionUrl(connectionId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateAtsIntegrationConnectionCommandDtoOtysConnectionConfig)
  }
);}





export const getUpdateOtysConnectionMutationKey = () => ['updateOtysConnection'] as const;

export const getUpdateOtysConnectionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOtysConnection>>, TError,UpdateOtysConnectionMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOtysConnection>>, TError,UpdateOtysConnectionMutationVariables, TContext> => {

const mutationKey = getUpdateOtysConnectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOtysConnection>>, UpdateOtysConnectionMutationVariables> = (props) => {
          const {connectionId,data} = props ?? {};

          return  updateOtysConnection(connectionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOtysConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof updateOtysConnection>>>
    export type UpdateOtysConnectionMutationBody = UpdateAtsIntegrationConnectionCommandDtoOtysConnectionConfig | undefined
    export type UpdateOtysConnectionMutationError = ProblemDetails
    export type UpdateOtysConnectionMutationVariables = {connectionId: number;data?: UpdateAtsIntegrationConnectionCommandDtoOtysConnectionConfig}

    export const useUpdateOtysConnection = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOtysConnection>>, TError,UpdateOtysConnectionMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateOtysConnection>>,
        TError,
        UpdateOtysConnectionMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateOtysConnectionMutationOptions(options), queryClient);
    }

export const getGetOtysConnectionUrl = (connectionId: number,) => {




  return `/employer/otys-connection/otys/${connectionId}`
}

export const getOtysConnection = async (connectionId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetAtsIntegrationConnectionResultOtysConnectionConfig> => {

  return fetchWithAuth<GetAtsIntegrationConnectionResultOtysConnectionConfig>(getGetOtysConnectionUrl(connectionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOtysConnectionQueryKey = (connectionId: MaybeRefOrGetter<number>,) => {
    return [
    'employer','otys-connection','otys',connectionId
    ] as const;
    }


export const getGetOtysConnectionQueryOptions = <TData = Awaited<ReturnType<typeof getOtysConnection>>, TError = ProblemDetails>(connectionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOtysConnection>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetOtysConnectionQueryKey(connectionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOtysConnection>>> = ({ signal }) => getOtysConnection(toValue(connectionId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(connectionId) !== null && toValue(connectionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOtysConnection>>, TError, TData>
}

export type GetOtysConnectionQueryResult = NonNullable<Awaited<ReturnType<typeof getOtysConnection>>>
export type GetOtysConnectionQueryError = ProblemDetails



export function useGetOtysConnection<TData = Awaited<ReturnType<typeof getOtysConnection>>, TError = ProblemDetails>(
 connectionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOtysConnection>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOtysConnectionQueryOptions(connectionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListOtysPortalsUrl = (connectionId: number,) => {




  return `/employer/otys-connection/otys/${connectionId}/portals`
}

export const listOtysPortals = async (connectionId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListOtysPortalsResult> => {

  return fetchWithAuth<ListOtysPortalsResult>(getListOtysPortalsUrl(connectionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOtysPortalsQueryKey = (connectionId: MaybeRefOrGetter<number>,) => {
    return [
    'employer','otys-connection','otys',connectionId,'portals'
    ] as const;
    }


export const getListOtysPortalsQueryOptions = <TData = Awaited<ReturnType<typeof listOtysPortals>>, TError = ProblemDetails>(connectionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOtysPortals>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListOtysPortalsQueryKey(connectionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOtysPortals>>> = ({ signal }) => listOtysPortals(toValue(connectionId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(connectionId) !== null && toValue(connectionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOtysPortals>>, TError, TData>
}

export type ListOtysPortalsQueryResult = NonNullable<Awaited<ReturnType<typeof listOtysPortals>>>
export type ListOtysPortalsQueryError = ProblemDetails



export function useListOtysPortals<TData = Awaited<ReturnType<typeof listOtysPortals>>, TError = ProblemDetails>(
 connectionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOtysPortals>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOtysPortalsQueryOptions(connectionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getUpdateOtysPortalUrl = (connectionId: number,) => {




  return `/employer/otys-connection/otys/${connectionId}/portal`
}

export const updateOtysPortal = async (connectionId: number,
    updateOtysPortalCommandDto?: UpdateOtysPortalCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<Unit>(getUpdateOtysPortalUrl(connectionId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateOtysPortalCommandDto)
  }
);}





export const getUpdateOtysPortalMutationKey = () => ['updateOtysPortal'] as const;

export const getUpdateOtysPortalMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOtysPortal>>, TError,UpdateOtysPortalMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOtysPortal>>, TError,UpdateOtysPortalMutationVariables, TContext> => {

const mutationKey = getUpdateOtysPortalMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOtysPortal>>, UpdateOtysPortalMutationVariables> = (props) => {
          const {connectionId,data} = props ?? {};

          return  updateOtysPortal(connectionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOtysPortalMutationResult = NonNullable<Awaited<ReturnType<typeof updateOtysPortal>>>
    export type UpdateOtysPortalMutationBody = UpdateOtysPortalCommandDto | undefined
    export type UpdateOtysPortalMutationError = ProblemDetails
    export type UpdateOtysPortalMutationVariables = {connectionId: number;data?: UpdateOtysPortalCommandDto}

    export const useUpdateOtysPortal = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOtysPortal>>, TError,UpdateOtysPortalMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateOtysPortal>>,
        TError,
        UpdateOtysPortalMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateOtysPortalMutationOptions(options), queryClient);
    }

export const getConnectRecruiteeIntegrationUrl = () => {




  return `/employer/recruitee-connection`
}

export const connectRecruiteeIntegration = async (getOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecrets?: GetOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecrets, options?: Parameters<typeof fetchWithAuth>[1]): Promise<IntegrationConnectionDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<IntegrationConnectionDto>(getConnectRecruiteeIntegrationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecrets)
  }
);}





export const getConnectRecruiteeIntegrationMutationKey = () => ['connectRecruiteeIntegration'] as const;

export const getConnectRecruiteeIntegrationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectRecruiteeIntegration>>, TError,ConnectRecruiteeIntegrationMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof connectRecruiteeIntegration>>, TError,ConnectRecruiteeIntegrationMutationVariables, TContext> => {

const mutationKey = getConnectRecruiteeIntegrationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof connectRecruiteeIntegration>>, ConnectRecruiteeIntegrationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  connectRecruiteeIntegration(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConnectRecruiteeIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof connectRecruiteeIntegration>>>
    export type ConnectRecruiteeIntegrationMutationBody = GetOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecrets | undefined
    export type ConnectRecruiteeIntegrationMutationError = ProblemDetails
    export type ConnectRecruiteeIntegrationMutationVariables = {data?: GetOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecrets}

    export const useConnectRecruiteeIntegration = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectRecruiteeIntegration>>, TError,ConnectRecruiteeIntegrationMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof connectRecruiteeIntegration>>,
        TError,
        ConnectRecruiteeIntegrationMutationVariables,
        TContext
      > => {
      return useMutation(getConnectRecruiteeIntegrationMutationOptions(options), queryClient);
    }

export const getUpdateRecruiteeConnectionUrl = (connectionId: number,) => {




  return `/employer/recruitee-connection/recruitee/${connectionId}`
}

export const updateRecruiteeConnection = async (connectionId: number,
    updateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfig?: UpdateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfig, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<Unit>(getUpdateRecruiteeConnectionUrl(connectionId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfig)
  }
);}





export const getUpdateRecruiteeConnectionMutationKey = () => ['updateRecruiteeConnection'] as const;

export const getUpdateRecruiteeConnectionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRecruiteeConnection>>, TError,UpdateRecruiteeConnectionMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRecruiteeConnection>>, TError,UpdateRecruiteeConnectionMutationVariables, TContext> => {

const mutationKey = getUpdateRecruiteeConnectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRecruiteeConnection>>, UpdateRecruiteeConnectionMutationVariables> = (props) => {
          const {connectionId,data} = props ?? {};

          return  updateRecruiteeConnection(connectionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateRecruiteeConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof updateRecruiteeConnection>>>
    export type UpdateRecruiteeConnectionMutationBody = UpdateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfig | undefined
    export type UpdateRecruiteeConnectionMutationError = ProblemDetails
    export type UpdateRecruiteeConnectionMutationVariables = {connectionId: number;data?: UpdateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfig}

    export const useUpdateRecruiteeConnection = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRecruiteeConnection>>, TError,UpdateRecruiteeConnectionMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateRecruiteeConnection>>,
        TError,
        UpdateRecruiteeConnectionMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateRecruiteeConnectionMutationOptions(options), queryClient);
    }

export const getGetRecruiteeConnectionUrl = (connectionId: number,) => {




  return `/employer/recruitee-connection/recruitee/${connectionId}`
}

export const getRecruiteeConnection = async (connectionId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetAtsIntegrationConnectionResultRecruiteeConnectionConfig> => {

  return fetchWithAuth<GetAtsIntegrationConnectionResultRecruiteeConnectionConfig>(getGetRecruiteeConnectionUrl(connectionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRecruiteeConnectionQueryKey = (connectionId: MaybeRefOrGetter<number>,) => {
    return [
    'employer','recruitee-connection','recruitee',connectionId
    ] as const;
    }


export const getGetRecruiteeConnectionQueryOptions = <TData = Awaited<ReturnType<typeof getRecruiteeConnection>>, TError = ProblemDetails>(connectionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecruiteeConnection>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetRecruiteeConnectionQueryKey(connectionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecruiteeConnection>>> = ({ signal }) => getRecruiteeConnection(toValue(connectionId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(connectionId) !== null && toValue(connectionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRecruiteeConnection>>, TError, TData>
}

export type GetRecruiteeConnectionQueryResult = NonNullable<Awaited<ReturnType<typeof getRecruiteeConnection>>>
export type GetRecruiteeConnectionQueryError = ProblemDetails



export function useGetRecruiteeConnection<TData = Awaited<ReturnType<typeof getRecruiteeConnection>>, TError = ProblemDetails>(
 connectionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecruiteeConnection>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRecruiteeConnectionQueryOptions(connectionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetRecruiteeJobLocationsUrl = (connectionId: number,
    atsJobId: string,) => {




  return `/employer/recruitee-connection/recruitee/${connectionId}/jobs/${atsJobId}/locations`
}

export const getRecruiteeJobLocations = async (connectionId: number,
    atsJobId: string, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetRecruiteeJobLocationsResult> => {

  return fetchWithAuth<GetRecruiteeJobLocationsResult>(getGetRecruiteeJobLocationsUrl(connectionId,atsJobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRecruiteeJobLocationsQueryKey = (connectionId: MaybeRefOrGetter<number>,
    atsJobId: MaybeRefOrGetter<string>,) => {
    return [
    'employer','recruitee-connection','recruitee',connectionId,'jobs',atsJobId,'locations'
    ] as const;
    }


export const getGetRecruiteeJobLocationsQueryOptions = <TData = Awaited<ReturnType<typeof getRecruiteeJobLocations>>, TError = ProblemDetails>(connectionId: MaybeRefOrGetter<number>,
    atsJobId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecruiteeJobLocations>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetRecruiteeJobLocationsQueryKey(connectionId,atsJobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecruiteeJobLocations>>> = ({ signal }) => getRecruiteeJobLocations(toValue(connectionId),toValue(atsJobId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(connectionId) !== null && toValue(connectionId) !== undefined && toValue(atsJobId) !== null && toValue(atsJobId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRecruiteeJobLocations>>, TError, TData>
}

export type GetRecruiteeJobLocationsQueryResult = NonNullable<Awaited<ReturnType<typeof getRecruiteeJobLocations>>>
export type GetRecruiteeJobLocationsQueryError = ProblemDetails



export function useGetRecruiteeJobLocations<TData = Awaited<ReturnType<typeof getRecruiteeJobLocations>>, TError = ProblemDetails>(
 connectionId: MaybeRefOrGetter<number>,
    atsJobId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecruiteeJobLocations>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRecruiteeJobLocationsQueryOptions(connectionId,atsJobId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getConnectRecruitNowIntegrationUrl = () => {




  return `/employer/recruit-now-connection`
}

export const connectRecruitNowIntegration = async (getOrCreateAtsIntegrationConnectionCommandDtoRecruitNowConnectionSecrets?: GetOrCreateAtsIntegrationConnectionCommandDtoRecruitNowConnectionSecrets, options?: Parameters<typeof fetchWithAuth>[1]): Promise<IntegrationConnectionDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<IntegrationConnectionDto>(getConnectRecruitNowIntegrationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getOrCreateAtsIntegrationConnectionCommandDtoRecruitNowConnectionSecrets)
  }
);}





export const getConnectRecruitNowIntegrationMutationKey = () => ['connectRecruitNowIntegration'] as const;

export const getConnectRecruitNowIntegrationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectRecruitNowIntegration>>, TError,ConnectRecruitNowIntegrationMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof connectRecruitNowIntegration>>, TError,ConnectRecruitNowIntegrationMutationVariables, TContext> => {

const mutationKey = getConnectRecruitNowIntegrationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof connectRecruitNowIntegration>>, ConnectRecruitNowIntegrationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  connectRecruitNowIntegration(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConnectRecruitNowIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof connectRecruitNowIntegration>>>
    export type ConnectRecruitNowIntegrationMutationBody = GetOrCreateAtsIntegrationConnectionCommandDtoRecruitNowConnectionSecrets | undefined
    export type ConnectRecruitNowIntegrationMutationError = ProblemDetails
    export type ConnectRecruitNowIntegrationMutationVariables = {data?: GetOrCreateAtsIntegrationConnectionCommandDtoRecruitNowConnectionSecrets}

    export const useConnectRecruitNowIntegration = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectRecruitNowIntegration>>, TError,ConnectRecruitNowIntegrationMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof connectRecruitNowIntegration>>,
        TError,
        ConnectRecruitNowIntegrationMutationVariables,
        TContext
      > => {
      return useMutation(getConnectRecruitNowIntegrationMutationOptions(options), queryClient);
    }

export const getUpdateRecruitNowConnectionUrl = (connectionId: number,) => {




  return `/employer/recruit-now-connection/recruitnow/${connectionId}`
}

export const updateRecruitNowConnection = async (connectionId: number,
    updateAtsIntegrationConnectionCommandDtoRecruitNowConnectionConfig?: UpdateAtsIntegrationConnectionCommandDtoRecruitNowConnectionConfig, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<Unit>(getUpdateRecruitNowConnectionUrl(connectionId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateAtsIntegrationConnectionCommandDtoRecruitNowConnectionConfig)
  }
);}





export const getUpdateRecruitNowConnectionMutationKey = () => ['updateRecruitNowConnection'] as const;

export const getUpdateRecruitNowConnectionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRecruitNowConnection>>, TError,UpdateRecruitNowConnectionMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRecruitNowConnection>>, TError,UpdateRecruitNowConnectionMutationVariables, TContext> => {

const mutationKey = getUpdateRecruitNowConnectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRecruitNowConnection>>, UpdateRecruitNowConnectionMutationVariables> = (props) => {
          const {connectionId,data} = props ?? {};

          return  updateRecruitNowConnection(connectionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateRecruitNowConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof updateRecruitNowConnection>>>
    export type UpdateRecruitNowConnectionMutationBody = UpdateAtsIntegrationConnectionCommandDtoRecruitNowConnectionConfig | undefined
    export type UpdateRecruitNowConnectionMutationError = ProblemDetails
    export type UpdateRecruitNowConnectionMutationVariables = {connectionId: number;data?: UpdateAtsIntegrationConnectionCommandDtoRecruitNowConnectionConfig}

    export const useUpdateRecruitNowConnection = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRecruitNowConnection>>, TError,UpdateRecruitNowConnectionMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateRecruitNowConnection>>,
        TError,
        UpdateRecruitNowConnectionMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateRecruitNowConnectionMutationOptions(options), queryClient);
    }

export const getGetRecruitNowConnectionUrl = (connectionId: number,) => {




  return `/employer/recruit-now-connection/recruitnow/${connectionId}`
}

export const getRecruitNowConnection = async (connectionId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetAtsIntegrationConnectionResultRecruitNowConnectionConfig> => {

  return fetchWithAuth<GetAtsIntegrationConnectionResultRecruitNowConnectionConfig>(getGetRecruitNowConnectionUrl(connectionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRecruitNowConnectionQueryKey = (connectionId: MaybeRefOrGetter<number>,) => {
    return [
    'employer','recruit-now-connection','recruitnow',connectionId
    ] as const;
    }


export const getGetRecruitNowConnectionQueryOptions = <TData = Awaited<ReturnType<typeof getRecruitNowConnection>>, TError = ProblemDetails>(connectionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecruitNowConnection>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetRecruitNowConnectionQueryKey(connectionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecruitNowConnection>>> = ({ signal }) => getRecruitNowConnection(toValue(connectionId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(connectionId) !== null && toValue(connectionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRecruitNowConnection>>, TError, TData>
}

export type GetRecruitNowConnectionQueryResult = NonNullable<Awaited<ReturnType<typeof getRecruitNowConnection>>>
export type GetRecruitNowConnectionQueryError = ProblemDetails



export function useGetRecruitNowConnection<TData = Awaited<ReturnType<typeof getRecruitNowConnection>>, TError = ProblemDetails>(
 connectionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecruitNowConnection>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRecruitNowConnectionQueryOptions(connectionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getUpdateRecruitNowJobMappingUrl = (connectionId: number,
    jobId: number,) => {




  return `/employer/recruit-now-connection/recruitnow/${connectionId}/job-mappings/${jobId}`
}

export const updateRecruitNowJobMapping = async (connectionId: number,
    jobId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getUpdateRecruitNowJobMappingUrl(connectionId,jobId),
  {
    ...options,
    method: 'PUT'


  }
);}





export const getUpdateRecruitNowJobMappingMutationKey = () => ['updateRecruitNowJobMapping'] as const;

export const getUpdateRecruitNowJobMappingMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRecruitNowJobMapping>>, TError,UpdateRecruitNowJobMappingMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRecruitNowJobMapping>>, TError,UpdateRecruitNowJobMappingMutationVariables, TContext> => {

const mutationKey = getUpdateRecruitNowJobMappingMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRecruitNowJobMapping>>, UpdateRecruitNowJobMappingMutationVariables> = (props) => {
          const {connectionId,jobId} = props ?? {};

          return  updateRecruitNowJobMapping(connectionId,jobId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateRecruitNowJobMappingMutationResult = NonNullable<Awaited<ReturnType<typeof updateRecruitNowJobMapping>>>

    export type UpdateRecruitNowJobMappingMutationError = ProblemDetails
    export type UpdateRecruitNowJobMappingMutationVariables = {connectionId: number;jobId: number}

    export const useUpdateRecruitNowJobMapping = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRecruitNowJobMapping>>, TError,UpdateRecruitNowJobMappingMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateRecruitNowJobMapping>>,
        TError,
        UpdateRecruitNowJobMappingMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateRecruitNowJobMappingMutationOptions(options), queryClient);
    }

export const getConnectUbeeoIntegrationUrl = () => {




  return `/employer/ubeeo-connection`
}

export const connectUbeeoIntegration = async (getOrCreateAtsIntegrationConnectionCommandDtoUbeeoConnectionSecrets?: GetOrCreateAtsIntegrationConnectionCommandDtoUbeeoConnectionSecrets, options?: Parameters<typeof fetchWithAuth>[1]): Promise<IntegrationConnectionDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<IntegrationConnectionDto>(getConnectUbeeoIntegrationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getOrCreateAtsIntegrationConnectionCommandDtoUbeeoConnectionSecrets)
  }
);}





export const getConnectUbeeoIntegrationMutationKey = () => ['connectUbeeoIntegration'] as const;

export const getConnectUbeeoIntegrationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectUbeeoIntegration>>, TError,ConnectUbeeoIntegrationMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof connectUbeeoIntegration>>, TError,ConnectUbeeoIntegrationMutationVariables, TContext> => {

const mutationKey = getConnectUbeeoIntegrationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof connectUbeeoIntegration>>, ConnectUbeeoIntegrationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  connectUbeeoIntegration(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConnectUbeeoIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof connectUbeeoIntegration>>>
    export type ConnectUbeeoIntegrationMutationBody = GetOrCreateAtsIntegrationConnectionCommandDtoUbeeoConnectionSecrets | undefined
    export type ConnectUbeeoIntegrationMutationError = ProblemDetails
    export type ConnectUbeeoIntegrationMutationVariables = {data?: GetOrCreateAtsIntegrationConnectionCommandDtoUbeeoConnectionSecrets}

    export const useConnectUbeeoIntegration = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectUbeeoIntegration>>, TError,ConnectUbeeoIntegrationMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof connectUbeeoIntegration>>,
        TError,
        ConnectUbeeoIntegrationMutationVariables,
        TContext
      > => {
      return useMutation(getConnectUbeeoIntegrationMutationOptions(options), queryClient);
    }

export const getUpdateUbeeoConnectionUrl = (connectionId: number,) => {




  return `/employer/ubeeo-connection/${connectionId}`
}

export const updateUbeeoConnection = async (connectionId: number,
    updateAtsIntegrationConnectionCommandDtoUbeeoConnectionConfig?: UpdateAtsIntegrationConnectionCommandDtoUbeeoConnectionConfig, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<Unit>(getUpdateUbeeoConnectionUrl(connectionId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateAtsIntegrationConnectionCommandDtoUbeeoConnectionConfig)
  }
);}





export const getUpdateUbeeoConnectionMutationKey = () => ['updateUbeeoConnection'] as const;

export const getUpdateUbeeoConnectionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUbeeoConnection>>, TError,UpdateUbeeoConnectionMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUbeeoConnection>>, TError,UpdateUbeeoConnectionMutationVariables, TContext> => {

const mutationKey = getUpdateUbeeoConnectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUbeeoConnection>>, UpdateUbeeoConnectionMutationVariables> = (props) => {
          const {connectionId,data} = props ?? {};

          return  updateUbeeoConnection(connectionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUbeeoConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof updateUbeeoConnection>>>
    export type UpdateUbeeoConnectionMutationBody = UpdateAtsIntegrationConnectionCommandDtoUbeeoConnectionConfig | undefined
    export type UpdateUbeeoConnectionMutationError = ProblemDetails
    export type UpdateUbeeoConnectionMutationVariables = {connectionId: number;data?: UpdateAtsIntegrationConnectionCommandDtoUbeeoConnectionConfig}

    export const useUpdateUbeeoConnection = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUbeeoConnection>>, TError,UpdateUbeeoConnectionMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateUbeeoConnection>>,
        TError,
        UpdateUbeeoConnectionMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateUbeeoConnectionMutationOptions(options), queryClient);
    }

export const getGetUbeeoConnectionUrl = (connectionId: number,) => {




  return `/employer/ubeeo-connection/${connectionId}`
}

export const getUbeeoConnection = async (connectionId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetAtsIntegrationConnectionResultUbeeoConnectionConfig> => {

  return fetchWithAuth<GetAtsIntegrationConnectionResultUbeeoConnectionConfig>(getGetUbeeoConnectionUrl(connectionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUbeeoConnectionQueryKey = (connectionId: MaybeRefOrGetter<number>,) => {
    return [
    'employer','ubeeo-connection',connectionId
    ] as const;
    }


export const getGetUbeeoConnectionQueryOptions = <TData = Awaited<ReturnType<typeof getUbeeoConnection>>, TError = ProblemDetails>(connectionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUbeeoConnection>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetUbeeoConnectionQueryKey(connectionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUbeeoConnection>>> = ({ signal }) => getUbeeoConnection(toValue(connectionId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(connectionId) !== null && toValue(connectionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUbeeoConnection>>, TError, TData>
}

export type GetUbeeoConnectionQueryResult = NonNullable<Awaited<ReturnType<typeof getUbeeoConnection>>>
export type GetUbeeoConnectionQueryError = ProblemDetails



export function useGetUbeeoConnection<TData = Awaited<ReturnType<typeof getUbeeoConnection>>, TError = ProblemDetails>(
 connectionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUbeeoConnection>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUbeeoConnectionQueryOptions(connectionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getRequestPasswordResetUrl = () => {




  return `/employer/auth/request-password-reset`
}

/**
 * @summary Request a password reset email for the given email address.
Always returns 200 to prevent email enumeration.
 */
export const requestPasswordReset = async (sendPasswordResetEmailCommandDto?: SendPasswordResetEmailCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<void>(getRequestPasswordResetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(sendPasswordResetEmailCommandDto)
  }
);}





export const getRequestPasswordResetMutationKey = () => ['requestPasswordReset'] as const;

export const getRequestPasswordResetMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestPasswordReset>>, TError,RequestPasswordResetMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof requestPasswordReset>>, TError,RequestPasswordResetMutationVariables, TContext> => {

const mutationKey = getRequestPasswordResetMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestPasswordReset>>, RequestPasswordResetMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  requestPasswordReset(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestPasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof requestPasswordReset>>>
    export type RequestPasswordResetMutationBody = SendPasswordResetEmailCommandDto | undefined
    export type RequestPasswordResetMutationError = ProblemDetails
    export type RequestPasswordResetMutationVariables = {data?: SendPasswordResetEmailCommandDto}

    /**
 * @summary Request a password reset email for the given email address.
Always returns 200 to prevent email enumeration.
 */
export const useRequestPasswordReset = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestPasswordReset>>, TError,RequestPasswordResetMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof requestPasswordReset>>,
        TError,
        RequestPasswordResetMutationVariables,
        TContext
      > => {
      return useMutation(getRequestPasswordResetMutationOptions(options), queryClient);
    }

export const getCreateEmployerInviteUrl = () => {




  return `/admin/employer/create-employer-invite/employer`
}

export const createEmployerInvite = async (createEmployerInviteCommandDto?: CreateEmployerInviteCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<void>(getCreateEmployerInviteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createEmployerInviteCommandDto)
  }
);}





export const getCreateEmployerInviteMutationKey = () => ['createEmployerInvite'] as const;

export const getCreateEmployerInviteMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployerInvite>>, TError,CreateEmployerInviteMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof createEmployerInvite>>, TError,CreateEmployerInviteMutationVariables, TContext> => {

const mutationKey = getCreateEmployerInviteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEmployerInvite>>, CreateEmployerInviteMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createEmployerInvite(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateEmployerInviteMutationResult = NonNullable<Awaited<ReturnType<typeof createEmployerInvite>>>
    export type CreateEmployerInviteMutationBody = CreateEmployerInviteCommandDto | undefined
    export type CreateEmployerInviteMutationError = ProblemDetails
    export type CreateEmployerInviteMutationVariables = {data?: CreateEmployerInviteCommandDto}

    export const useCreateEmployerInvite = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployerInvite>>, TError,CreateEmployerInviteMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createEmployerInvite>>,
        TError,
        CreateEmployerInviteMutationVariables,
        TContext
      > => {
      return useMutation(getCreateEmployerInviteMutationOptions(options), queryClient);
    }

export const getCreateTeammateInviteUrl = () => {




  return `/admin/employer/create-teammate-invite/teammate`
}

export const createTeammateInvite = async (createTeammateInviteCommandDto?: CreateTeammateInviteCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<void>(getCreateTeammateInviteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createTeammateInviteCommandDto)
  }
);}





export const getCreateTeammateInviteMutationKey = () => ['createTeammateInvite'] as const;

export const getCreateTeammateInviteMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTeammateInvite>>, TError,CreateTeammateInviteMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof createTeammateInvite>>, TError,CreateTeammateInviteMutationVariables, TContext> => {

const mutationKey = getCreateTeammateInviteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTeammateInvite>>, CreateTeammateInviteMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createTeammateInvite(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTeammateInviteMutationResult = NonNullable<Awaited<ReturnType<typeof createTeammateInvite>>>
    export type CreateTeammateInviteMutationBody = CreateTeammateInviteCommandDto | undefined
    export type CreateTeammateInviteMutationError = ProblemDetails
    export type CreateTeammateInviteMutationVariables = {data?: CreateTeammateInviteCommandDto}

    export const useCreateTeammateInvite = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTeammateInvite>>, TError,CreateTeammateInviteMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createTeammateInvite>>,
        TError,
        CreateTeammateInviteMutationVariables,
        TContext
      > => {
      return useMutation(getCreateTeammateInviteMutationOptions(options), queryClient);
    }

export const getListReferralInvitesUrl = () => {




  return `/admin/employer/list-referral-invites`
}

export const listReferralInvites = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListReferralInvitesResult> => {

  return fetchWithAuth<ListReferralInvitesResult>(getListReferralInvitesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListReferralInvitesQueryKey = () => {
    return [
    'admin','employer','list-referral-invites'
    ] as const;
    }


export const getListReferralInvitesQueryOptions = <TData = Awaited<ReturnType<typeof listReferralInvites>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReferralInvites>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListReferralInvitesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listReferralInvites>>> = ({ signal }) => listReferralInvites({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listReferralInvites>>, TError, TData>
}

export type ListReferralInvitesQueryResult = NonNullable<Awaited<ReturnType<typeof listReferralInvites>>>
export type ListReferralInvitesQueryError = unknown



export function useListReferralInvites<TData = Awaited<ReturnType<typeof listReferralInvites>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReferralInvites>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListReferralInvitesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getDeleteTeammateUrl = () => {




  return `/admin/employer/delete-teammate/teammate`
}

export const deleteTeammate = async (deleteEmployerCommandDto?: DeleteEmployerCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<void>(getDeleteTeammateUrl(),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deleteEmployerCommandDto)
  }
);}





export const getDeleteTeammateMutationKey = () => ['deleteTeammate'] as const;

export const getDeleteTeammateMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeammate>>, TError,DeleteTeammateMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTeammate>>, TError,DeleteTeammateMutationVariables, TContext> => {

const mutationKey = getDeleteTeammateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTeammate>>, DeleteTeammateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  deleteTeammate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTeammateMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTeammate>>>
    export type DeleteTeammateMutationBody = DeleteEmployerCommandDto | undefined
    export type DeleteTeammateMutationError = ProblemDetails
    export type DeleteTeammateMutationVariables = {data?: DeleteEmployerCommandDto}

    export const useDeleteTeammate = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeammate>>, TError,DeleteTeammateMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteTeammate>>,
        TError,
        DeleteTeammateMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteTeammateMutationOptions(options), queryClient);
    }

export const getGetEmployerAccessUrl = () => {




  return `/employer/profile/access`
}

export const getEmployerAccess = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetEmployerAccessResult> => {

  return fetchWithAuth<GetEmployerAccessResult>(getGetEmployerAccessUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEmployerAccessQueryKey = () => {
    return [
    'employer','profile','access'
    ] as const;
    }


export const getGetEmployerAccessQueryOptions = <TData = Awaited<ReturnType<typeof getEmployerAccess>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerAccess>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetEmployerAccessQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployerAccess>>> = ({ signal }) => getEmployerAccess({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployerAccess>>, TError, TData>
}

export type GetEmployerAccessQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployerAccess>>>
export type GetEmployerAccessQueryError = ProblemDetails



export function useGetEmployerAccess<TData = Awaited<ReturnType<typeof getEmployerAccess>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerAccess>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployerAccessQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetProfileUrl = () => {




  return `/employer/profile`
}

export const getProfile = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetEmployerProfileResult> => {

  return fetchWithAuth<GetEmployerProfileResult>(getGetProfileUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProfileQueryKey = () => {
    return [
    'employer','profile'
    ] as const;
    }


export const getGetProfileQueryOptions = <TData = Awaited<ReturnType<typeof getProfile>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetProfileQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfile>>> = ({ signal }) => getProfile({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>
}

export type GetProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getProfile>>>
export type GetProfileQueryError = ProblemDetails



export function useGetProfile<TData = Awaited<ReturnType<typeof getProfile>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProfileQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getUpdateProfileUrl = () => {




  return `/employer/profile`
}

export const updateProfile = async (updateEmployerProfileCommandDto?: UpdateEmployerProfileCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<number> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<number>(getUpdateProfileUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateEmployerProfileCommandDto)
  }
);}





export const getUpdateProfileMutationKey = () => ['updateProfile'] as const;

export const getUpdateProfileMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,UpdateProfileMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,UpdateProfileMutationVariables, TContext> => {

const mutationKey = getUpdateProfileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProfile>>, UpdateProfileMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateProfile>>>
    export type UpdateProfileMutationBody = UpdateEmployerProfileCommandDto | undefined
    export type UpdateProfileMutationError = ProblemDetails
    export type UpdateProfileMutationVariables = {data?: UpdateEmployerProfileCommandDto}

    export const useUpdateProfile = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,UpdateProfileMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateProfile>>,
        TError,
        UpdateProfileMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateProfileMutationOptions(options), queryClient);
    }

export const getUploadEmployerProfilePictureUrl = () => {




  return `/employer/profile/picture`
}

export const uploadEmployerProfilePicture = async (uploadEmployerProfilePictureBody?: UploadEmployerProfilePictureBody, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ImageDto> => {
    const formData = new FormData();
if(uploadEmployerProfilePictureBody?.File !== undefined) {
 formData.append(`File`, uploadEmployerProfilePictureBody.File);
 }

  return fetchWithAuth<ImageDto>(getUploadEmployerProfilePictureUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getUploadEmployerProfilePictureMutationKey = () => ['uploadEmployerProfilePicture'] as const;

export const getUploadEmployerProfilePictureMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadEmployerProfilePicture>>, TError,UploadEmployerProfilePictureMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadEmployerProfilePicture>>, TError,UploadEmployerProfilePictureMutationVariables, TContext> => {

const mutationKey = getUploadEmployerProfilePictureMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadEmployerProfilePicture>>, UploadEmployerProfilePictureMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  uploadEmployerProfilePicture(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadEmployerProfilePictureMutationResult = NonNullable<Awaited<ReturnType<typeof uploadEmployerProfilePicture>>>
    export type UploadEmployerProfilePictureMutationBody = UploadEmployerProfilePictureBody | undefined
    export type UploadEmployerProfilePictureMutationError = ProblemDetails
    export type UploadEmployerProfilePictureMutationVariables = {data?: UploadEmployerProfilePictureBody}

    export const useUploadEmployerProfilePicture = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadEmployerProfilePicture>>, TError,UploadEmployerProfilePictureMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof uploadEmployerProfilePicture>>,
        TError,
        UploadEmployerProfilePictureMutationVariables,
        TContext
      > => {
      return useMutation(getUploadEmployerProfilePictureMutationOptions(options), queryClient);
    }

export const getGetStatisticsUrl = () => {




  return `/employer/dashboard/statistics`
}

export const getStatistics = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetCompanyStatisticsResult> => {

  return fetchWithAuth<GetCompanyStatisticsResult>(getGetStatisticsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStatisticsQueryKey = () => {
    return [
    'employer','dashboard','statistics'
    ] as const;
    }


export const getGetStatisticsQueryOptions = <TData = Awaited<ReturnType<typeof getStatistics>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatistics>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetStatisticsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStatistics>>> = ({ signal }) => getStatistics({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStatistics>>, TError, TData>
}

export type GetStatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof getStatistics>>>
export type GetStatisticsQueryError = unknown



export function useGetStatistics<TData = Awaited<ReturnType<typeof getStatistics>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatistics>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStatisticsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListUnhandledJobsUrl = (params?: ListUnhandledJobsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/employer/dashboard/unhandled-jobs?${stringifiedParams}` : `/employer/dashboard/unhandled-jobs`
}

export const listUnhandledJobs = async (params?: ListUnhandledJobsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListUnhandledJobsResult> => {

  return fetchWithAuth<ListUnhandledJobsResult>(getListUnhandledJobsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListUnhandledJobsQueryKey = (params?: MaybeRefOrGetter<ListUnhandledJobsParams>,) => {
    return [
    'employer','dashboard','unhandled-jobs', ...(params ? [params] : [])
    ] as const;
    }


export const getListUnhandledJobsQueryOptions = <TData = Awaited<ReturnType<typeof listUnhandledJobs>>, TError = unknown>(params?: MaybeRefOrGetter<ListUnhandledJobsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUnhandledJobs>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListUnhandledJobsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUnhandledJobs>>> = ({ signal }) => listUnhandledJobs(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUnhandledJobs>>, TError, TData>
}

export type ListUnhandledJobsQueryResult = NonNullable<Awaited<ReturnType<typeof listUnhandledJobs>>>
export type ListUnhandledJobsQueryError = unknown



export function useListUnhandledJobs<TData = Awaited<ReturnType<typeof listUnhandledJobs>>, TError = unknown>(
 params?: MaybeRefOrGetter<ListUnhandledJobsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUnhandledJobs>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUnhandledJobsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetConferenceInfoUrl = () => {




  return `/employer/conference`
}

export const getConferenceInfo = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetConferenceInfoResult> => {

  return fetchWithAuth<GetConferenceInfoResult>(getGetConferenceInfoUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetConferenceInfoQueryKey = () => {
    return [
    'employer','conference'
    ] as const;
    }


export const getGetConferenceInfoQueryOptions = <TData = Awaited<ReturnType<typeof getConferenceInfo>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConferenceInfo>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetConferenceInfoQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConferenceInfo>>> = ({ signal }) => getConferenceInfo({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConferenceInfo>>, TError, TData>
}

export type GetConferenceInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getConferenceInfo>>>
export type GetConferenceInfoQueryError = ProblemDetails



export function useGetConferenceInfo<TData = Awaited<ReturnType<typeof getConferenceInfo>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConferenceInfo>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConferenceInfoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListConferenceChatsEmployerUrl = (params: ListConferenceChatsEmployerParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/employer/conference/chat?${stringifiedParams}` : `/employer/conference/chat`
}

export const listConferenceChatsEmployer = async (params: ListConferenceChatsEmployerParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListConferenceChatsResult> => {

  return fetchWithAuth<ListConferenceChatsResult>(getListConferenceChatsEmployerUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListConferenceChatsEmployerQueryKey = (params?: MaybeRefOrGetter<ListConferenceChatsEmployerParams>,) => {
    return [
    'employer','conference','chat', ...(params ? [params] : [])
    ] as const;
    }


export const getListConferenceChatsEmployerQueryOptions = <TData = Awaited<ReturnType<typeof listConferenceChatsEmployer>>, TError = unknown>(params: MaybeRefOrGetter<ListConferenceChatsEmployerParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConferenceChatsEmployer>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListConferenceChatsEmployerQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listConferenceChatsEmployer>>> = ({ signal }) => listConferenceChatsEmployer(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listConferenceChatsEmployer>>, TError, TData>
}

export type ListConferenceChatsEmployerQueryResult = NonNullable<Awaited<ReturnType<typeof listConferenceChatsEmployer>>>
export type ListConferenceChatsEmployerQueryError = unknown



export function useListConferenceChatsEmployer<TData = Awaited<ReturnType<typeof listConferenceChatsEmployer>>, TError = unknown>(
 params: MaybeRefOrGetter<ListConferenceChatsEmployerParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConferenceChatsEmployer>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListConferenceChatsEmployerQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getSendConferenceChatMessageEmployerUrl = () => {




  return `/employer/conference/chat`
}

export const sendConferenceChatMessageEmployer = async (sendMessageCommandDto?: SendMessageCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ChatMessageDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<ChatMessageDto>(getSendConferenceChatMessageEmployerUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(sendMessageCommandDto)
  }
);}





export const getSendConferenceChatMessageEmployerMutationKey = () => ['sendConferenceChatMessageEmployer'] as const;

export const getSendConferenceChatMessageEmployerMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendConferenceChatMessageEmployer>>, TError,SendConferenceChatMessageEmployerMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof sendConferenceChatMessageEmployer>>, TError,SendConferenceChatMessageEmployerMutationVariables, TContext> => {

const mutationKey = getSendConferenceChatMessageEmployerMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendConferenceChatMessageEmployer>>, SendConferenceChatMessageEmployerMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  sendConferenceChatMessageEmployer(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendConferenceChatMessageEmployerMutationResult = NonNullable<Awaited<ReturnType<typeof sendConferenceChatMessageEmployer>>>
    export type SendConferenceChatMessageEmployerMutationBody = SendMessageCommandDto | undefined
    export type SendConferenceChatMessageEmployerMutationError = ProblemDetails
    export type SendConferenceChatMessageEmployerMutationVariables = {data?: SendMessageCommandDto}

    export const useSendConferenceChatMessageEmployer = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendConferenceChatMessageEmployer>>, TError,SendConferenceChatMessageEmployerMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sendConferenceChatMessageEmployer>>,
        TError,
        SendConferenceChatMessageEmployerMutationVariables,
        TContext
      > => {
      return useMutation(getSendConferenceChatMessageEmployerMutationOptions(options), queryClient);
    }

export const getListUnreadConferenceChatsEmployerUrl = (params: ListUnreadConferenceChatsEmployerParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/employer/conference/chat-unread?${stringifiedParams}` : `/employer/conference/chat-unread`
}

export const listUnreadConferenceChatsEmployer = async (params: ListUnreadConferenceChatsEmployerParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListUnreadConferenceChatsResult> => {

  return fetchWithAuth<ListUnreadConferenceChatsResult>(getListUnreadConferenceChatsEmployerUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListUnreadConferenceChatsEmployerQueryKey = (params?: MaybeRefOrGetter<ListUnreadConferenceChatsEmployerParams>,) => {
    return [
    'employer','conference','chat-unread', ...(params ? [params] : [])
    ] as const;
    }


export const getListUnreadConferenceChatsEmployerQueryOptions = <TData = Awaited<ReturnType<typeof listUnreadConferenceChatsEmployer>>, TError = unknown>(params: MaybeRefOrGetter<ListUnreadConferenceChatsEmployerParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUnreadConferenceChatsEmployer>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListUnreadConferenceChatsEmployerQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUnreadConferenceChatsEmployer>>> = ({ signal }) => listUnreadConferenceChatsEmployer(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUnreadConferenceChatsEmployer>>, TError, TData>
}

export type ListUnreadConferenceChatsEmployerQueryResult = NonNullable<Awaited<ReturnType<typeof listUnreadConferenceChatsEmployer>>>
export type ListUnreadConferenceChatsEmployerQueryError = unknown



export function useListUnreadConferenceChatsEmployer<TData = Awaited<ReturnType<typeof listUnreadConferenceChatsEmployer>>, TError = unknown>(
 params: MaybeRefOrGetter<ListUnreadConferenceChatsEmployerParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUnreadConferenceChatsEmployer>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUnreadConferenceChatsEmployerQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetConferenceChatWithMessagesForEmployerUrl = (chatId: number,) => {




  return `/employer/conference/chat/${chatId}`
}

export const getConferenceChatWithMessagesForEmployer = async (chatId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetConferenceChatWithMessagesForEmployerResult> => {

  return fetchWithAuth<GetConferenceChatWithMessagesForEmployerResult>(getGetConferenceChatWithMessagesForEmployerUrl(chatId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetConferenceChatWithMessagesForEmployerQueryKey = (chatId: MaybeRefOrGetter<number>,) => {
    return [
    'employer','conference','chat',chatId
    ] as const;
    }


export const getGetConferenceChatWithMessagesForEmployerQueryOptions = <TData = Awaited<ReturnType<typeof getConferenceChatWithMessagesForEmployer>>, TError = ProblemDetails>(chatId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConferenceChatWithMessagesForEmployer>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetConferenceChatWithMessagesForEmployerQueryKey(chatId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConferenceChatWithMessagesForEmployer>>> = ({ signal }) => getConferenceChatWithMessagesForEmployer(toValue(chatId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(chatId) !== null && toValue(chatId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConferenceChatWithMessagesForEmployer>>, TError, TData>
}

export type GetConferenceChatWithMessagesForEmployerQueryResult = NonNullable<Awaited<ReturnType<typeof getConferenceChatWithMessagesForEmployer>>>
export type GetConferenceChatWithMessagesForEmployerQueryError = ProblemDetails



export function useGetConferenceChatWithMessagesForEmployer<TData = Awaited<ReturnType<typeof getConferenceChatWithMessagesForEmployer>>, TError = ProblemDetails>(
 chatId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConferenceChatWithMessagesForEmployer>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConferenceChatWithMessagesForEmployerQueryOptions(chatId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListManagedCompaniesUrl = () => {




  return `/employer/managed-company`
}

/**
 * @summary List the companies that an employer is allowed to manage
 */
export const listManagedCompanies = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListManagedCompaniesResult> => {

  return fetchWithAuth<ListManagedCompaniesResult>(getListManagedCompaniesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListManagedCompaniesQueryKey = () => {
    return [
    'employer','managed-company'
    ] as const;
    }


export const getListManagedCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof listManagedCompanies>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listManagedCompanies>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListManagedCompaniesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listManagedCompanies>>> = ({ signal }) => listManagedCompanies({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listManagedCompanies>>, TError, TData>
}

export type ListManagedCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof listManagedCompanies>>>
export type ListManagedCompaniesQueryError = unknown


/**
 * @summary List the companies that an employer is allowed to manage
 */

export function useListManagedCompanies<TData = Awaited<ReturnType<typeof listManagedCompanies>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listManagedCompanies>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListManagedCompaniesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getUpdateManagedCompanyUrl = () => {




  return `/employer/managed-company/update`
}

/**
 * @summary Update the company that an employer manages.
 */
export const updateManagedCompany = async (updateManagedCompanyBody?: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<void>(getUpdateManagedCompanyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateManagedCompanyBody)
  }
);}





export const getUpdateManagedCompanyMutationKey = () => ['updateManagedCompany'] as const;

export const getUpdateManagedCompanyMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateManagedCompany>>, TError,UpdateManagedCompanyMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateManagedCompany>>, TError,UpdateManagedCompanyMutationVariables, TContext> => {

const mutationKey = getUpdateManagedCompanyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateManagedCompany>>, UpdateManagedCompanyMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateManagedCompany(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateManagedCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof updateManagedCompany>>>
    export type UpdateManagedCompanyMutationBody = number | undefined
    export type UpdateManagedCompanyMutationError = ProblemDetails
    export type UpdateManagedCompanyMutationVariables = {data?: number}

    /**
 * @summary Update the company that an employer manages.
 */
export const useUpdateManagedCompany = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateManagedCompany>>, TError,UpdateManagedCompanyMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateManagedCompany>>,
        TError,
        UpdateManagedCompanyMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateManagedCompanyMutationOptions(options), queryClient);
    }

export const getResetManagedCompanyUrl = () => {




  return `/employer/managed-company/reset`
}

/**
 * @summary Reset the company of an employer.
 */
export const resetManagedCompany = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getResetManagedCompanyUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getResetManagedCompanyMutationKey = () => ['resetManagedCompany'] as const;

export const getResetManagedCompanyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetManagedCompany>>, TError,void, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof resetManagedCompany>>, TError,void, TContext> => {

const mutationKey = getResetManagedCompanyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetManagedCompany>>, void> = () => {


          return  resetManagedCompany(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetManagedCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof resetManagedCompany>>>

    export type ResetManagedCompanyMutationError = unknown


    /**
 * @summary Reset the company of an employer.
 */
export const useResetManagedCompany = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetManagedCompany>>, TError,void, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof resetManagedCompany>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getResetManagedCompanyMutationOptions(options), queryClient);
    }

export const getGetMyCompanyUrl = () => {




  return `/employer/company`
}

export const getMyCompany = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetCompanyFromPortalResult> => {

  return fetchWithAuth<GetCompanyFromPortalResult>(getGetMyCompanyUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyCompanyQueryKey = () => {
    return [
    'employer','company'
    ] as const;
    }


export const getGetMyCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getMyCompany>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyCompany>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetMyCompanyQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyCompany>>> = ({ signal }) => getMyCompany({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyCompany>>, TError, TData>
}

export type GetMyCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getMyCompany>>>
export type GetMyCompanyQueryError = ProblemDetails



export function useGetMyCompany<TData = Awaited<ReturnType<typeof getMyCompany>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyCompany>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyCompanyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getUpdateMyCompanyUrl = () => {




  return `/employer/company`
}

export const updateMyCompany = async (updateCompanyFromPortalCommandDto?: UpdateCompanyFromPortalCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<number> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<number>(getUpdateMyCompanyUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateCompanyFromPortalCommandDto)
  }
);}





export const getUpdateMyCompanyMutationKey = () => ['updateMyCompany'] as const;

export const getUpdateMyCompanyMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMyCompany>>, TError,UpdateMyCompanyMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMyCompany>>, TError,UpdateMyCompanyMutationVariables, TContext> => {

const mutationKey = getUpdateMyCompanyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMyCompany>>, UpdateMyCompanyMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateMyCompany(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMyCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof updateMyCompany>>>
    export type UpdateMyCompanyMutationBody = UpdateCompanyFromPortalCommandDto | undefined
    export type UpdateMyCompanyMutationError = ProblemDetails
    export type UpdateMyCompanyMutationVariables = {data?: UpdateCompanyFromPortalCommandDto}

    export const useUpdateMyCompany = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMyCompany>>, TError,UpdateMyCompanyMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateMyCompany>>,
        TError,
        UpdateMyCompanyMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateMyCompanyMutationOptions(options), queryClient);
    }

export const getDeleteMyCompanyUrl = () => {




  return `/employer/company`
}

/**
 * @summary Delete a Company.
This will close all related matches, jobs and other data.
 */
export const deleteMyCompany = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<number> => {

  return fetchWithAuth<number>(getDeleteMyCompanyUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteMyCompanyMutationKey = () => ['deleteMyCompany'] as const;

export const getDeleteMyCompanyMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMyCompany>>, TError,void, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMyCompany>>, TError,void, TContext> => {

const mutationKey = getDeleteMyCompanyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMyCompany>>, void> = () => {


          return  deleteMyCompany(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteMyCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMyCompany>>>

    export type DeleteMyCompanyMutationError = ProblemDetails


    /**
 * @summary Delete a Company.
This will close all related matches, jobs and other data.
 */
export const useDeleteMyCompany = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMyCompany>>, TError,void, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteMyCompany>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDeleteMyCompanyMutationOptions(options), queryClient);
    }

export const getGetMyCompanyPlanUrl = () => {




  return `/employer/company/plan`
}

export const getMyCompanyPlan = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetCompanyPlanResult> => {

  return fetchWithAuth<GetCompanyPlanResult>(getGetMyCompanyPlanUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyCompanyPlanQueryKey = () => {
    return [
    'employer','company','plan'
    ] as const;
    }


export const getGetMyCompanyPlanQueryOptions = <TData = Awaited<ReturnType<typeof getMyCompanyPlan>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyCompanyPlan>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetMyCompanyPlanQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyCompanyPlan>>> = ({ signal }) => getMyCompanyPlan({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyCompanyPlan>>, TError, TData>
}

export type GetMyCompanyPlanQueryResult = NonNullable<Awaited<ReturnType<typeof getMyCompanyPlan>>>
export type GetMyCompanyPlanQueryError = ProblemDetails



export function useGetMyCompanyPlan<TData = Awaited<ReturnType<typeof getMyCompanyPlan>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyCompanyPlan>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyCompanyPlanQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListEmployersForCompanyUrl = () => {




  return `/employer/company/employers`
}

export const listEmployersForCompany = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListOtherEmployersForCompanyResult> => {

  return fetchWithAuth<ListOtherEmployersForCompanyResult>(getListEmployersForCompanyUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEmployersForCompanyQueryKey = () => {
    return [
    'employer','company','employers'
    ] as const;
    }


export const getListEmployersForCompanyQueryOptions = <TData = Awaited<ReturnType<typeof listEmployersForCompany>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmployersForCompany>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListEmployersForCompanyQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEmployersForCompany>>> = ({ signal }) => listEmployersForCompany({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEmployersForCompany>>, TError, TData>
}

export type ListEmployersForCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof listEmployersForCompany>>>
export type ListEmployersForCompanyQueryError = unknown



export function useListEmployersForCompany<TData = Awaited<ReturnType<typeof listEmployersForCompany>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmployersForCompany>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEmployersForCompanyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getUpdateEmployerCompanyAccessUrl = () => {




  return `/employer/company/employer-company-access`
}

/**
 * @summary Update an employer's company access: the provided CompanyIds become the desired state.
Additions and removals are computed automatically. An empty array removes all child assignments.
The employer's role from the parent company is automatically copied to newly added child companies.
Only assignments within the specified parent company tree are valid.
 */
export const updateEmployerCompanyAccess = async (updateEmployerCompanyAccessCommandDto?: UpdateEmployerCompanyAccessCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<UpdateEmployerCompanyAccessResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<UpdateEmployerCompanyAccessResult>(getUpdateEmployerCompanyAccessUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateEmployerCompanyAccessCommandDto)
  }
);}





export const getUpdateEmployerCompanyAccessMutationKey = () => ['updateEmployerCompanyAccess'] as const;

export const getUpdateEmployerCompanyAccessMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployerCompanyAccess>>, TError,UpdateEmployerCompanyAccessMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmployerCompanyAccess>>, TError,UpdateEmployerCompanyAccessMutationVariables, TContext> => {

const mutationKey = getUpdateEmployerCompanyAccessMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmployerCompanyAccess>>, UpdateEmployerCompanyAccessMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateEmployerCompanyAccess(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmployerCompanyAccessMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmployerCompanyAccess>>>
    export type UpdateEmployerCompanyAccessMutationBody = UpdateEmployerCompanyAccessCommandDto | undefined
    export type UpdateEmployerCompanyAccessMutationError = ProblemDetails
    export type UpdateEmployerCompanyAccessMutationVariables = {data?: UpdateEmployerCompanyAccessCommandDto}

    /**
 * @summary Update an employer's company access: the provided CompanyIds become the desired state.
Additions and removals are computed automatically. An empty array removes all child assignments.
The employer's role from the parent company is automatically copied to newly added child companies.
Only assignments within the specified parent company tree are valid.
 */
export const useUpdateEmployerCompanyAccess = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployerCompanyAccess>>, TError,UpdateEmployerCompanyAccessMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateEmployerCompanyAccess>>,
        TError,
        UpdateEmployerCompanyAccessMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateEmployerCompanyAccessMutationOptions(options), queryClient);
    }

export const getAddOrUpdateDefaultMessageUrl = () => {




  return `/employer/company/default-messages`
}

export const addOrUpdateDefaultMessage = async (addOrUpdateDefaultMessageCommandDto?: AddOrUpdateDefaultMessageCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<AddOrUpdateDefaultMessageResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<AddOrUpdateDefaultMessageResult>(getAddOrUpdateDefaultMessageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addOrUpdateDefaultMessageCommandDto)
  }
);}





export const getAddOrUpdateDefaultMessageMutationKey = () => ['addOrUpdateDefaultMessage'] as const;

export const getAddOrUpdateDefaultMessageMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addOrUpdateDefaultMessage>>, TError,AddOrUpdateDefaultMessageMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof addOrUpdateDefaultMessage>>, TError,AddOrUpdateDefaultMessageMutationVariables, TContext> => {

const mutationKey = getAddOrUpdateDefaultMessageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addOrUpdateDefaultMessage>>, AddOrUpdateDefaultMessageMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  addOrUpdateDefaultMessage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddOrUpdateDefaultMessageMutationResult = NonNullable<Awaited<ReturnType<typeof addOrUpdateDefaultMessage>>>
    export type AddOrUpdateDefaultMessageMutationBody = AddOrUpdateDefaultMessageCommandDto | undefined
    export type AddOrUpdateDefaultMessageMutationError = ProblemDetails
    export type AddOrUpdateDefaultMessageMutationVariables = {data?: AddOrUpdateDefaultMessageCommandDto}

    export const useAddOrUpdateDefaultMessage = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addOrUpdateDefaultMessage>>, TError,AddOrUpdateDefaultMessageMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof addOrUpdateDefaultMessage>>,
        TError,
        AddOrUpdateDefaultMessageMutationVariables,
        TContext
      > => {
      return useMutation(getAddOrUpdateDefaultMessageMutationOptions(options), queryClient);
    }

export const getDeleteDefaultMessageUrl = (id: number,) => {




  return `/employer/company/default-messages/${id}`
}

export const deleteDefaultMessage = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<DeleteDefaultMessageResult> => {

  return fetchWithAuth<DeleteDefaultMessageResult>(getDeleteDefaultMessageUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteDefaultMessageMutationKey = () => ['deleteDefaultMessage'] as const;

export const getDeleteDefaultMessageMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDefaultMessage>>, TError,DeleteDefaultMessageMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDefaultMessage>>, TError,DeleteDefaultMessageMutationVariables, TContext> => {

const mutationKey = getDeleteDefaultMessageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDefaultMessage>>, DeleteDefaultMessageMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteDefaultMessage(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDefaultMessageMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDefaultMessage>>>

    export type DeleteDefaultMessageMutationError = ProblemDetails
    export type DeleteDefaultMessageMutationVariables = {id: number}

    export const useDeleteDefaultMessage = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDefaultMessage>>, TError,DeleteDefaultMessageMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteDefaultMessage>>,
        TError,
        DeleteDefaultMessageMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteDefaultMessageMutationOptions(options), queryClient);
    }

export const getUploadProvisionalImageUrl = () => {




  return `/employer/company/provisional-image`
}

/**
 * @summary Upload Provisional Company Image
 */
export const uploadProvisionalImage = async (uploadProvisionalImageBody?: UploadProvisionalImageBody, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ImageDto> => {
    const formData = new FormData();
if(uploadProvisionalImageBody?.File !== undefined) {
 formData.append(`File`, uploadProvisionalImageBody.File);
 }

  return fetchWithAuth<ImageDto>(getUploadProvisionalImageUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getUploadProvisionalImageMutationKey = () => ['uploadProvisionalImage'] as const;

export const getUploadProvisionalImageMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadProvisionalImage>>, TError,UploadProvisionalImageMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadProvisionalImage>>, TError,UploadProvisionalImageMutationVariables, TContext> => {

const mutationKey = getUploadProvisionalImageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadProvisionalImage>>, UploadProvisionalImageMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  uploadProvisionalImage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadProvisionalImageMutationResult = NonNullable<Awaited<ReturnType<typeof uploadProvisionalImage>>>
    export type UploadProvisionalImageMutationBody = UploadProvisionalImageBody | undefined
    export type UploadProvisionalImageMutationError = ProblemDetails
    export type UploadProvisionalImageMutationVariables = {data?: UploadProvisionalImageBody}

    /**
 * @summary Upload Provisional Company Image
 */
export const useUploadProvisionalImage = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadProvisionalImage>>, TError,UploadProvisionalImageMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof uploadProvisionalImage>>,
        TError,
        UploadProvisionalImageMutationVariables,
        TContext
      > => {
      return useMutation(getUploadProvisionalImageMutationOptions(options), queryClient);
    }

export const getSendRequestToAccountManagerUrl = () => {




  return `/employer/company/send-account-manager-request`
}

export const sendRequestToAccountManager = async (sendRequestToAccountManagerCommandDto?: SendRequestToAccountManagerCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<Unit>(getSendRequestToAccountManagerUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(sendRequestToAccountManagerCommandDto)
  }
);}





export const getSendRequestToAccountManagerMutationKey = () => ['sendRequestToAccountManager'] as const;

export const getSendRequestToAccountManagerMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendRequestToAccountManager>>, TError,SendRequestToAccountManagerMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof sendRequestToAccountManager>>, TError,SendRequestToAccountManagerMutationVariables, TContext> => {

const mutationKey = getSendRequestToAccountManagerMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendRequestToAccountManager>>, SendRequestToAccountManagerMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  sendRequestToAccountManager(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendRequestToAccountManagerMutationResult = NonNullable<Awaited<ReturnType<typeof sendRequestToAccountManager>>>
    export type SendRequestToAccountManagerMutationBody = SendRequestToAccountManagerCommandDto | undefined
    export type SendRequestToAccountManagerMutationError = ProblemDetails
    export type SendRequestToAccountManagerMutationVariables = {data?: SendRequestToAccountManagerCommandDto}

    export const useSendRequestToAccountManager = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendRequestToAccountManager>>, TError,SendRequestToAccountManagerMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sendRequestToAccountManager>>,
        TError,
        SendRequestToAccountManagerMutationVariables,
        TContext
      > => {
      return useMutation(getSendRequestToAccountManagerMutationOptions(options), queryClient);
    }

export const getUpdateDefaultCandidatePoolUrl = () => {




  return `/employer/company/update-default-candidate-pool`
}

/**
 * @summary Update the default candidate pool size for the company
 */
export const updateDefaultCandidatePool = async (updateDefaultCandidatePoolCommandDto?: UpdateDefaultCandidatePoolCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<Unit>(getUpdateDefaultCandidatePoolUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateDefaultCandidatePoolCommandDto)
  }
);}





export const getUpdateDefaultCandidatePoolMutationKey = () => ['updateDefaultCandidatePool'] as const;

export const getUpdateDefaultCandidatePoolMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDefaultCandidatePool>>, TError,UpdateDefaultCandidatePoolMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDefaultCandidatePool>>, TError,UpdateDefaultCandidatePoolMutationVariables, TContext> => {

const mutationKey = getUpdateDefaultCandidatePoolMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDefaultCandidatePool>>, UpdateDefaultCandidatePoolMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateDefaultCandidatePool(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDefaultCandidatePoolMutationResult = NonNullable<Awaited<ReturnType<typeof updateDefaultCandidatePool>>>
    export type UpdateDefaultCandidatePoolMutationBody = UpdateDefaultCandidatePoolCommandDto | undefined
    export type UpdateDefaultCandidatePoolMutationError = ProblemDetails
    export type UpdateDefaultCandidatePoolMutationVariables = {data?: UpdateDefaultCandidatePoolCommandDto}

    /**
 * @summary Update the default candidate pool size for the company
 */
export const useUpdateDefaultCandidatePool = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDefaultCandidatePool>>, TError,UpdateDefaultCandidatePoolMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateDefaultCandidatePool>>,
        TError,
        UpdateDefaultCandidatePoolMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateDefaultCandidatePoolMutationOptions(options), queryClient);
    }

export const getUpdateCalendarInviteBodyUrl = () => {




  return `/employer/company/update-calendar-invite-body`
}

export const updateCalendarInviteBody = async (updateCalendarInviteBodyCommandDto?: UpdateCalendarInviteBodyCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<Unit>(getUpdateCalendarInviteBodyUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateCalendarInviteBodyCommandDto)
  }
);}





export const getUpdateCalendarInviteBodyMutationKey = () => ['updateCalendarInviteBody'] as const;

export const getUpdateCalendarInviteBodyMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCalendarInviteBody>>, TError,UpdateCalendarInviteBodyMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCalendarInviteBody>>, TError,UpdateCalendarInviteBodyMutationVariables, TContext> => {

const mutationKey = getUpdateCalendarInviteBodyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCalendarInviteBody>>, UpdateCalendarInviteBodyMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateCalendarInviteBody(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCalendarInviteBodyMutationResult = NonNullable<Awaited<ReturnType<typeof updateCalendarInviteBody>>>
    export type UpdateCalendarInviteBodyMutationBody = UpdateCalendarInviteBodyCommandDto | undefined
    export type UpdateCalendarInviteBodyMutationError = ProblemDetails
    export type UpdateCalendarInviteBodyMutationVariables = {data?: UpdateCalendarInviteBodyCommandDto}

    export const useUpdateCalendarInviteBody = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCalendarInviteBody>>, TError,UpdateCalendarInviteBodyMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateCalendarInviteBody>>,
        TError,
        UpdateCalendarInviteBodyMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateCalendarInviteBodyMutationOptions(options), queryClient);
    }

export const getGetCompanyHireReportInfoUrl = () => {




  return `/employer/hire-report`
}

export const getCompanyHireReportInfo = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetCompanyHireReportInfoResult> => {

  return fetchWithAuth<GetCompanyHireReportInfoResult>(getGetCompanyHireReportInfoUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCompanyHireReportInfoQueryKey = () => {
    return [
    'employer','hire-report'
    ] as const;
    }


export const getGetCompanyHireReportInfoQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyHireReportInfo>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyHireReportInfo>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetCompanyHireReportInfoQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyHireReportInfo>>> = ({ signal }) => getCompanyHireReportInfo({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyHireReportInfo>>, TError, TData>
}

export type GetCompanyHireReportInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyHireReportInfo>>>
export type GetCompanyHireReportInfoQueryError = unknown



export function useGetCompanyHireReportInfo<TData = Awaited<ReturnType<typeof getCompanyHireReportInfo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyHireReportInfo>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyHireReportInfoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getCreateCompanyHireReportUrl = () => {




  return `/employer/hire-report`
}

export const createCompanyHireReport = async (createCompanyHireReportCommandDto?: CreateCompanyHireReportCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<CreateCompanyHireReport> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<CreateCompanyHireReport>(getCreateCompanyHireReportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createCompanyHireReportCommandDto)
  }
);}





export const getCreateCompanyHireReportMutationKey = () => ['createCompanyHireReport'] as const;

export const getCreateCompanyHireReportMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompanyHireReport>>, TError,CreateCompanyHireReportMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof createCompanyHireReport>>, TError,CreateCompanyHireReportMutationVariables, TContext> => {

const mutationKey = getCreateCompanyHireReportMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCompanyHireReport>>, CreateCompanyHireReportMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createCompanyHireReport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCompanyHireReportMutationResult = NonNullable<Awaited<ReturnType<typeof createCompanyHireReport>>>
    export type CreateCompanyHireReportMutationBody = CreateCompanyHireReportCommandDto | undefined
    export type CreateCompanyHireReportMutationError = ProblemDetails
    export type CreateCompanyHireReportMutationVariables = {data?: CreateCompanyHireReportCommandDto}

    export const useCreateCompanyHireReport = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompanyHireReport>>, TError,CreateCompanyHireReportMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createCompanyHireReport>>,
        TError,
        CreateCompanyHireReportMutationVariables,
        TContext
      > => {
      return useMutation(getCreateCompanyHireReportMutationOptions(options), queryClient);
    }

export const getSetMatchingConfigurationUrl = () => {




  return `/employer/company-matching-configuration`
}

export const setMatchingConfiguration = async (setCompanyMatchingConfigurationCommandDto?: SetCompanyMatchingConfigurationCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<void>(getSetMatchingConfigurationUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setCompanyMatchingConfigurationCommandDto)
  }
);}





export const getSetMatchingConfigurationMutationKey = () => ['setMatchingConfiguration'] as const;

export const getSetMatchingConfigurationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setMatchingConfiguration>>, TError,SetMatchingConfigurationMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof setMatchingConfiguration>>, TError,SetMatchingConfigurationMutationVariables, TContext> => {

const mutationKey = getSetMatchingConfigurationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setMatchingConfiguration>>, SetMatchingConfigurationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setMatchingConfiguration(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetMatchingConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof setMatchingConfiguration>>>
    export type SetMatchingConfigurationMutationBody = SetCompanyMatchingConfigurationCommandDto | undefined
    export type SetMatchingConfigurationMutationError = ProblemDetails
    export type SetMatchingConfigurationMutationVariables = {data?: SetCompanyMatchingConfigurationCommandDto}

    export const useSetMatchingConfiguration = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setMatchingConfiguration>>, TError,SetMatchingConfigurationMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof setMatchingConfiguration>>,
        TError,
        SetMatchingConfigurationMutationVariables,
        TContext
      > => {
      return useMutation(getSetMatchingConfigurationMutationOptions(options), queryClient);
    }

export const getResetMatchingConfigurationUrl = () => {




  return `/employer/company-matching-configuration`
}

export const resetMatchingConfiguration = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getResetMatchingConfigurationUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getResetMatchingConfigurationMutationKey = () => ['resetMatchingConfiguration'] as const;

export const getResetMatchingConfigurationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetMatchingConfiguration>>, TError,void, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof resetMatchingConfiguration>>, TError,void, TContext> => {

const mutationKey = getResetMatchingConfigurationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetMatchingConfiguration>>, void> = () => {


          return  resetMatchingConfiguration(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetMatchingConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof resetMatchingConfiguration>>>

    export type ResetMatchingConfigurationMutationError = ProblemDetails


    export const useResetMatchingConfiguration = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetMatchingConfiguration>>, TError,void, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof resetMatchingConfiguration>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getResetMatchingConfigurationMutationOptions(options), queryClient);
    }

export const getGetMatchingConfigurationUrl = () => {




  return `/employer/company-matching-configuration`
}

export const getMatchingConfiguration = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetCompanyMatchingConfigurationResult> => {

  return fetchWithAuth<GetCompanyMatchingConfigurationResult>(getGetMatchingConfigurationUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMatchingConfigurationQueryKey = () => {
    return [
    'employer','company-matching-configuration'
    ] as const;
    }


export const getGetMatchingConfigurationQueryOptions = <TData = Awaited<ReturnType<typeof getMatchingConfiguration>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMatchingConfiguration>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetMatchingConfigurationQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMatchingConfiguration>>> = ({ signal }) => getMatchingConfiguration({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMatchingConfiguration>>, TError, TData>
}

export type GetMatchingConfigurationQueryResult = NonNullable<Awaited<ReturnType<typeof getMatchingConfiguration>>>
export type GetMatchingConfigurationQueryError = ProblemDetails



export function useGetMatchingConfiguration<TData = Awaited<ReturnType<typeof getMatchingConfiguration>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMatchingConfiguration>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMatchingConfigurationQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getRequestLoginLinkUrl = () => {




  return `/employer/authentication/login-link`
}

/**
 * @summary Request a login link to be sent to the user's email via jwt token
Currently only for employers with auth provider Internal Jwt aka Lead employers
 */
export const requestLoginLink = async (requestLoginLinkBody?: string, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<void>(getRequestLoginLinkUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(requestLoginLinkBody)
  }
);}





export const getRequestLoginLinkMutationKey = () => ['requestLoginLink'] as const;

export const getRequestLoginLinkMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestLoginLink>>, TError,RequestLoginLinkMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof requestLoginLink>>, TError,RequestLoginLinkMutationVariables, TContext> => {

const mutationKey = getRequestLoginLinkMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestLoginLink>>, RequestLoginLinkMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  requestLoginLink(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestLoginLinkMutationResult = NonNullable<Awaited<ReturnType<typeof requestLoginLink>>>
    export type RequestLoginLinkMutationBody = string | undefined
    export type RequestLoginLinkMutationError = ProblemDetails
    export type RequestLoginLinkMutationVariables = {data?: string}

    /**
 * @summary Request a login link to be sent to the user's email via jwt token
Currently only for employers with auth provider Internal Jwt aka Lead employers
 */
export const useRequestLoginLink = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestLoginLink>>, TError,RequestLoginLinkMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof requestLoginLink>>,
        TError,
        RequestLoginLinkMutationVariables,
        TContext
      > => {
      return useMutation(getRequestLoginLinkMutationOptions(options), queryClient);
    }

export const getComposeAiJobUrl = () => {




  return `/employer/ai-jobs/compose`
}

/**
 * @summary Composes a vacancy (data + texts) from a vacancy text or briefing and saves it as an AiJob.
 */
export const composeAiJob = async (composeAiJobCommandDto?: ComposeAiJobCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ComposeAiJobResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<ComposeAiJobResult>(getComposeAiJobUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(composeAiJobCommandDto)
  }
);}





export const getComposeAiJobMutationKey = () => ['composeAiJob'] as const;

export const getComposeAiJobMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof composeAiJob>>, TError,ComposeAiJobMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof composeAiJob>>, TError,ComposeAiJobMutationVariables, TContext> => {

const mutationKey = getComposeAiJobMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof composeAiJob>>, ComposeAiJobMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  composeAiJob(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ComposeAiJobMutationResult = NonNullable<Awaited<ReturnType<typeof composeAiJob>>>
    export type ComposeAiJobMutationBody = ComposeAiJobCommandDto | undefined
    export type ComposeAiJobMutationError = ProblemDetails
    export type ComposeAiJobMutationVariables = {data?: ComposeAiJobCommandDto}

    /**
 * @summary Composes a vacancy (data + texts) from a vacancy text or briefing and saves it as an AiJob.
 */
export const useComposeAiJob = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof composeAiJob>>, TError,ComposeAiJobMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof composeAiJob>>,
        TError,
        ComposeAiJobMutationVariables,
        TContext
      > => {
      return useMutation(getComposeAiJobMutationOptions(options), queryClient);
    }

export const getExtractVacancyFromPageUrl = () => {




  return `/employer/ai-jobs/extract-page`
}

/**
 * @summary Reads the vacancy text off a public vacancy page, for the "paste a link" entry; stateless.
 */
export const extractVacancyFromPage = async (extractVacancyFromPageCommandDto?: ExtractVacancyFromPageCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ExtractVacancyFromPageResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<ExtractVacancyFromPageResult>(getExtractVacancyFromPageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(extractVacancyFromPageCommandDto)
  }
);}





export const getExtractVacancyFromPageMutationKey = () => ['extractVacancyFromPage'] as const;

export const getExtractVacancyFromPageMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof extractVacancyFromPage>>, TError,ExtractVacancyFromPageMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof extractVacancyFromPage>>, TError,ExtractVacancyFromPageMutationVariables, TContext> => {

const mutationKey = getExtractVacancyFromPageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof extractVacancyFromPage>>, ExtractVacancyFromPageMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  extractVacancyFromPage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExtractVacancyFromPageMutationResult = NonNullable<Awaited<ReturnType<typeof extractVacancyFromPage>>>
    export type ExtractVacancyFromPageMutationBody = ExtractVacancyFromPageCommandDto | undefined
    export type ExtractVacancyFromPageMutationError = ProblemDetails
    export type ExtractVacancyFromPageMutationVariables = {data?: ExtractVacancyFromPageCommandDto}

    /**
 * @summary Reads the vacancy text off a public vacancy page, for the "paste a link" entry; stateless.
 */
export const useExtractVacancyFromPage = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof extractVacancyFromPage>>, TError,ExtractVacancyFromPageMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof extractVacancyFromPage>>,
        TError,
        ExtractVacancyFromPageMutationVariables,
        TContext
      > => {
      return useMutation(getExtractVacancyFromPageMutationOptions(options), queryClient);
    }

export const getDetermineJobFunctionUrl = () => {




  return `/employer/ai-jobs/job-function`
}

/**
 * @summary Determines the job function from a vacancy the employer wrote themselves; stateless.
 */
export const determineJobFunction = async (determineJobFunctionCommandDto?: DetermineJobFunctionCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<DetermineJobFunctionResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<DetermineJobFunctionResult>(getDetermineJobFunctionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(determineJobFunctionCommandDto)
  }
);}





export const getDetermineJobFunctionMutationKey = () => ['determineJobFunction'] as const;

export const getDetermineJobFunctionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof determineJobFunction>>, TError,DetermineJobFunctionMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof determineJobFunction>>, TError,DetermineJobFunctionMutationVariables, TContext> => {

const mutationKey = getDetermineJobFunctionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof determineJobFunction>>, DetermineJobFunctionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  determineJobFunction(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DetermineJobFunctionMutationResult = NonNullable<Awaited<ReturnType<typeof determineJobFunction>>>
    export type DetermineJobFunctionMutationBody = DetermineJobFunctionCommandDto | undefined
    export type DetermineJobFunctionMutationError = ProblemDetails
    export type DetermineJobFunctionMutationVariables = {data?: DetermineJobFunctionCommandDto}

    /**
 * @summary Determines the job function from a vacancy the employer wrote themselves; stateless.
 */
export const useDetermineJobFunction = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof determineJobFunction>>, TError,DetermineJobFunctionMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof determineJobFunction>>,
        TError,
        DetermineJobFunctionMutationVariables,
        TContext
      > => {
      return useMutation(getDetermineJobFunctionMutationOptions(options), queryClient);
    }

export const getDetermineAiJobDataUrl = () => {




  return `/employer/ai-jobs/determine`
}

/**
 * @summary Determines the vacancy data from a text (with sources, reasonings and issues) and saves it as an AiJob without texts.
 */
export const determineAiJobData = async (determineAiJobDataCommandDto?: DetermineAiJobDataCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<DetermineAiJobDataResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<DetermineAiJobDataResult>(getDetermineAiJobDataUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(determineAiJobDataCommandDto)
  }
);}





export const getDetermineAiJobDataMutationKey = () => ['determineAiJobData'] as const;

export const getDetermineAiJobDataMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof determineAiJobData>>, TError,DetermineAiJobDataMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof determineAiJobData>>, TError,DetermineAiJobDataMutationVariables, TContext> => {

const mutationKey = getDetermineAiJobDataMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof determineAiJobData>>, DetermineAiJobDataMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  determineAiJobData(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DetermineAiJobDataMutationResult = NonNullable<Awaited<ReturnType<typeof determineAiJobData>>>
    export type DetermineAiJobDataMutationBody = DetermineAiJobDataCommandDto | undefined
    export type DetermineAiJobDataMutationError = ProblemDetails
    export type DetermineAiJobDataMutationVariables = {data?: DetermineAiJobDataCommandDto}

    /**
 * @summary Determines the vacancy data from a text (with sources, reasonings and issues) and saves it as an AiJob without texts.
 */
export const useDetermineAiJobData = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof determineAiJobData>>, TError,DetermineAiJobDataMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof determineAiJobData>>,
        TError,
        DetermineAiJobDataMutationVariables,
        TContext
      > => {
      return useMutation(getDetermineAiJobDataMutationOptions(options), queryClient);
    }

export const getWriteAiJobSectionsUrl = (id: number,) => {




  return `/employer/ai-jobs/${id}/write`
}

/**
 * @summary Writes all text sections for an AiJob whose data was determined; the sections come back as HTML.
 */
export const writeAiJobSections = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<WriteAiJobSectionsResult> => {

  return fetchWithAuth<WriteAiJobSectionsResult>(getWriteAiJobSectionsUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getWriteAiJobSectionsMutationKey = () => ['writeAiJobSections'] as const;

export const getWriteAiJobSectionsMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeAiJobSections>>, TError,WriteAiJobSectionsMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof writeAiJobSections>>, TError,WriteAiJobSectionsMutationVariables, TContext> => {

const mutationKey = getWriteAiJobSectionsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writeAiJobSections>>, WriteAiJobSectionsMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  writeAiJobSections(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WriteAiJobSectionsMutationResult = NonNullable<Awaited<ReturnType<typeof writeAiJobSections>>>

    export type WriteAiJobSectionsMutationError = ProblemDetails
    export type WriteAiJobSectionsMutationVariables = {id: number}

    /**
 * @summary Writes all text sections for an AiJob whose data was determined; the sections come back as HTML.
 */
export const useWriteAiJobSections = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeAiJobSections>>, TError,WriteAiJobSectionsMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof writeAiJobSections>>,
        TError,
        WriteAiJobSectionsMutationVariables,
        TContext
      > => {
      return useMutation(getWriteAiJobSectionsMutationOptions(options), queryClient);
    }

export const getChatWithJobAgentUrl = () => {




  return `/employer/ai-jobs/chat`
}

/**
 * @summary One chat turn with the agent about the vacancy in the form; stateless.
 */
export const chatWithJobAgent = async (chatWithJobAgentCommandDto?: ChatWithJobAgentCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ChatWithJobAgentResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<ChatWithJobAgentResult>(getChatWithJobAgentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(chatWithJobAgentCommandDto)
  }
);}





export const getChatWithJobAgentMutationKey = () => ['chatWithJobAgent'] as const;

export const getChatWithJobAgentMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatWithJobAgent>>, TError,ChatWithJobAgentMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof chatWithJobAgent>>, TError,ChatWithJobAgentMutationVariables, TContext> => {

const mutationKey = getChatWithJobAgentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chatWithJobAgent>>, ChatWithJobAgentMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  chatWithJobAgent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChatWithJobAgentMutationResult = NonNullable<Awaited<ReturnType<typeof chatWithJobAgent>>>
    export type ChatWithJobAgentMutationBody = ChatWithJobAgentCommandDto | undefined
    export type ChatWithJobAgentMutationError = ProblemDetails
    export type ChatWithJobAgentMutationVariables = {data?: ChatWithJobAgentCommandDto}

    /**
 * @summary One chat turn with the agent about the vacancy in the form; stateless.
 */
export const useChatWithJobAgent = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatWithJobAgent>>, TError,ChatWithJobAgentMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof chatWithJobAgent>>,
        TError,
        ChatWithJobAgentMutationVariables,
        TContext
      > => {
      return useMutation(getChatWithJobAgentMutationOptions(options), queryClient);
    }

export const getRewriteJobSectionUrl = () => {




  return `/employer/ai-jobs/rewrite-section`
}

/**
 * @summary Rewrites one text section of the vacancy in the form in a preset style; stateless.
 */
export const rewriteJobSection = async (rewriteJobSectionCommandDto?: RewriteJobSectionCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<RewriteJobSectionResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<RewriteJobSectionResult>(getRewriteJobSectionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(rewriteJobSectionCommandDto)
  }
);}





export const getRewriteJobSectionMutationKey = () => ['rewriteJobSection'] as const;

export const getRewriteJobSectionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rewriteJobSection>>, TError,RewriteJobSectionMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof rewriteJobSection>>, TError,RewriteJobSectionMutationVariables, TContext> => {

const mutationKey = getRewriteJobSectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rewriteJobSection>>, RewriteJobSectionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  rewriteJobSection(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RewriteJobSectionMutationResult = NonNullable<Awaited<ReturnType<typeof rewriteJobSection>>>
    export type RewriteJobSectionMutationBody = RewriteJobSectionCommandDto | undefined
    export type RewriteJobSectionMutationError = ProblemDetails
    export type RewriteJobSectionMutationVariables = {data?: RewriteJobSectionCommandDto}

    /**
 * @summary Rewrites one text section of the vacancy in the form in a preset style; stateless.
 */
export const useRewriteJobSection = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rewriteJobSection>>, TError,RewriteJobSectionMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof rewriteJobSection>>,
        TError,
        RewriteJobSectionMutationVariables,
        TContext
      > => {
      return useMutation(getRewriteJobSectionMutationOptions(options), queryClient);
    }

export const getReviewAiJobUrl = (id: number,) => {




  return `/employer/ai-jobs/${id}/review`
}

/**
 * @summary Thumbs up/down on the agent's result, after the job was created from it.
 */
export const reviewAiJob = async (id: number,
    reviewAiJobCommandDto?: ReviewAiJobCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<boolean> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<boolean>(getReviewAiJobUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reviewAiJobCommandDto)
  }
);}





export const getReviewAiJobMutationKey = () => ['reviewAiJob'] as const;

export const getReviewAiJobMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewAiJob>>, TError,ReviewAiJobMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof reviewAiJob>>, TError,ReviewAiJobMutationVariables, TContext> => {

const mutationKey = getReviewAiJobMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reviewAiJob>>, ReviewAiJobMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  reviewAiJob(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReviewAiJobMutationResult = NonNullable<Awaited<ReturnType<typeof reviewAiJob>>>
    export type ReviewAiJobMutationBody = ReviewAiJobCommandDto | undefined
    export type ReviewAiJobMutationError = ProblemDetails
    export type ReviewAiJobMutationVariables = {id: number;data?: ReviewAiJobCommandDto}

    /**
 * @summary Thumbs up/down on the agent's result, after the job was created from it.
 */
export const useReviewAiJob = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewAiJob>>, TError,ReviewAiJobMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof reviewAiJob>>,
        TError,
        ReviewAiJobMutationVariables,
        TContext
      > => {
      return useMutation(getReviewAiJobMutationOptions(options), queryClient);
    }

export const getListEducationLevelsUrl = () => {




  return `/education-level`
}

/**
 * @summary List all education levels
 */
export const listEducationLevels = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListEducationLevelsResult> => {

  return fetchWithAuth<ListEducationLevelsResult>(getListEducationLevelsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEducationLevelsQueryKey = () => {
    return [
    'education-level'
    ] as const;
    }


export const getListEducationLevelsQueryOptions = <TData = Awaited<ReturnType<typeof listEducationLevels>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEducationLevels>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListEducationLevelsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEducationLevels>>> = ({ signal }) => listEducationLevels({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEducationLevels>>, TError, TData>
}

export type ListEducationLevelsQueryResult = NonNullable<Awaited<ReturnType<typeof listEducationLevels>>>
export type ListEducationLevelsQueryError = unknown


/**
 * @summary List all education levels
 */

export function useListEducationLevels<TData = Awaited<ReturnType<typeof listEducationLevels>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEducationLevels>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEducationLevelsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListPersonalCharacteristicsUrl = () => {




  return `/personal-characteristics`
}

/**
 * @summary List all personal characteristics
 */
export const listPersonalCharacteristics = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListPersonalCharacteristicsResult> => {

  return fetchWithAuth<ListPersonalCharacteristicsResult>(getListPersonalCharacteristicsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPersonalCharacteristicsQueryKey = () => {
    return [
    'personal-characteristics'
    ] as const;
    }


export const getListPersonalCharacteristicsQueryOptions = <TData = Awaited<ReturnType<typeof listPersonalCharacteristics>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPersonalCharacteristics>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListPersonalCharacteristicsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPersonalCharacteristics>>> = ({ signal }) => listPersonalCharacteristics({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPersonalCharacteristics>>, TError, TData>
}

export type ListPersonalCharacteristicsQueryResult = NonNullable<Awaited<ReturnType<typeof listPersonalCharacteristics>>>
export type ListPersonalCharacteristicsQueryError = unknown


/**
 * @summary List all personal characteristics
 */

export function useListPersonalCharacteristics<TData = Awaited<ReturnType<typeof listPersonalCharacteristics>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPersonalCharacteristics>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPersonalCharacteristicsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListNewJobReasonsUrl = () => {




  return `/new-job-reasons`
}

/**
 * @summary List all new job reasons
 */
export const listNewJobReasons = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListNewJobReasonsResult> => {

  return fetchWithAuth<ListNewJobReasonsResult>(getListNewJobReasonsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListNewJobReasonsQueryKey = () => {
    return [
    'new-job-reasons'
    ] as const;
    }


export const getListNewJobReasonsQueryOptions = <TData = Awaited<ReturnType<typeof listNewJobReasons>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNewJobReasons>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListNewJobReasonsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNewJobReasons>>> = ({ signal }) => listNewJobReasons({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNewJobReasons>>, TError, TData>
}

export type ListNewJobReasonsQueryResult = NonNullable<Awaited<ReturnType<typeof listNewJobReasons>>>
export type ListNewJobReasonsQueryError = unknown


/**
 * @summary List all new job reasons
 */

export function useListNewJobReasons<TData = Awaited<ReturnType<typeof listNewJobReasons>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNewJobReasons>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNewJobReasonsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListPersonalityTypesUrl = () => {




  return `/personality-types`
}

export const listPersonalityTypes = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListPersonalityTypesResult> => {

  return fetchWithAuth<ListPersonalityTypesResult>(getListPersonalityTypesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPersonalityTypesQueryKey = () => {
    return [
    'personality-types'
    ] as const;
    }


export const getListPersonalityTypesQueryOptions = <TData = Awaited<ReturnType<typeof listPersonalityTypes>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPersonalityTypes>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListPersonalityTypesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPersonalityTypes>>> = ({ signal }) => listPersonalityTypes({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPersonalityTypes>>, TError, TData>
}

export type ListPersonalityTypesQueryResult = NonNullable<Awaited<ReturnType<typeof listPersonalityTypes>>>
export type ListPersonalityTypesQueryError = unknown



export function useListPersonalityTypes<TData = Awaited<ReturnType<typeof listPersonalityTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPersonalityTypes>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPersonalityTypesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetAutoCompleteLocationsUrl = (params: GetAutoCompleteLocationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/location/auto-complete?${stringifiedParams}` : `/location/auto-complete`
}

/**
 * @summary Get Auto complete locations from the Google Places API.
 */
export const getAutoCompleteLocations = async (params: GetAutoCompleteLocationsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetAutoCompleteLocationsResult> => {

  return fetchWithAuth<GetAutoCompleteLocationsResult>(getGetAutoCompleteLocationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAutoCompleteLocationsQueryKey = (params?: MaybeRefOrGetter<GetAutoCompleteLocationsParams>,) => {
    return [
    'location','auto-complete', ...(params ? [params] : [])
    ] as const;
    }


export const getGetAutoCompleteLocationsQueryOptions = <TData = Awaited<ReturnType<typeof getAutoCompleteLocations>>, TError = ProblemDetails>(params: MaybeRefOrGetter<GetAutoCompleteLocationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAutoCompleteLocations>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetAutoCompleteLocationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAutoCompleteLocations>>> = ({ signal }) => getAutoCompleteLocations(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAutoCompleteLocations>>, TError, TData>
}

export type GetAutoCompleteLocationsQueryResult = NonNullable<Awaited<ReturnType<typeof getAutoCompleteLocations>>>
export type GetAutoCompleteLocationsQueryError = ProblemDetails


/**
 * @summary Get Auto complete locations from the Google Places API.
 */

export function useGetAutoCompleteLocations<TData = Awaited<ReturnType<typeof getAutoCompleteLocations>>, TError = ProblemDetails>(
 params: MaybeRefOrGetter<GetAutoCompleteLocationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAutoCompleteLocations>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAutoCompleteLocationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetLocationDetailsUrl = (params: GetLocationDetailsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/location/details/v2?${stringifiedParams}` : `/location/details/v2`
}

/**
 * @summary Get location details (including Lat, Long) from the Google Places API based on the place Id.
 */
export const getLocationDetails = async (params: GetLocationDetailsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetLocationDetailsResult> => {

  return fetchWithAuth<GetLocationDetailsResult>(getGetLocationDetailsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLocationDetailsQueryKey = (params?: MaybeRefOrGetter<GetLocationDetailsParams>,) => {
    return [
    'location','details','v2', ...(params ? [params] : [])
    ] as const;
    }


export const getGetLocationDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getLocationDetails>>, TError = ProblemDetails>(params: MaybeRefOrGetter<GetLocationDetailsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationDetails>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetLocationDetailsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationDetails>>> = ({ signal }) => getLocationDetails(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocationDetails>>, TError, TData>
}

export type GetLocationDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationDetails>>>
export type GetLocationDetailsQueryError = ProblemDetails


/**
 * @summary Get location details (including Lat, Long) from the Google Places API based on the place Id.
 */

export function useGetLocationDetails<TData = Awaited<ReturnType<typeof getLocationDetails>>, TError = ProblemDetails>(
 params: MaybeRefOrGetter<GetLocationDetailsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationDetails>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLocationDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetLocationGeocodeUrl = (params?: GetLocationGeocodeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/location/location-geocode?${stringifiedParams}` : `/location/location-geocode`
}

/**
 * @summary Get a location geocode (including Lat, Long) from the Google Places API based on the lat long.
 */
export const getLocationGeocode = async (params?: GetLocationGeocodeParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetLocationGeocodeResult> => {

  return fetchWithAuth<GetLocationGeocodeResult>(getGetLocationGeocodeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLocationGeocodeQueryKey = (params?: MaybeRefOrGetter<GetLocationGeocodeParams>,) => {
    return [
    'location','location-geocode', ...(params ? [params] : [])
    ] as const;
    }


export const getGetLocationGeocodeQueryOptions = <TData = Awaited<ReturnType<typeof getLocationGeocode>>, TError = ProblemDetails>(params?: MaybeRefOrGetter<GetLocationGeocodeParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationGeocode>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetLocationGeocodeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationGeocode>>> = ({ signal }) => getLocationGeocode(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocationGeocode>>, TError, TData>
}

export type GetLocationGeocodeQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationGeocode>>>
export type GetLocationGeocodeQueryError = ProblemDetails


/**
 * @summary Get a location geocode (including Lat, Long) from the Google Places API based on the lat long.
 */

export function useGetLocationGeocode<TData = Awaited<ReturnType<typeof getLocationGeocode>>, TError = ProblemDetails>(
 params?: MaybeRefOrGetter<GetLocationGeocodeParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationGeocode>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLocationGeocodeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListSkillsCertificatesAndLanguagesUrl = () => {




  return `/skill/v2`
}

export const listSkillsCertificatesAndLanguages = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListSkillsCertificatesAndLanguagesResult> => {

  return fetchWithAuth<ListSkillsCertificatesAndLanguagesResult>(getListSkillsCertificatesAndLanguagesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSkillsCertificatesAndLanguagesQueryKey = () => {
    return [
    'skill','v2'
    ] as const;
    }


export const getListSkillsCertificatesAndLanguagesQueryOptions = <TData = Awaited<ReturnType<typeof listSkillsCertificatesAndLanguages>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSkillsCertificatesAndLanguages>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListSkillsCertificatesAndLanguagesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSkillsCertificatesAndLanguages>>> = ({ signal }) => listSkillsCertificatesAndLanguages({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSkillsCertificatesAndLanguages>>, TError, TData>
}

export type ListSkillsCertificatesAndLanguagesQueryResult = NonNullable<Awaited<ReturnType<typeof listSkillsCertificatesAndLanguages>>>
export type ListSkillsCertificatesAndLanguagesQueryError = unknown



export function useListSkillsCertificatesAndLanguages<TData = Awaited<ReturnType<typeof listSkillsCertificatesAndLanguages>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSkillsCertificatesAndLanguages>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSkillsCertificatesAndLanguagesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListAllSkillsUrl = () => {




  return `/skill/v2/list-all-skills`
}

export const listAllSkills = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListAllSkillsResult> => {

  return fetchWithAuth<ListAllSkillsResult>(getListAllSkillsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAllSkillsQueryKey = () => {
    return [
    'skill','v2','list-all-skills'
    ] as const;
    }


export const getListAllSkillsQueryOptions = <TData = Awaited<ReturnType<typeof listAllSkills>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllSkills>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListAllSkillsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllSkills>>> = ({ signal }) => listAllSkills({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAllSkills>>, TError, TData>
}

export type ListAllSkillsQueryResult = NonNullable<Awaited<ReturnType<typeof listAllSkills>>>
export type ListAllSkillsQueryError = unknown



export function useListAllSkills<TData = Awaited<ReturnType<typeof listAllSkills>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllSkills>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAllSkillsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListSkillsForJobCategoriesUrl = (params?: ListSkillsForJobCategoriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["jobCategoryIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/skill/v2/list-for-job-categories?${stringifiedParams}` : `/skill/v2/list-for-job-categories`
}

export const listSkillsForJobCategories = async (params?: ListSkillsForJobCategoriesParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListSkillsForJobCategoriesResult> => {

  return fetchWithAuth<ListSkillsForJobCategoriesResult>(getListSkillsForJobCategoriesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSkillsForJobCategoriesQueryKey = (params?: MaybeRefOrGetter<ListSkillsForJobCategoriesParams>,) => {
    return [
    'skill','v2','list-for-job-categories', ...(params ? [params] : [])
    ] as const;
    }


export const getListSkillsForJobCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof listSkillsForJobCategories>>, TError = unknown>(params?: MaybeRefOrGetter<ListSkillsForJobCategoriesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSkillsForJobCategories>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListSkillsForJobCategoriesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSkillsForJobCategories>>> = ({ signal }) => listSkillsForJobCategories(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSkillsForJobCategories>>, TError, TData>
}

export type ListSkillsForJobCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof listSkillsForJobCategories>>>
export type ListSkillsForJobCategoriesQueryError = unknown



export function useListSkillsForJobCategories<TData = Awaited<ReturnType<typeof listSkillsForJobCategories>>, TError = unknown>(
 params?: MaybeRefOrGetter<ListSkillsForJobCategoriesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSkillsForJobCategories>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSkillsForJobCategoriesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListCertificatesUrl = () => {




  return `/skill/v2/list-certificates`
}

export const listCertificates = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListCertificatesResult> => {

  return fetchWithAuth<ListCertificatesResult>(getListCertificatesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCertificatesQueryKey = () => {
    return [
    'skill','v2','list-certificates'
    ] as const;
    }


export const getListCertificatesQueryOptions = <TData = Awaited<ReturnType<typeof listCertificates>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCertificates>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListCertificatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCertificates>>> = ({ signal }) => listCertificates({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCertificates>>, TError, TData>
}

export type ListCertificatesQueryResult = NonNullable<Awaited<ReturnType<typeof listCertificates>>>
export type ListCertificatesQueryError = unknown



export function useListCertificates<TData = Awaited<ReturnType<typeof listCertificates>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCertificates>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCertificatesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListJobFunctionsUrl = (params?: ListJobFunctionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/job-function?${stringifiedParams}` : `/job-function`
}

export const listJobFunctions = async (params?: ListJobFunctionsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<JobFunctionCrudListResult> => {

  return fetchWithAuth<JobFunctionCrudListResult>(getListJobFunctionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListJobFunctionsQueryKey = (params?: MaybeRefOrGetter<ListJobFunctionsParams>,) => {
    return [
    'job-function', ...(params ? [params] : [])
    ] as const;
    }


export const getListJobFunctionsQueryOptions = <TData = Awaited<ReturnType<typeof listJobFunctions>>, TError = unknown>(params?: MaybeRefOrGetter<ListJobFunctionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobFunctions>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListJobFunctionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listJobFunctions>>> = ({ signal }) => listJobFunctions(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listJobFunctions>>, TError, TData>
}

export type ListJobFunctionsQueryResult = NonNullable<Awaited<ReturnType<typeof listJobFunctions>>>
export type ListJobFunctionsQueryError = unknown



export function useListJobFunctions<TData = Awaited<ReturnType<typeof listJobFunctions>>, TError = unknown>(
 params?: MaybeRefOrGetter<ListJobFunctionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobFunctions>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListJobFunctionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListSimilarJobFunctionsUrl = (params?: ListSimilarJobFunctionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/job-function/similar?${stringifiedParams}` : `/job-function/similar`
}

/**
 * @summary Shared by onboarding and profile job-function editing: given the user's selected Job Functions
(DB-backed or free text), returns one group of occupation-relevant Job Functions per selection.
POST (not GET) because free-text selections don't bind cleanly from a query string.
 */
export const listSimilarJobFunctions = async (itemInput?: ItemInput[],
    params?: ListSimilarJobFunctionsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListSimilarJobFunctionsResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return fetchWithAuth<ListSimilarJobFunctionsResult>(getListSimilarJobFunctionsUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(itemInput)
  }
);}





export const getListSimilarJobFunctionsMutationKey = () => ['listSimilarJobFunctions'] as const;

export const getListSimilarJobFunctionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof listSimilarJobFunctions>>, TError,ListSimilarJobFunctionsMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof listSimilarJobFunctions>>, TError,ListSimilarJobFunctionsMutationVariables, TContext> => {

const mutationKey = getListSimilarJobFunctionsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof listSimilarJobFunctions>>, ListSimilarJobFunctionsMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  listSimilarJobFunctions(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ListSimilarJobFunctionsMutationResult = NonNullable<Awaited<ReturnType<typeof listSimilarJobFunctions>>>
    export type ListSimilarJobFunctionsMutationBody = ItemInput[] | undefined
    export type ListSimilarJobFunctionsMutationError = unknown
    export type ListSimilarJobFunctionsMutationVariables = {data?: ItemInput[];params?: ListSimilarJobFunctionsParams}

    /**
 * @summary Shared by onboarding and profile job-function editing: given the user's selected Job Functions
(DB-backed or free text), returns one group of occupation-relevant Job Functions per selection.
POST (not GET) because free-text selections don't bind cleanly from a query string.
 */
export const useListSimilarJobFunctions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof listSimilarJobFunctions>>, TError,ListSimilarJobFunctionsMutationVariables, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof listSimilarJobFunctions>>,
        TError,
        ListSimilarJobFunctionsMutationVariables,
        TContext
      > => {
      return useMutation(getListSimilarJobFunctionsMutationOptions(options), queryClient);
    }

export const getListJobCategoriesUrl = () => {




  return `/job-category/v2`
}

/**
 * @summary List all job categories, along with their job functions and skills
 */
export const listJobCategories = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<JobCategoryCrudListResult> => {

  return fetchWithAuth<JobCategoryCrudListResult>(getListJobCategoriesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListJobCategoriesQueryKey = () => {
    return [
    'job-category','v2'
    ] as const;
    }


export const getListJobCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof listJobCategories>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobCategories>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListJobCategoriesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listJobCategories>>> = ({ signal }) => listJobCategories({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listJobCategories>>, TError, TData>
}

export type ListJobCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof listJobCategories>>>
export type ListJobCategoriesQueryError = unknown


/**
 * @summary List all job categories, along with their job functions and skills
 */

export function useListJobCategories<TData = Awaited<ReturnType<typeof listJobCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobCategories>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListJobCategoriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetJobCategoryUrl = (id: number,) => {




  return `/job-category/v2/${id}`
}

/**
 * @summary List a job category, along with their job functions and skills
 */
export const getJobCategory = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<JobCategoryCrudJobCategoryDto> => {

  return fetchWithAuth<JobCategoryCrudJobCategoryDto>(getGetJobCategoryUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetJobCategoryQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'job-category','v2',id
    ] as const;
    }


export const getGetJobCategoryQueryOptions = <TData = Awaited<ReturnType<typeof getJobCategory>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobCategory>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetJobCategoryQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobCategory>>> = ({ signal }) => getJobCategory(toValue(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobCategory>>, TError, TData>
}

export type GetJobCategoryQueryResult = NonNullable<Awaited<ReturnType<typeof getJobCategory>>>
export type GetJobCategoryQueryError = ProblemDetails


/**
 * @summary List a job category, along with their job functions and skills
 */

export function useGetJobCategory<TData = Awaited<ReturnType<typeof getJobCategory>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobCategory>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobCategoryQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListInterestsUrl = () => {




  return `/interest`
}

/**
 * @summary List all interests
 */
export const listInterests = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListInterestsResult> => {

  return fetchWithAuth<ListInterestsResult>(getListInterestsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInterestsQueryKey = () => {
    return [
    'interest'
    ] as const;
    }


export const getListInterestsQueryOptions = <TData = Awaited<ReturnType<typeof listInterests>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInterests>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListInterestsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInterests>>> = ({ signal }) => listInterests({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInterests>>, TError, TData>
}

export type ListInterestsQueryResult = NonNullable<Awaited<ReturnType<typeof listInterests>>>
export type ListInterestsQueryError = unknown


/**
 * @summary List all interests
 */

export function useListInterests<TData = Awaited<ReturnType<typeof listInterests>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInterests>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInterestsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetRoleUrl = () => {




  return `/user/account/role`
}

/**
 * @summary Get the role of the current user.
 */
export const getRole = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetRoleResult> => {

  return fetchWithAuth<GetRoleResult>(getGetRoleUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRoleQueryKey = () => {
    return [
    'user','account','role'
    ] as const;
    }


export const getGetRoleQueryOptions = <TData = Awaited<ReturnType<typeof getRole>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRole>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetRoleQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRole>>> = ({ signal }) => getRole({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRole>>, TError, TData>
}

export type GetRoleQueryResult = NonNullable<Awaited<ReturnType<typeof getRole>>>
export type GetRoleQueryError = unknown


/**
 * @summary Get the role of the current user.
 */

export function useGetRole<TData = Awaited<ReturnType<typeof getRole>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRole>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRoleQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}


export const getGetUserCommentsResponseMock = (overrideResponse: Partial<Extract<GetUserCommentsResult, object>> = {}): GetUserCommentsResult => ({comments: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), employerId: faker.number.int(), employerName: faker.string.alpha({length: {min: 10, max: 20}}), employerProfilePictureUrl: faker.string.alpha({length: {min: 10, max: 20}}), body: faker.string.alpha({length: {min: 10, max: 20}}), job: {id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})}, createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), updatedAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), isOwnComment: faker.datatype.boolean()})), ...overrideResponse})

export const getListEducationLevelsWithTrackCategoryResponseMock = (overrideResponse: Partial<Extract<ListEducationLevelsWithTrackCategoryResult, object>> = {}): ListEducationLevelsWithTrackCategoryResult => ({educationLevels: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}}), trackCategory: faker.helpers.arrayElement(Object.values(TrackCategory))})), ...overrideResponse})

export const getListPaymentOptionsResponseMock = (overrideResponse: Partial<Extract<ListPaymentOptionsResult, object>> = {}): ListPaymentOptionsResult => ({discount: faker.number.float({fractionDigits: 2}), creditPackages: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), title: faker.string.alpha({length: {min: 10, max: 20}}), creditAmount: faker.number.int(), creditPrice: faker.number.float({fractionDigits: 2}), totalPrice: faker.number.float({fractionDigits: 2})})), jobSlotOptions: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.number.int())), subscriptions: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), title: faker.string.alpha({length: {min: 10, max: 20}}), price: faker.number.int(), billingPeriodMonths: faker.number.int(), features: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), discountFraction: faker.number.float({fractionDigits: 2}), includesVideo: faker.datatype.boolean(), jobSlots: faker.helpers.arrayElement([faker.number.int(), null])})), ...overrideResponse})

export const getCreateEmployerResponseMock = (overrideResponse: Partial<Extract<CreateEmployerResponse, object>> = {}): CreateEmployerResponse => ({companyId: faker.helpers.arrayElement([faker.number.int(), null]), token: faker.string.alpha({length: {min: 10, max: 20}}), ...overrideResponse})

export const getGetEmployerOnboardingStatusResponseMock = (overrideResponse: Partial<Extract<GetEmployerOnboardingStatusResult, object>> = {}): GetEmployerOnboardingStatusResult => ({status: faker.helpers.arrayElement(Object.values(EmployerOnboardingStatus)), employerInvite: faker.helpers.arrayElement([{type: faker.helpers.arrayElement(Object.values(EmployerInviteType)), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}}), invitedBy: faker.string.alpha({length: {min: 10, max: 20}}), invitedByCompany: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), employer: faker.helpers.arrayElement([{firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), ...overrideResponse})

export const getListAllMatchesResponseMock = (overrideResponse: Partial<Extract<ListMatchesResult, object>> = {}): ListMatchesResult => ({totalCount: faker.number.int(), hasClosedMatches: faker.datatype.boolean(), matches: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({summary: {id: faker.number.int(), createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), closedAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), status: faker.helpers.arrayElement(Object.values(MatchStatus)), unreadCount: faker.number.int(), lastMessageBody: faker.string.alpha({length: {min: 10, max: 20}}), lastMessageAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z')}, user: {id: faker.number.int(), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}}), profilePictureUrl: faker.string.alpha({length: {min: 10, max: 20}}), phoneNumber: faker.string.alpha({length: {min: 10, max: 20}}), hasNotificationsEnabled: faker.helpers.arrayElement([faker.datatype.boolean(), null]), allowPhoneCalls: faker.datatype.boolean(), allowTexts: faker.datatype.boolean(), prefersContactOverPhone: faker.datatype.boolean()}, job: {id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})}})), ...overrideResponse})

export const getHasUnreadMatchesResponseMock = (): boolean => (faker.datatype.boolean())

export const getGetMatchedUserResponseMock = (overrideResponse: Partial<Extract<GetMatchedUserResult, object>> = {}): GetMatchedUserResult => ({userId: faker.number.int(), cityName: faker.string.alpha({length: {min: 10, max: 20}}), searchLocationName: faker.string.alpha({length: {min: 10, max: 20}}), searchLocationRadius: faker.number.int(), isSearchEverywhere: faker.datatype.boolean(), skills: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(SkillType)), name: faker.string.alpha({length: {min: 10, max: 20}}), tag: faker.string.alpha({length: {min: 10, max: 20}})})), topSkills: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(SkillType)), name: faker.string.alpha({length: {min: 10, max: 20}}), tag: faker.string.alpha({length: {min: 10, max: 20}})})), yearsExperience: {lower: faker.number.int(), upper: faker.helpers.arrayElement([faker.number.int(), null])}, hoursPerWeek: {lower: faker.number.int(), upper: faker.number.int()}, educationLevel: faker.number.int(), personalCharacteristics: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.number.int())), personalityTypeId: faker.number.int(), educationExperiences: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.helpers.arrayElement([faker.number.int(), null]), studyAndGrade: faker.string.alpha({length: {min: 1, max: 20}}), institute: faker.string.alpha({length: {min: 1, max: 20}}), startYear: faker.number.int({min: 1900}), endYear: faker.helpers.arrayElement([faker.number.int(), null]), isGraduated: faker.datatype.boolean()})), noEducationExperience: faker.datatype.boolean(), workExperiences: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.helpers.arrayElement([faker.number.int(), null]), type: faker.helpers.arrayElement(Object.values(WorkExperienceType)), functionTitle: faker.string.alpha({length: {min: 1, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), company: faker.string.alpha({length: {min: 1, max: 20}}), startYear: faker.number.int({min: 1900}), endYear: faker.helpers.arrayElement([faker.number.int(), null]), jobFunctionId: faker.helpers.arrayElement([faker.number.int(), null])})), noWorkExperience: faker.datatype.boolean(), workExperienceComplete: faker.datatype.boolean(), ambitions: faker.string.alpha({length: {min: 10, max: 20}}), personalInterests: faker.string.alpha({length: {min: 10, max: 20}}), newJobReason: faker.string.alpha({length: {min: 10, max: 20}}), isCompleteProfileRequestSent: faker.datatype.boolean(), prefersContactOverPhone: faker.datatype.boolean(), allowPhoneCalls: faker.datatype.boolean(), allowTexts: faker.datatype.boolean(), id: faker.number.int(), profilePictureUrl: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), age: faker.helpers.arrayElement([faker.number.int(), null]), email: faker.string.alpha({length: {min: 10, max: 20}}), phoneNumber: faker.string.alpha({length: {min: 10, max: 20}}), matchCreatedAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), job: {id: faker.number.int(), title: faker.string.alpha({length: {min: 10, max: 20}}), subtitle: faker.string.alpha({length: {min: 10, max: 20}}), skills: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(SkillType)), name: faker.string.alpha({length: {min: 10, max: 20}}), tag: faker.string.alpha({length: {min: 10, max: 20}})}))}, ...overrideResponse})

// @ts-ignore Orval mock generation bug with Blob/ArrayBuffer type
export const getDownloadCandidatePdfResponseMock = (): Blob => (new Blob([new Uint8Array(faker.number.int({ min: 1, max: 64 }))]))

export const getListMatchesByStageResponseMock = (overrideResponse: Partial<Extract<ListMatchesByStageResult, object>> = {}): ListMatchesByStageResult => ({matches: {Unspecified: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({summary: {id: faker.number.int(), createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), closedAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), status: faker.helpers.arrayElement(Object.values(MatchStatus)), unreadCount: faker.number.int(), lastMessageBody: faker.string.alpha({length: {min: 10, max: 20}}), lastMessageAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z')}, user: {id: faker.number.int(), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}}), profilePictureUrl: faker.string.alpha({length: {min: 10, max: 20}}), phoneNumber: faker.string.alpha({length: {min: 10, max: 20}}), hasNotificationsEnabled: faker.helpers.arrayElement([faker.datatype.boolean(), null]), allowPhoneCalls: faker.datatype.boolean(), allowTexts: faker.datatype.boolean(), prefersContactOverPhone: faker.datatype.boolean()}, job: {id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})}})), undefined]), ActionChatRequired: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({summary: {id: faker.number.int(), createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), closedAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), status: faker.helpers.arrayElement(Object.values(MatchStatus)), unreadCount: faker.number.int(), lastMessageBody: faker.string.alpha({length: {min: 10, max: 20}}), lastMessageAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z')}, user: {id: faker.number.int(), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}}), profilePictureUrl: faker.string.alpha({length: {min: 10, max: 20}}), phoneNumber: faker.string.alpha({length: {min: 10, max: 20}}), hasNotificationsEnabled: faker.helpers.arrayElement([faker.datatype.boolean(), null]), allowPhoneCalls: faker.datatype.boolean(), allowTexts: faker.datatype.boolean(), prefersContactOverPhone: faker.datatype.boolean()}, job: {id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})}})), undefined]), ActionCallRequired: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({summary: {id: faker.number.int(), createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), closedAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), status: faker.helpers.arrayElement(Object.values(MatchStatus)), unreadCount: faker.number.int(), lastMessageBody: faker.string.alpha({length: {min: 10, max: 20}}), lastMessageAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z')}, user: {id: faker.number.int(), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}}), profilePictureUrl: faker.string.alpha({length: {min: 10, max: 20}}), phoneNumber: faker.string.alpha({length: {min: 10, max: 20}}), hasNotificationsEnabled: faker.helpers.arrayElement([faker.datatype.boolean(), null]), allowPhoneCalls: faker.datatype.boolean(), allowTexts: faker.datatype.boolean(), prefersContactOverPhone: faker.datatype.boolean()}, job: {id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})}})), undefined]), InProgress: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({summary: {id: faker.number.int(), createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), closedAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), status: faker.helpers.arrayElement(Object.values(MatchStatus)), unreadCount: faker.number.int(), lastMessageBody: faker.string.alpha({length: {min: 10, max: 20}}), lastMessageAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z')}, user: {id: faker.number.int(), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}}), profilePictureUrl: faker.string.alpha({length: {min: 10, max: 20}}), phoneNumber: faker.string.alpha({length: {min: 10, max: 20}}), hasNotificationsEnabled: faker.helpers.arrayElement([faker.datatype.boolean(), null]), allowPhoneCalls: faker.datatype.boolean(), allowTexts: faker.datatype.boolean(), prefersContactOverPhone: faker.datatype.boolean()}, job: {id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})}})), undefined]), Closed: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({summary: {id: faker.number.int(), createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), closedAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), status: faker.helpers.arrayElement(Object.values(MatchStatus)), unreadCount: faker.number.int(), lastMessageBody: faker.string.alpha({length: {min: 10, max: 20}}), lastMessageAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z')}, user: {id: faker.number.int(), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}}), profilePictureUrl: faker.string.alpha({length: {min: 10, max: 20}}), phoneNumber: faker.string.alpha({length: {min: 10, max: 20}}), hasNotificationsEnabled: faker.helpers.arrayElement([faker.datatype.boolean(), null]), allowPhoneCalls: faker.datatype.boolean(), allowTexts: faker.datatype.boolean(), prefersContactOverPhone: faker.datatype.boolean()}, job: {id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})}})), undefined]), Hired: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({summary: {id: faker.number.int(), createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), closedAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), status: faker.helpers.arrayElement(Object.values(MatchStatus)), unreadCount: faker.number.int(), lastMessageBody: faker.string.alpha({length: {min: 10, max: 20}}), lastMessageAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z')}, user: {id: faker.number.int(), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}}), profilePictureUrl: faker.string.alpha({length: {min: 10, max: 20}}), phoneNumber: faker.string.alpha({length: {min: 10, max: 20}}), hasNotificationsEnabled: faker.helpers.arrayElement([faker.datatype.boolean(), null]), allowPhoneCalls: faker.datatype.boolean(), allowTexts: faker.datatype.boolean(), prefersContactOverPhone: faker.datatype.boolean()}, job: {id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})}})), undefined])}, ...overrideResponse})

export const getGetMatchChatWithMessagesForEmployerResponseMock = (overrideResponse: Partial<Extract<GetMatchChatWithMessagesResult, object>> = {}): GetMatchChatWithMessagesResult => ({state: {suggestedAndHasNegativeCredits: faker.datatype.boolean(), isClosed: faker.datatype.boolean(), closedAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), isAtsJobApplication: faker.datatype.boolean(), atsJobApplicationUrl: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null])}, chat: {summary: {id: faker.number.int(), createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), closedAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), status: faker.helpers.arrayElement(Object.values(MatchStatus)), unreadCount: faker.number.int(), lastMessageBody: faker.string.alpha({length: {min: 10, max: 20}}), lastMessageAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z')}, user: {id: faker.number.int(), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}}), profilePictureUrl: faker.string.alpha({length: {min: 10, max: 20}}), phoneNumber: faker.string.alpha({length: {min: 10, max: 20}}), hasNotificationsEnabled: faker.helpers.arrayElement([faker.datatype.boolean(), null]), allowPhoneCalls: faker.datatype.boolean(), allowTexts: faker.datatype.boolean(), prefersContactOverPhone: faker.datatype.boolean()}, job: {id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})}}, appliedAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), messages: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), chatId: faker.number.int(), employerId: faker.helpers.arrayElement([faker.number.int(), null]), userId: faker.helpers.arrayElement([faker.number.int(), null]), isRead: faker.datatype.boolean(), senderRole: faker.helpers.arrayElement(Object.values(ChatMessageSenderRole)), sender: faker.string.alpha({length: {min: 10, max: 20}}), body: faker.string.alpha({length: {min: 10, max: 20}}), createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), poll: faker.helpers.arrayElement([{id: faker.number.int(), matchId: faker.number.int(), dates: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'))), selectedDate: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), answeredAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null])}, undefined]), phase: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(ChatMessagePhase)), undefined])})), ...overrideResponse})

export const getSendMatchChatMessageForEmployerResponseMock = (overrideResponse: Partial<Extract<ChatMessageDto, object>> = {}): ChatMessageDto => ({id: faker.number.int(), chatId: faker.number.int(), employerId: faker.helpers.arrayElement([faker.number.int(), null]), userId: faker.helpers.arrayElement([faker.number.int(), null]), isRead: faker.datatype.boolean(), senderRole: faker.helpers.arrayElement(Object.values(ChatMessageSenderRole)), sender: faker.string.alpha({length: {min: 10, max: 20}}), body: faker.string.alpha({length: {min: 10, max: 20}}), createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), poll: faker.helpers.arrayElement([{id: faker.number.int(), matchId: faker.number.int(), dates: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'))), selectedDate: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), answeredAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null])}, undefined]), phase: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(ChatMessagePhase)), undefined]), ...overrideResponse})

export const getSendPollResponseMock = (overrideResponse: Partial<Extract<SendPollResult, object>> = {}): SendPollResult => ({chatMessageId: faker.number.int(), pollId: faker.number.int(), matchId: faker.number.int(), ...overrideResponse})

export const getGetLeadEmployerResponseMock = (overrideResponse: Partial<Extract<GetLeadEmployerResult, object>> = {}): GetLeadEmployerResult => ({firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}}), hasAccount: faker.datatype.boolean(), ...overrideResponse})

export const getCreateFirebaseAccountForLeadResponseMock = (overrideResponse: Partial<Extract<CreateFirebaseAccountForLeadResult, object>> = {}): CreateFirebaseAccountForLeadResult => ({token: faker.string.alpha({length: {min: 10, max: 20}}), ...overrideResponse})

export const getListJobsResponseMock = (overrideResponse: Partial<Extract<ListJobsInPortalResult, object>> = {}): ListJobsInPortalResult => ({count: faker.number.int(), totalCount: faker.number.int(), jobs: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), description: {title: faker.string.alpha({length: {min: 10, max: 20}}), opening: faker.string.alpha({length: {min: 10, max: 20}}), duties: faker.string.alpha({length: {min: 10, max: 20}}), requirements: faker.string.alpha({length: {min: 10, max: 20}}), benefitsAndPerks: faker.string.alpha({length: {min: 10, max: 20}}), closing: faker.string.alpha({length: {min: 10, max: 20}})}, createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), publishedAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), visibleBetween: faker.helpers.arrayElement([{start: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), end: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null])}, undefined]), closedAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), status: faker.helpers.arrayElement(Object.values(JobStatus)), closureReason: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(JobClosureReason)), undefined]), locationNames: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), jobCategoryCode: faker.string.alpha({length: {min: 10, max: 20}}), jobCategoryId: faker.number.int(), jobFunctionId: faker.number.int(), waitingJobApplicationCount: faker.number.int(), isAiGenerated: faker.datatype.boolean(), atsJob: faker.helpers.arrayElement([{id: faker.string.alpha({length: {min: 10, max: 20}}), title: faker.string.alpha({length: {min: 10, max: 20}}), location: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), status: faker.helpers.arrayElement(Object.values(AtsJobMappingStatus)), locationId: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), externalOwnerId: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), externalOwnerUserId: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), externalOwnerDepartmentId: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), key: faker.string.alpha({length: {min: 10, max: 20}})}, undefined])})), ...overrideResponse})

export const getCreateJobResponseMock = (): number => (faker.number.int())

export const getUpdateJobResponseMock = (): number => (faker.number.int())

export const getGetJobResponseMock = (overrideResponse: Partial<Extract<GetJobResult, object>> = {}): GetJobResult => ({id: faker.number.int(), description: {title: faker.string.alpha({length: {min: 10, max: 20}}), opening: faker.string.alpha({length: {min: 10, max: 20}}), duties: faker.string.alpha({length: {min: 10, max: 20}}), requirements: faker.string.alpha({length: {min: 10, max: 20}}), benefitsAndPerks: faker.string.alpha({length: {min: 10, max: 20}}), closing: faker.string.alpha({length: {min: 10, max: 20}})}, createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), publishedAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), republishedAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), visibleBetween: faker.helpers.arrayElement([{start: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), end: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null])}, undefined]), closedAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), status: faker.helpers.arrayElement(Object.values(JobStatus)), closureReason: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(JobClosureReason)), undefined]), locations: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}}), geolocation: {latitude: faker.number.float({fractionDigits: 2}), longitude: faker.number.float({fractionDigits: 2})}})), isRemote: faker.datatype.boolean(), jobCategoryId: faker.number.int(), jobFunctionId: faker.number.int(), educationLevels: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})})), yearsExperience: {lower: faker.number.int(), upper: faker.helpers.arrayElement([faker.number.int(), null])}, salary: {lower: faker.number.float({fractionDigits: 2}), upper: faker.number.float({fractionDigits: 2})}, salaryPeriodicity: faker.helpers.arrayElement(Object.values(Periodicity)), hoursPerWeek: {lower: faker.number.int(), upper: faker.number.int()}, preferredCharacteristicColor: faker.helpers.arrayElement(Object.values(CharacteristicColor)), skills: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(SkillType)), name: faker.string.alpha({length: {min: 10, max: 20}}), tag: faker.string.alpha({length: {min: 10, max: 20}})})), waitingJobApplicationCount: faker.number.int(), rejectedJobApplicationCount: faker.number.int(), matchesCount: faker.number.int(), isSubscribed: faker.datatype.boolean(), atsJob: faker.helpers.arrayElement([{id: faker.string.alpha({length: {min: 10, max: 20}}), title: faker.string.alpha({length: {min: 10, max: 20}}), location: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), status: faker.helpers.arrayElement(Object.values(AtsJobMappingStatus)), locationId: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), externalOwnerId: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), externalOwnerUserId: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), externalOwnerDepartmentId: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), key: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), candidatePoolSize: faker.helpers.arrayElement(Object.values(CandidatePoolSize)), ...overrideResponse})

export const getRepublishJobResponseMock = (): number => (faker.number.int())

export const getUpdateJobPublishedResponseMock = (): UpdateJobPublishedResult => ({})

export const getUpdateJobCandidatePoolResponseMock = (): Unit => ({})

export const getFindBestCandidateResponseMock = (overrideResponse: Partial<Extract<FindBestCandidateResult, object>> = {}): FindBestCandidateResult => ({matchScoreId: faker.number.int(), user: {userId: faker.number.int(), cityName: faker.string.alpha({length: {min: 10, max: 20}}), searchLocationName: faker.string.alpha({length: {min: 10, max: 20}}), searchLocationRadius: faker.number.int(), isSearchEverywhere: faker.datatype.boolean(), skills: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(SkillType)), name: faker.string.alpha({length: {min: 10, max: 20}}), tag: faker.string.alpha({length: {min: 10, max: 20}})})), topSkills: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(SkillType)), name: faker.string.alpha({length: {min: 10, max: 20}}), tag: faker.string.alpha({length: {min: 10, max: 20}})})), yearsExperience: {lower: faker.number.int(), upper: faker.helpers.arrayElement([faker.number.int(), null])}, hoursPerWeek: {lower: faker.number.int(), upper: faker.number.int()}, educationLevel: faker.number.int(), personalCharacteristics: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.number.int())), personalityTypeId: faker.number.int(), educationExperiences: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.helpers.arrayElement([faker.number.int(), null]), studyAndGrade: faker.string.alpha({length: {min: 1, max: 20}}), institute: faker.string.alpha({length: {min: 1, max: 20}}), startYear: faker.number.int({min: 1900}), endYear: faker.helpers.arrayElement([faker.number.int(), null]), isGraduated: faker.datatype.boolean()})), noEducationExperience: faker.datatype.boolean(), workExperiences: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.helpers.arrayElement([faker.number.int(), null]), type: faker.helpers.arrayElement(Object.values(WorkExperienceType)), functionTitle: faker.string.alpha({length: {min: 1, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), company: faker.string.alpha({length: {min: 1, max: 20}}), startYear: faker.number.int({min: 1900}), endYear: faker.helpers.arrayElement([faker.number.int(), null]), jobFunctionId: faker.helpers.arrayElement([faker.number.int(), null])})), noWorkExperience: faker.datatype.boolean(), workExperienceComplete: faker.datatype.boolean(), ambitions: faker.string.alpha({length: {min: 10, max: 20}}), personalInterests: faker.string.alpha({length: {min: 10, max: 20}}), newJobReason: faker.string.alpha({length: {min: 10, max: 20}}), isCompleteProfileRequestSent: faker.datatype.boolean(), prefersContactOverPhone: faker.datatype.boolean(), allowPhoneCalls: faker.datatype.boolean(), allowTexts: faker.datatype.boolean()}, job: {id: faker.number.int(), title: faker.string.alpha({length: {min: 10, max: 20}}), subtitle: faker.string.alpha({length: {min: 10, max: 20}}), skills: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(SkillType)), name: faker.string.alpha({length: {min: 10, max: 20}}), tag: faker.string.alpha({length: {min: 10, max: 20}})}))}, matchScoreTotal: faker.number.float({fractionDigits: 2}), ...overrideResponse})

export const getReactToBestCandidateResponseMock = (): ReactToCandidateResult => ({})

export const getGetJobNotificationSettingsResponseMock = (overrideResponse: Partial<Extract<GetJobNotificationSettingsResult, object>> = {}): GetJobNotificationSettingsResult => ({teammates: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), displayName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}}), isSubscribed: faker.datatype.boolean(), isInternal: faker.datatype.boolean()})), ...overrideResponse})

export const getGetCompanyJobsNotificationSettingsResponseMock = (overrideResponse: Partial<Extract<GetCompanyJobsNotificationSettingsResult, object>> = {}): GetCompanyJobsNotificationSettingsResult => ({teammates: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), displayName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}}), isInternal: faker.datatype.boolean()})), jobs: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), title: faker.string.alpha({length: {min: 10, max: 20}}), status: faker.helpers.arrayElement(Object.values(JobStatus)), createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), subscribedEmployerIds: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.number.int()))})), ...overrideResponse})

export const getGetJobApplicationResponseMock = (overrideResponse: Partial<Extract<GetJobApplicationResult, object>> = {}): GetJobApplicationResult => ({id: faker.number.int(), createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), respondedAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), status: faker.helpers.arrayElement(Object.values(JobApplicationState)), closedAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), closureReasonCode: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(JobApplicationClosureReasonCode)), undefined]), closureReasonCustom: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), matchId: faker.helpers.arrayElement([faker.number.int(), null]), user: faker.helpers.arrayElement([{userId: faker.number.int(), cityName: faker.string.alpha({length: {min: 10, max: 20}}), searchLocationName: faker.string.alpha({length: {min: 10, max: 20}}), searchLocationRadius: faker.number.int(), isSearchEverywhere: faker.datatype.boolean(), skills: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(SkillType)), name: faker.string.alpha({length: {min: 10, max: 20}}), tag: faker.string.alpha({length: {min: 10, max: 20}})})), topSkills: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(SkillType)), name: faker.string.alpha({length: {min: 10, max: 20}}), tag: faker.string.alpha({length: {min: 10, max: 20}})})), yearsExperience: {lower: faker.number.int(), upper: faker.helpers.arrayElement([faker.number.int(), null])}, hoursPerWeek: {lower: faker.number.int(), upper: faker.number.int()}, educationLevel: faker.number.int(), personalCharacteristics: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.number.int())), personalityTypeId: faker.number.int(), educationExperiences: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.helpers.arrayElement([faker.number.int(), null]), studyAndGrade: faker.string.alpha({length: {min: 1, max: 20}}), institute: faker.string.alpha({length: {min: 1, max: 20}}), startYear: faker.number.int({min: 1900}), endYear: faker.helpers.arrayElement([faker.number.int(), null]), isGraduated: faker.datatype.boolean()})), noEducationExperience: faker.datatype.boolean(), workExperiences: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.helpers.arrayElement([faker.number.int(), null]), type: faker.helpers.arrayElement(Object.values(WorkExperienceType)), functionTitle: faker.string.alpha({length: {min: 1, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), company: faker.string.alpha({length: {min: 1, max: 20}}), startYear: faker.number.int({min: 1900}), endYear: faker.helpers.arrayElement([faker.number.int(), null]), jobFunctionId: faker.helpers.arrayElement([faker.number.int(), null])})), noWorkExperience: faker.datatype.boolean(), workExperienceComplete: faker.datatype.boolean(), ambitions: faker.string.alpha({length: {min: 10, max: 20}}), personalInterests: faker.string.alpha({length: {min: 10, max: 20}}), newJobReason: faker.string.alpha({length: {min: 10, max: 20}}), isCompleteProfileRequestSent: faker.datatype.boolean(), prefersContactOverPhone: faker.datatype.boolean(), allowPhoneCalls: faker.datatype.boolean(), allowTexts: faker.datatype.boolean()}, undefined]), job: {id: faker.number.int(), title: faker.string.alpha({length: {min: 10, max: 20}}), subtitle: faker.string.alpha({length: {min: 10, max: 20}}), skills: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(SkillType)), name: faker.string.alpha({length: {min: 10, max: 20}}), tag: faker.string.alpha({length: {min: 10, max: 20}})}))}, matchScoreTotal: faker.number.float({fractionDigits: 2}), atsJobApplicationUrl: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), siblingApplications: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), jobId: faker.number.int(), jobTitle: faker.string.alpha({length: {min: 10, max: 20}})})), activeMatchAtCompany: faker.helpers.arrayElement([{matchId: faker.number.int(), jobId: faker.number.int(), jobTitle: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), previousMatchesAtCompany: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({closedAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), jobTitle: faker.string.alpha({length: {min: 10, max: 20}}), closeReason: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(MatchCloseReason)), undefined])})), applicationMessages: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), body: faker.string.alpha({length: {min: 10, max: 20}}), createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z')})), ...overrideResponse})

export const getGetJobApplicationTabCountsResponseMock = (overrideResponse: Partial<Extract<GetJobApplicationTabCountsResult, object>> = {}): GetJobApplicationTabCountsResult => ({toReview: faker.number.int(), matches: faker.number.int(), hasRecentRejectedApplications: faker.datatype.boolean(), ...overrideResponse})

export const getListJobApplicationCandidatesResponseMock = (overrideResponse: Partial<Extract<ListJobApplicationCandidatesResult, object>> = {}): ListJobApplicationCandidatesResult => ({totalCount: faker.number.int(), candidates: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({candidate: {cityName: faker.string.alpha({length: {min: 10, max: 20}}), searchLocationName: faker.string.alpha({length: {min: 10, max: 20}}), searchLocationRadius: faker.number.int(), yearsExperience: {lower: faker.number.int(), upper: faker.helpers.arrayElement([faker.number.int(), null])}, educationLevel: faker.number.int(), personalCharacteristics: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.number.int())), personalityTypeId: faker.number.int(), lastCompany: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), displayName: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), profilePictureUrl: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null])}, applications: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), job: {id: faker.number.int(), title: faker.string.alpha({length: {min: 10, max: 20}}), createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), jobCategoryId: faker.number.int(), jobFunctionId: faker.number.int()}, status: faker.helpers.arrayElement(Object.values(JobApplicationState)), createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), matchScoreTotal: faker.number.float({fractionDigits: 2})}))})), ...overrideResponse})

export const getListJobApplicationRejectionReasonsResponseMock = (overrideResponse: Partial<Extract<ListJobApplicationRejectionReasonsResult, object>> = {}): ListJobApplicationRejectionReasonsResult => ({rejectionReasons: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})})), ...overrideResponse})

export const getRejectJobApplicationResponseMock = (overrideResponse: Partial<Extract<RejectJobApplicationResult, object>> = {}): RejectJobApplicationResult => ({id: faker.number.int(), ...overrideResponse})

export const getStartMatchResponseMock = (overrideResponse: Partial<Extract<StartMatchResult, object>> = {}): StartMatchResult => ({id: faker.number.int(), matchId: faker.number.int(), ...overrideResponse})

export const getListCreditTransactionsResponseMock = (overrideResponse: Partial<Extract<ListCreditTransactionsResult, object>> = {}): ListCreditTransactionsResult => ({creditTotal: faker.number.int(), creditTransactions: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), creditAmount: faker.number.int(), creditPrice: faker.number.float({fractionDigits: 2}), totalPrice: faker.number.float({fractionDigits: 2})})), ...overrideResponse})

export const getGetSubscriptionResponseMock = (overrideResponse: Partial<Extract<GetSubscriptionResult, object>> = {}): GetSubscriptionResult => ({subscription: faker.helpers.arrayElement([{id: faker.string.uuid(), title: faker.string.alpha({length: {min: 10, max: 20}}), invoicee: {customer: {id: faker.string.uuid(), type: faker.string.alpha({length: {min: 10, max: 20}})}}, status: faker.helpers.arrayElement(Object.values(SubscriptionStatus)), next_renewal_date: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), starts_on: new Date(faker.date.past().toISOString().slice(0, 10)), ends_on: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 10)), null]), billing_cycle: {periodicity: {unit: faker.string.alpha({length: {min: 10, max: 20}}), period: faker.number.int()}, days_in_advance: faker.number.int()}, grouped_lines: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({line_items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({product_category: {id: faker.string.uuid(), type: faker.string.alpha({length: {min: 10, max: 20}})}, quantity: faker.number.int(), description: faker.string.alpha({length: {min: 10, max: 20}}), unit_price: {amount: faker.number.float({fractionDigits: 2}), currency: faker.string.alpha({length: {min: 10, max: 20}}), tax: faker.string.alpha({length: {min: 10, max: 20}})}, total: faker.helpers.arrayElement([{tax_exclusive: faker.helpers.arrayElement([{amount: faker.number.float({fractionDigits: 2})}, undefined]), tax_inclusive: {amount: faker.number.float({fractionDigits: 2})}, due: faker.helpers.arrayElement([{amount: faker.number.float({fractionDigits: 2})}, undefined])}, undefined])}))})), total: {tax_exclusive: faker.helpers.arrayElement([{amount: faker.number.float({fractionDigits: 2})}, undefined]), tax_inclusive: {amount: faker.number.float({fractionDigits: 2})}, due: faker.helpers.arrayElement([{amount: faker.number.float({fractionDigits: 2})}, undefined])}}, undefined]), ...overrideResponse})

export const getListCompanySubscriptionsResponseMock = (overrideResponse: Partial<Extract<ListCompanySubscriptionsResult, object>> = {}): ListCompanySubscriptionsResult => ({results: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({subscriptionId: faker.helpers.arrayElement([faker.string.uuid(), null]), name: faker.string.alpha({length: {min: 10, max: 20}}), status: faker.helpers.arrayElement(Object.values(SubscriptionStatus)), startDate: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), endDate: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), jobSlots: faker.number.int(), durationInMonths: faker.number.int(), pricePerMonthExclVat: faker.number.int()})), ...overrideResponse})

export const getListInvoicesForCompanyResponseMock = (overrideResponse: Partial<Extract<ListInvoicesForCompanyResult, object>> = {}): ListInvoicesForCompanyResult => ({invoices: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), invoiceNumber: faker.string.alpha({length: {min: 10, max: 20}}), invoiceDate: new Date(faker.date.past().toISOString().slice(0, 10)), status: faker.helpers.arrayElement(Object.values(InvoiceStatus)), paid: faker.datatype.boolean(), dueOn: new Date(faker.date.past().toISOString().slice(0, 10)), daysOverdue: faker.number.int(), totalTaxExclusive: faker.number.float({fractionDigits: 2}), totalTaxInclusive: faker.number.float({fractionDigits: 2}), due: faker.number.float({fractionDigits: 2}), fileId: faker.helpers.arrayElement([faker.string.uuid(), null])})), ...overrideResponse})

export const getListCreditNotesForCompanyResponseMock = (overrideResponse: Partial<Extract<ListCreditNotesForCompanyResult, object>> = {}): ListCreditNotesForCompanyResult => ({creditNotes: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), creditNoteNumber: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), creditNoteDate: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 10)), null]), status: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), paid: faker.datatype.boolean(), totalTaxExclusive: faker.number.float({fractionDigits: 2}), totalTaxInclusive: faker.number.float({fractionDigits: 2}), invoiceId: faker.helpers.arrayElement([faker.string.uuid(), null]), invoiceNumber: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null])})), ...overrideResponse})

export const getGetInvoiceFileUrlResponseMock = (overrideResponse: Partial<Extract<GetInvoiceFileUrlResult, object>> = {}): GetInvoiceFileUrlResult => ({fileUrl: faker.string.alpha({length: {min: 10, max: 20}}), ...overrideResponse})

export const getGetCreditNoteFileUrlResponseMock = (overrideResponse: Partial<Extract<GetCreditNoteFileUrlResult, object>> = {}): GetCreditNoteFileUrlResult => ({fileUrl: faker.string.alpha({length: {min: 10, max: 20}}), ...overrideResponse})

export const getListIntegrationsResponseMock = (overrideResponse: Partial<Extract<ListIntegrationsResult, object>> = {}): ListIntegrationsResult => ({integrations: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({type: faker.helpers.arrayElement(Object.values(IntegrationType)), name: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), websiteUrl: faker.string.alpha({length: {min: 10, max: 20}}), iconSvgPath: faker.string.alpha({length: {min: 10, max: 20}}), visibility: faker.helpers.arrayElement(Object.values(IntegrationVisibility)), connection: faker.helpers.arrayElement([{id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(IntegrationType)), status: faker.helpers.arrayElement(Object.values(ConnectionStatus)), createdBy: {role: faker.helpers.arrayElement(Object.values(Role)), id: faker.number.int(), externalId: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}})}, createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), lastSyncAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null])}, undefined])})), ...overrideResponse})

export const getConnectCarerixIntegrationResponseMock = (overrideResponse: Partial<Extract<IntegrationConnectionDto, object>> = {}): IntegrationConnectionDto => ({id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(IntegrationType)), status: faker.helpers.arrayElement(Object.values(ConnectionStatus)), createdBy: {role: faker.helpers.arrayElement(Object.values(Role)), id: faker.number.int(), externalId: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}})}, createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), lastSyncAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), ...overrideResponse})

export const getUpdateCarerixConnectionResponseMock = (): Unit => ({})

export const getGetCarerixConnectionResponseMock = (overrideResponse: Partial<Extract<GetAtsIntegrationConnectionResultCarerixConnectionConfig, object>> = {}): GetAtsIntegrationConnectionResultCarerixConnectionConfig => ({id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(IntegrationType)), status: faker.helpers.arrayElement(Object.values(ConnectionStatus)), config: faker.helpers.arrayElement([{initialStatusInfoId: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), sourceNodeId: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null])}, undefined]), defaultMessageDto: faker.helpers.arrayElement([{id: faker.number.int(), title: faker.string.alpha({length: {min: 10, max: 20}}), body: faker.string.alpha({length: {min: 10, max: 20}}), isPublic: faker.datatype.boolean(), messageType: faker.helpers.arrayElement(Object.values(DefaultMessageType))}, undefined]), createdByEmployer: {role: faker.helpers.arrayElement(Object.values(Role)), id: faker.number.int(), externalId: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}})}, sendAsEmployer: {role: faker.helpers.arrayElement(Object.values(Role)), id: faker.number.int(), externalId: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}})}, sendFlow: faker.helpers.arrayElement(Object.values(AtsSendFlow)), createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), lastSyncAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), ...overrideResponse})

export const getListCarerixStatusInfosResponseMock = (overrideResponse: Partial<Extract<ListCarerixStatusInfosResult, object>> = {}): ListCarerixStatusInfosResult => ({statusInfos: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.alpha({length: {min: 10, max: 20}}), name: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), label: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), displayName: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), statusValue: faker.helpers.arrayElement([faker.number.int(), null]), sortOrder: faker.helpers.arrayElement([faker.number.int(), null]), indicationColor: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), active: faker.helpers.arrayElement([faker.datatype.boolean(), null]), isFinal: faker.helpers.arrayElement([faker.datatype.boolean(), null]), isDefault: faker.helpers.arrayElement([faker.datatype.boolean(), null])})), ...overrideResponse})

export const getListCarerixSourceNodesResponseMock = (overrideResponse: Partial<Extract<ListCarerixSourceNodesResult, object>> = {}): ListCarerixSourceNodesResult => ({sourceNodes: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.alpha({length: {min: 10, max: 20}}), value: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), label: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), isDefault: faker.helpers.arrayElement([faker.datatype.boolean(), null]), sortOrder: faker.helpers.arrayElement([faker.number.int(), null])})), ...overrideResponse})

export const getListCarerixOwnersResponseMock = (overrideResponse: Partial<Extract<ListCarerixOwnersResult, object>> = {}): ListCarerixOwnersResult => ({owners: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.alpha({length: {min: 10, max: 20}}), userName: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), emailAddress: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null])})), ...overrideResponse})

export const getUpdateCarerixJobMappingResponseMock = (): Unit => ({})

export const getConnectHomerunIntegrationResponseMock = (overrideResponse: Partial<Extract<IntegrationConnectionDto, object>> = {}): IntegrationConnectionDto => ({id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(IntegrationType)), status: faker.helpers.arrayElement(Object.values(ConnectionStatus)), createdBy: {role: faker.helpers.arrayElement(Object.values(Role)), id: faker.number.int(), externalId: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}})}, createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), lastSyncAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), ...overrideResponse})

export const getUpdateHomerunConnectionResponseMock = (): Unit => ({})

export const getGetHomerunConnectionResponseMock = (overrideResponse: Partial<Extract<GetAtsIntegrationConnectionResultHomerunConnectionConfig, object>> = {}): GetAtsIntegrationConnectionResultHomerunConnectionConfig => ({id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(IntegrationType)), status: faker.helpers.arrayElement(Object.values(ConnectionStatus)), config: faker.helpers.arrayElement([{isJobImportEnabled: faker.datatype.boolean(), isCandidateExportEnabled: faker.datatype.boolean()}, undefined]), defaultMessageDto: faker.helpers.arrayElement([{id: faker.number.int(), title: faker.string.alpha({length: {min: 10, max: 20}}), body: faker.string.alpha({length: {min: 10, max: 20}}), isPublic: faker.datatype.boolean(), messageType: faker.helpers.arrayElement(Object.values(DefaultMessageType))}, undefined]), createdByEmployer: {role: faker.helpers.arrayElement(Object.values(Role)), id: faker.number.int(), externalId: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}})}, sendAsEmployer: {role: faker.helpers.arrayElement(Object.values(Role)), id: faker.number.int(), externalId: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}})}, sendFlow: faker.helpers.arrayElement(Object.values(AtsSendFlow)), createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), lastSyncAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), ...overrideResponse})

export const getDeleteIntegrationConnectionResponseMock = (): Unit => ({})

export const getListAtsJobsResponseMock = (overrideResponse: Partial<Extract<ListAtsJobsResult, object>> = {}): ListAtsJobsResult => ({jobs: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.alpha({length: {min: 10, max: 20}}), title: faker.string.alpha({length: {min: 10, max: 20}}), location: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), status: faker.helpers.arrayElement(Object.values(AtsJobMappingStatus)), locationId: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), externalOwnerId: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), externalOwnerUserId: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), externalOwnerDepartmentId: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), key: faker.string.alpha({length: {min: 10, max: 20}})})), hasMore: faker.datatype.boolean(), totalCount: faker.helpers.arrayElement([faker.number.int(), null]), ...overrideResponse})

export const getMapJobWithAtsJobResponseMock = (): Unit => ({})

export const getListAtsVacanciesResponseMock = (overrideResponse: Partial<Extract<ListAtsVacanciesResult, object>> = {}): ListAtsVacanciesResult => ({vacancies: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.alpha({length: {min: 10, max: 20}}), title: faker.string.alpha({length: {min: 10, max: 20}}), location: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), locationId: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), atsStatus: faker.helpers.arrayElement(Object.values(NormalizedOfferStatus)), coupling: faker.helpers.arrayElement([{jobId: faker.number.int(), jobTitle: faker.string.alpha({length: {min: 10, max: 20}}), jobStatus: faker.helpers.arrayElement(Object.values(JobStatus)), mappingStatus: faker.helpers.arrayElement(Object.values(AtsJobMappingStatus)), reopenBlockedAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null])}, undefined]), importState: faker.helpers.arrayElement(Object.values(AtsVacancyImportState)), importError: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), key: faker.string.alpha({length: {min: 10, max: 20}})})), hasMore: faker.datatype.boolean(), totalCount: faker.helpers.arrayElement([faker.number.int(), null]), freeJobSlots: faker.helpers.arrayElement([faker.number.int(), null]), ...overrideResponse})

export const getImportAtsJobResponseMock = (): number => (faker.number.int())

export const getGetAtsConnectionSyncStatusResponseMock = (overrideResponse: Partial<Extract<GetAtsConnectionSyncStatusResult, object>> = {}): GetAtsConnectionSyncStatusResult => ({openCount: faker.number.int(), erroredCount: faker.number.int(), lastSyncAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), ...overrideResponse})

export const getResendOwnAtsJobApplicationsResponseMock = (overrideResponse: Partial<Extract<ResendAtsJobApplicationsResult, object>> = {}): ResendAtsJobApplicationsResult => ({resentCount: faker.number.int(), ...overrideResponse})

export const getConnectMySolutionIntegrationResponseMock = (overrideResponse: Partial<Extract<ConnectMySolutionIntegrationResult, object>> = {}): ConnectMySolutionIntegrationResult => ({connectionId: faker.number.int(), authorizeUrl: faker.string.alpha({length: {min: 10, max: 20}}), ...overrideResponse})

export const getUpdateMySolutionConnectionResponseMock = (): Unit => ({})

export const getGetMySolutionConnectionResponseMock = (overrideResponse: Partial<Extract<GetAtsIntegrationConnectionResultMySolutionConnectionConfig, object>> = {}): GetAtsIntegrationConnectionResultMySolutionConnectionConfig => ({id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(IntegrationType)), status: faker.helpers.arrayElement(Object.values(ConnectionStatus)), config: faker.helpers.arrayElement([{portalDomain: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), applySetApiName: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), firstNameFieldName: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), lastNameFieldName: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), emailFieldName: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), phoneFieldName: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), cvFieldName: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), extraFields: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({apiName: faker.string.alpha({length: {min: 10, max: 20}}), dataType: faker.string.alpha({length: {min: 10, max: 20}}), value: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null])})), null])}, undefined]), defaultMessageDto: faker.helpers.arrayElement([{id: faker.number.int(), title: faker.string.alpha({length: {min: 10, max: 20}}), body: faker.string.alpha({length: {min: 10, max: 20}}), isPublic: faker.datatype.boolean(), messageType: faker.helpers.arrayElement(Object.values(DefaultMessageType))}, undefined]), createdByEmployer: {role: faker.helpers.arrayElement(Object.values(Role)), id: faker.number.int(), externalId: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}})}, sendAsEmployer: {role: faker.helpers.arrayElement(Object.values(Role)), id: faker.number.int(), externalId: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}})}, sendFlow: faker.helpers.arrayElement(Object.values(AtsSendFlow)), createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), lastSyncAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), ...overrideResponse})

export const getGetMySolutionApplyConfigurationResponseMock = (overrideResponse: Partial<Extract<GetMySolutionApplyConfigurationResult, object>> = {}): GetMySolutionApplyConfigurationResult => ({portalConfiguration: {}, applyConfiguration: faker.helpers.arrayElement([{}, undefined]), applyFields: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({apiName: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), label: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), dataType: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), behaviour: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), options: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), null]), objectApiName: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), defaultValue: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null])})), null]), ...overrideResponse})

export const getGetMySolutionWebhookInfoResponseMock = (overrideResponse: Partial<Extract<GetMySolutionWebhookInfoResult, object>> = {}): GetMySolutionWebhookInfoResult => ({webhookUrl: faker.string.alpha({length: {min: 10, max: 20}}), webhookToken: faker.string.alpha({length: {min: 10, max: 20}}), ...overrideResponse})

export const getConnectOtysIntegrationResponseMock = (overrideResponse: Partial<Extract<IntegrationConnectionDto, object>> = {}): IntegrationConnectionDto => ({id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(IntegrationType)), status: faker.helpers.arrayElement(Object.values(ConnectionStatus)), createdBy: {role: faker.helpers.arrayElement(Object.values(Role)), id: faker.number.int(), externalId: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}})}, createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), lastSyncAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), ...overrideResponse})

export const getUpdateOtysConnectionResponseMock = (): Unit => ({})

export const getGetOtysConnectionResponseMock = (overrideResponse: Partial<Extract<GetAtsIntegrationConnectionResultOtysConnectionConfig, object>> = {}): GetAtsIntegrationConnectionResultOtysConnectionConfig => ({id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(IntegrationType)), status: faker.helpers.arrayElement(Object.values(ConnectionStatus)), config: faker.helpers.arrayElement([{portalId: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null])}, undefined]), defaultMessageDto: faker.helpers.arrayElement([{id: faker.number.int(), title: faker.string.alpha({length: {min: 10, max: 20}}), body: faker.string.alpha({length: {min: 10, max: 20}}), isPublic: faker.datatype.boolean(), messageType: faker.helpers.arrayElement(Object.values(DefaultMessageType))}, undefined]), createdByEmployer: {role: faker.helpers.arrayElement(Object.values(Role)), id: faker.number.int(), externalId: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}})}, sendAsEmployer: {role: faker.helpers.arrayElement(Object.values(Role)), id: faker.number.int(), externalId: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}})}, sendFlow: faker.helpers.arrayElement(Object.values(AtsSendFlow)), createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), lastSyncAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), ...overrideResponse})

export const getListOtysPortalsResponseMock = (overrideResponse: Partial<Extract<ListOtysPortalsResult, object>> = {}): ListOtysPortalsResult => ({portals: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({portalId: faker.string.alpha({length: {min: 10, max: 20}}), label: faker.string.alpha({length: {min: 10, max: 20}})})), ...overrideResponse})

export const getUpdateOtysPortalResponseMock = (): Unit => ({})

export const getConnectRecruiteeIntegrationResponseMock = (overrideResponse: Partial<Extract<IntegrationConnectionDto, object>> = {}): IntegrationConnectionDto => ({id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(IntegrationType)), status: faker.helpers.arrayElement(Object.values(ConnectionStatus)), createdBy: {role: faker.helpers.arrayElement(Object.values(Role)), id: faker.number.int(), externalId: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}})}, createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), lastSyncAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), ...overrideResponse})

export const getUpdateRecruiteeConnectionResponseMock = (): Unit => ({})

export const getGetRecruiteeConnectionResponseMock = (overrideResponse: Partial<Extract<GetAtsIntegrationConnectionResultRecruiteeConnectionConfig, object>> = {}): GetAtsIntegrationConnectionResultRecruiteeConnectionConfig => ({id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(IntegrationType)), status: faker.helpers.arrayElement(Object.values(ConnectionStatus)), config: faker.helpers.arrayElement([{gdprExpirationDays: faker.number.int()}, undefined]), defaultMessageDto: faker.helpers.arrayElement([{id: faker.number.int(), title: faker.string.alpha({length: {min: 10, max: 20}}), body: faker.string.alpha({length: {min: 10, max: 20}}), isPublic: faker.datatype.boolean(), messageType: faker.helpers.arrayElement(Object.values(DefaultMessageType))}, undefined]), createdByEmployer: {role: faker.helpers.arrayElement(Object.values(Role)), id: faker.number.int(), externalId: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}})}, sendAsEmployer: {role: faker.helpers.arrayElement(Object.values(Role)), id: faker.number.int(), externalId: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}})}, sendFlow: faker.helpers.arrayElement(Object.values(AtsSendFlow)), createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), lastSyncAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), ...overrideResponse})

export const getGetRecruiteeJobLocationsResponseMock = (overrideResponse: Partial<Extract<GetRecruiteeJobLocationsResult, object>> = {}): GetRecruiteeJobLocationsResult => ({locations: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}})})), ...overrideResponse})

export const getConnectRecruitNowIntegrationResponseMock = (overrideResponse: Partial<Extract<IntegrationConnectionDto, object>> = {}): IntegrationConnectionDto => ({id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(IntegrationType)), status: faker.helpers.arrayElement(Object.values(ConnectionStatus)), createdBy: {role: faker.helpers.arrayElement(Object.values(Role)), id: faker.number.int(), externalId: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}})}, createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), lastSyncAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), ...overrideResponse})

export const getUpdateRecruitNowConnectionResponseMock = (): Unit => ({})

export const getGetRecruitNowConnectionResponseMock = (overrideResponse: Partial<Extract<GetAtsIntegrationConnectionResultRecruitNowConnectionConfig, object>> = {}): GetAtsIntegrationConnectionResultRecruitNowConnectionConfig => ({id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(IntegrationType)), status: faker.helpers.arrayElement(Object.values(ConnectionStatus)), config: faker.helpers.arrayElement([{}, undefined]), defaultMessageDto: faker.helpers.arrayElement([{id: faker.number.int(), title: faker.string.alpha({length: {min: 10, max: 20}}), body: faker.string.alpha({length: {min: 10, max: 20}}), isPublic: faker.datatype.boolean(), messageType: faker.helpers.arrayElement(Object.values(DefaultMessageType))}, undefined]), createdByEmployer: {role: faker.helpers.arrayElement(Object.values(Role)), id: faker.number.int(), externalId: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}})}, sendAsEmployer: {role: faker.helpers.arrayElement(Object.values(Role)), id: faker.number.int(), externalId: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}})}, sendFlow: faker.helpers.arrayElement(Object.values(AtsSendFlow)), createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), lastSyncAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), ...overrideResponse})

export const getUpdateRecruitNowJobMappingResponseMock = (): Unit => ({})

export const getConnectUbeeoIntegrationResponseMock = (overrideResponse: Partial<Extract<IntegrationConnectionDto, object>> = {}): IntegrationConnectionDto => ({id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(IntegrationType)), status: faker.helpers.arrayElement(Object.values(ConnectionStatus)), createdBy: {role: faker.helpers.arrayElement(Object.values(Role)), id: faker.number.int(), externalId: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}})}, createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), lastSyncAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), ...overrideResponse})

export const getUpdateUbeeoConnectionResponseMock = (): Unit => ({})

export const getGetUbeeoConnectionResponseMock = (overrideResponse: Partial<Extract<GetAtsIntegrationConnectionResultUbeeoConnectionConfig, object>> = {}): GetAtsIntegrationConnectionResultUbeeoConnectionConfig => ({id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(IntegrationType)), status: faker.helpers.arrayElement(Object.values(ConnectionStatus)), config: faker.helpers.arrayElement([{}, undefined]), defaultMessageDto: faker.helpers.arrayElement([{id: faker.number.int(), title: faker.string.alpha({length: {min: 10, max: 20}}), body: faker.string.alpha({length: {min: 10, max: 20}}), isPublic: faker.datatype.boolean(), messageType: faker.helpers.arrayElement(Object.values(DefaultMessageType))}, undefined]), createdByEmployer: {role: faker.helpers.arrayElement(Object.values(Role)), id: faker.number.int(), externalId: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}})}, sendAsEmployer: {role: faker.helpers.arrayElement(Object.values(Role)), id: faker.number.int(), externalId: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}})}, sendFlow: faker.helpers.arrayElement(Object.values(AtsSendFlow)), createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), lastSyncAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), ...overrideResponse})

export const getListReferralInvitesResponseMock = (overrideResponse: Partial<Extract<ListReferralInvitesResult, object>> = {}): ListReferralInvitesResult => ({invites: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({email: faker.string.alpha({length: {min: 10, max: 20}}), createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), isCompleted: faker.datatype.boolean()})), ...overrideResponse})

export const getGetEmployerAccessResponseMock = (overrideResponse: Partial<Extract<GetEmployerAccessResult, object>> = {}): GetEmployerAccessResult => ({canAccessOtherCompanies: faker.datatype.boolean(), permissions: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({resource: faker.helpers.arrayElement(Object.values(PermissionResource)), level: faker.helpers.arrayElement(Object.values(PermissionLevel))})), roles: faker.helpers.arrayElements(Object.values(EmployerRole)), ...overrideResponse})

export const getGetProfileResponseMock = (overrideResponse: Partial<Extract<GetEmployerProfileResult, object>> = {}): GetEmployerProfileResult => ({id: faker.number.int(), externalId: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}}), reportingPeriodicity: faker.helpers.arrayElement(Object.values(ReportingPeriodicity)), companyId: faker.number.int(), companyName: faker.string.alpha({length: {min: 10, max: 20}}), originalCompanyId: faker.helpers.arrayElement([faker.number.int(), null]), originalCompanyName: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), hasSubscription: faker.datatype.boolean(), phoneNumber: faker.string.alpha({length: {min: 10, max: 20}}), jobTitle: faker.string.alpha({length: {min: 10, max: 20}}), profilePicture: faker.helpers.arrayElement([{id: faker.string.uuid(), fileName: faker.string.alpha({length: {min: 10, max: 20}}), url: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), ...overrideResponse})

export const getUpdateProfileResponseMock = (): number => (faker.number.int())

export const getUploadEmployerProfilePictureResponseMock = (overrideResponse: Partial<Extract<ImageDto, object>> = {}): ImageDto => ({id: faker.string.uuid(), fileName: faker.string.alpha({length: {min: 10, max: 20}}), url: faker.string.alpha({length: {min: 10, max: 20}}), ...overrideResponse})

export const getGetStatisticsResponseMock = (overrideResponse: Partial<Extract<GetCompanyStatisticsResult, object>> = {}): GetCompanyStatisticsResult => ({waitingJobApplicationCount: faker.number.int(), totalJobApplicationCount: faker.number.int(), publishedJobCount: faker.number.int(), unhandledMatchCount: faker.number.int(), totalMatchCount: faker.number.int(), ...overrideResponse})

export const getListUnhandledJobsResponseMock = (overrideResponse: Partial<Extract<ListUnhandledJobsResult, object>> = {}): ListUnhandledJobsResult => ({jobs: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), title: faker.string.alpha({length: {min: 10, max: 20}}), functionTitle: faker.string.alpha({length: {min: 10, max: 20}}), unhandledJobApplicationCount: faker.number.int(), lastApplicationAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z')})), hasSubscribedJobs: faker.datatype.boolean(), ...overrideResponse})

export const getGetConferenceInfoResponseMock = (overrideResponse: Partial<Extract<GetConferenceInfoResult, object>> = {}): GetConferenceInfoResult => ({conference: faker.helpers.arrayElement([{conferenceId: faker.number.int(), date: {start: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), end: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null])}, companyJobsVisibleWithinApp: {start: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), end: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null])}, conferenceModuleVisibleWithinApp: {start: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), end: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null])}, conferenceArea: faker.string.alpha({length: {min: 10, max: 20}}), standNumber: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), ...overrideResponse})

export const getListConferenceChatsEmployerResponseMock = (overrideResponse: Partial<Extract<ListConferenceChatsResult, object>> = {}): ListConferenceChatsResult => ({chats: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({info: {id: faker.number.int(), createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), unreadCount: faker.number.int(), otherParticipant: {viewingUserRole: faker.helpers.arrayElement(Object.values(ChatMessageSenderRole)), id: faker.number.int(), displayName: faker.string.alpha({length: {min: 10, max: 20}}), imageUrl: faker.string.alpha({length: {min: 10, max: 20}})}, isUserResponseMissing: faker.datatype.boolean(), lastMessageBody: faker.string.alpha({length: {min: 10, max: 20}}), lastMessageAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z')}, job: faker.helpers.arrayElement([{id: faker.number.int(), title: faker.string.alpha({length: {min: 10, max: 20}}), subtitle: faker.string.alpha({length: {min: 10, max: 20}})}, undefined])})), ...overrideResponse})

export const getSendConferenceChatMessageEmployerResponseMock = (overrideResponse: Partial<Extract<ChatMessageDto, object>> = {}): ChatMessageDto => ({id: faker.number.int(), chatId: faker.number.int(), employerId: faker.helpers.arrayElement([faker.number.int(), null]), userId: faker.helpers.arrayElement([faker.number.int(), null]), isRead: faker.datatype.boolean(), senderRole: faker.helpers.arrayElement(Object.values(ChatMessageSenderRole)), sender: faker.string.alpha({length: {min: 10, max: 20}}), body: faker.string.alpha({length: {min: 10, max: 20}}), createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), poll: faker.helpers.arrayElement([{id: faker.number.int(), matchId: faker.number.int(), dates: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'))), selectedDate: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), answeredAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null])}, undefined]), phase: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(ChatMessagePhase)), undefined]), ...overrideResponse})

export const getListUnreadConferenceChatsEmployerResponseMock = (overrideResponse: Partial<Extract<ListUnreadConferenceChatsResult, object>> = {}): ListUnreadConferenceChatsResult => ({chats: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({info: {id: faker.number.int(), createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), unreadCount: faker.number.int(), otherParticipant: {viewingUserRole: faker.helpers.arrayElement(Object.values(ChatMessageSenderRole)), id: faker.number.int(), displayName: faker.string.alpha({length: {min: 10, max: 20}}), imageUrl: faker.string.alpha({length: {min: 10, max: 20}})}, isUserResponseMissing: faker.datatype.boolean(), lastMessageBody: faker.string.alpha({length: {min: 10, max: 20}}), lastMessageAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z')}, job: faker.helpers.arrayElement([{id: faker.number.int(), title: faker.string.alpha({length: {min: 10, max: 20}}), subtitle: faker.string.alpha({length: {min: 10, max: 20}})}, undefined])})), ...overrideResponse})

export const getGetConferenceChatWithMessagesForEmployerResponseMock = (overrideResponse: Partial<Extract<GetConferenceChatWithMessagesForEmployerResult, object>> = {}): GetConferenceChatWithMessagesForEmployerResult => ({chat: {info: {id: faker.number.int(), createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), unreadCount: faker.number.int(), otherParticipant: {viewingUserRole: faker.helpers.arrayElement(Object.values(ChatMessageSenderRole)), id: faker.number.int(), displayName: faker.string.alpha({length: {min: 10, max: 20}}), imageUrl: faker.string.alpha({length: {min: 10, max: 20}})}, isUserResponseMissing: faker.datatype.boolean(), lastMessageBody: faker.string.alpha({length: {min: 10, max: 20}}), lastMessageAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z')}, job: faker.helpers.arrayElement([{id: faker.number.int(), title: faker.string.alpha({length: {min: 10, max: 20}}), subtitle: faker.string.alpha({length: {min: 10, max: 20}})}, undefined])}, messages: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), chatId: faker.number.int(), employerId: faker.helpers.arrayElement([faker.number.int(), null]), userId: faker.helpers.arrayElement([faker.number.int(), null]), isRead: faker.datatype.boolean(), senderRole: faker.helpers.arrayElement(Object.values(ChatMessageSenderRole)), sender: faker.string.alpha({length: {min: 10, max: 20}}), body: faker.string.alpha({length: {min: 10, max: 20}}), createdAt: new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), poll: faker.helpers.arrayElement([{id: faker.number.int(), matchId: faker.number.int(), dates: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'))), selectedDate: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), answeredAt: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null])}, undefined]), phase: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(ChatMessagePhase)), undefined])})), ...overrideResponse})

export const getListManagedCompaniesResponseMock = (overrideResponse: Partial<Extract<ListManagedCompaniesResult, object>> = {}): ListManagedCompaniesResult => ({companies: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})})), ...overrideResponse})

export const getGetMyCompanyResponseMock = (overrideResponse: Partial<Extract<GetCompanyFromPortalResult, object>> = {}): GetCompanyFromPortalResult => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}}), location: {id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}}), geolocation: {latitude: faker.number.float({fractionDigits: 2}), longitude: faker.number.float({fractionDigits: 2})}}, aboutUs: faker.string.alpha({length: {min: 10, max: 20}}), culture: faker.string.alpha({length: {min: 10, max: 20}}), employeeCount: {lower: faker.number.int(), upper: faker.helpers.arrayElement([faker.number.int(), null])}, employeeStory: faker.string.alpha({length: {min: 10, max: 20}}), employeeName: faker.string.alpha({length: {min: 10, max: 20}}), employeeFunction: faker.string.alpha({length: {min: 10, max: 20}}), logo: faker.helpers.arrayElement([{id: faker.string.uuid(), fileName: faker.string.alpha({length: {min: 10, max: 20}}), url: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), cover: faker.helpers.arrayElement([{id: faker.string.uuid(), fileName: faker.string.alpha({length: {min: 10, max: 20}}), url: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), employeeProfilePicture: faker.helpers.arrayElement([{id: faker.string.uuid(), fileName: faker.string.alpha({length: {min: 10, max: 20}}), url: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), generalImages: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), fileName: faker.string.alpha({length: {min: 10, max: 20}}), url: faker.string.alpha({length: {min: 10, max: 20}})})), videoThumbnailUrl: faker.string.alpha({length: {min: 10, max: 20}}), videoUrl: faker.string.alpha({length: {min: 10, max: 20}}), defaultMessages: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), title: faker.string.alpha({length: {min: 10, max: 20}}), body: faker.string.alpha({length: {min: 10, max: 20}}), isPublic: faker.datatype.boolean(), messageType: faker.helpers.arrayElement(Object.values(DefaultMessageType))})), accountManager: faker.helpers.arrayElement([{firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), phoneNumber: faker.string.alpha({length: {min: 10, max: 20}}), profilePictureUrl: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null])}, undefined]), relatedCompanies: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})})), calendarInviteBody: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), childCompanies: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}}), employerIds: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.number.int()))})), parentCompanyEmployerIds: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.number.int())), parentCompany: faker.helpers.arrayElement([{id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), ...overrideResponse})

export const getUpdateMyCompanyResponseMock = (): number => (faker.number.int())

export const getDeleteMyCompanyResponseMock = (): number => (faker.number.int())

export const getGetMyCompanyPlanResponseMock = (overrideResponse: Partial<Extract<GetCompanyPlanResult, object>> = {}): GetCompanyPlanResult => ({hasSubscription: faker.datatype.boolean(), subscriptionStartsOn: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 10)), null]), jobSlots: faker.helpers.arrayElement([faker.number.int(), null]), activeJobs: faker.number.int(), scoutCredits: faker.number.int(), matchCredits: faker.helpers.arrayElement([faker.number.int(), null]), canMatch: faker.datatype.boolean(), mainAtsIntegrationConnectionId: faker.helpers.arrayElement([faker.number.int(), null]), mainAtsIntegrationType: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(IntegrationType)), undefined]), integrationTypes: faker.helpers.arrayElements(Object.values(IntegrationType)), defaultCandidatePoolSize: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(CandidatePoolSize)), undefined]), rememberCandidatePoolSizePreference: faker.datatype.boolean(), ...overrideResponse})

export const getListEmployersForCompanyResponseMock = (overrideResponse: Partial<Extract<ListOtherEmployersForCompanyResult, object>> = {}): ListOtherEmployersForCompanyResult => ({employers: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.helpers.arrayElement([faker.number.int(), null]), inviteId: faker.helpers.arrayElement([faker.number.int(), null]), name: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}}), isInternal: faker.datatype.boolean(), role: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), profilePictureUrl: faker.string.alpha({length: {min: 10, max: 20}})})), ...overrideResponse})

export const getUpdateEmployerCompanyAccessResponseMock = (overrideResponse: Partial<Extract<UpdateEmployerCompanyAccessResult, object>> = {}): UpdateEmployerCompanyAccessResult => ({assignmentsCreated: faker.number.int(), assignedCompanies: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})})), assignmentsRemoved: faker.number.int(), removedCompanies: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})})), ...overrideResponse})

export const getAddOrUpdateDefaultMessageResponseMock = (overrideResponse: Partial<Extract<AddOrUpdateDefaultMessageResult, object>> = {}): AddOrUpdateDefaultMessageResult => ({defaultMessages: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), title: faker.string.alpha({length: {min: 10, max: 20}}), body: faker.string.alpha({length: {min: 10, max: 20}}), isPublic: faker.datatype.boolean(), messageType: faker.helpers.arrayElement(Object.values(DefaultMessageType))})), ...overrideResponse})

export const getDeleteDefaultMessageResponseMock = (overrideResponse: Partial<Extract<DeleteDefaultMessageResult, object>> = {}): DeleteDefaultMessageResult => ({defaultMessages: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), title: faker.string.alpha({length: {min: 10, max: 20}}), body: faker.string.alpha({length: {min: 10, max: 20}}), isPublic: faker.datatype.boolean(), messageType: faker.helpers.arrayElement(Object.values(DefaultMessageType))})), ...overrideResponse})

export const getUploadProvisionalImageResponseMock = (overrideResponse: Partial<Extract<ImageDto, object>> = {}): ImageDto => ({id: faker.string.uuid(), fileName: faker.string.alpha({length: {min: 10, max: 20}}), url: faker.string.alpha({length: {min: 10, max: 20}}), ...overrideResponse})

export const getSendRequestToAccountManagerResponseMock = (): Unit => ({})

export const getUpdateDefaultCandidatePoolResponseMock = (): Unit => ({})

export const getUpdateCalendarInviteBodyResponseMock = (): Unit => ({})

export const getGetCompanyHireReportInfoResponseMock = (overrideResponse: Partial<Extract<GetCompanyHireReportInfoResult, object>> = {}): GetCompanyHireReportInfoResult => ({firstDay: faker.helpers.arrayElement([new Date(faker.date.past().toISOString().slice(0, 19) + 'Z'), null]), isFirstReport: faker.datatype.boolean(), hasMatches: faker.datatype.boolean(), registeredHireCount: faker.number.int(), ...overrideResponse})

export const getCreateCompanyHireReportResponseMock = (): CreateCompanyHireReport => ({})

export const getGetMatchingConfigurationResponseMock = (overrideResponse: Partial<Extract<GetCompanyMatchingConfigurationResult, object>> = {}): GetCompanyMatchingConfigurationResult => ({matchingConfiguration: faker.helpers.arrayElement([{workExperienceImportance: faker.helpers.arrayElement(Object.values(FeatureImportance)), educationImportance: faker.helpers.arrayElement(Object.values(FeatureImportance)), hardSkillsImportance: faker.helpers.arrayElement(Object.values(FeatureImportance)), personalityImportance: faker.helpers.arrayElement(Object.values(FeatureImportance))}, undefined]), ...overrideResponse})

export const getComposeAiJobResponseMock = (overrideResponse: Partial<Extract<ComposeAiJobResult, object>> = {}): ComposeAiJobResult => ({aiJobId: faker.number.int(), data: {functionTitle: faker.string.alpha({length: {min: 10, max: 20}}), jobFunction: faker.helpers.arrayElement([{id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), jobCategories: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})})), locations: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})})), locationsSource: faker.helpers.arrayElement(Object.values(DeterminationSource)), hoursLower: faker.number.int(), hoursUpper: faker.number.int(), hoursSource: faker.helpers.arrayElement(Object.values(DeterminationSource)), experienceLevel: faker.helpers.arrayElement(Object.values(ExperienceLevel)), experienceLevelSource: faker.helpers.arrayElement(Object.values(DeterminationSource)), educationLevels: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})})), educationLevelsSource: faker.helpers.arrayElement(Object.values(DeterminationSource)), salary: faker.helpers.arrayElement([{lower: faker.number.float({fractionDigits: 2}), upper: faker.number.float({fractionDigits: 2}), periodicity: faker.helpers.arrayElement(Object.values(Periodicity))}, undefined]), salarySource: faker.helpers.arrayElement(Object.values(DeterminationSource)), hardSkills: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})})), certificates: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})})), languages: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})})), personalityColor: faker.helpers.arrayElement(Object.values(CharacteristicColor)), personalityColorSource: faker.helpers.arrayElement(Object.values(DeterminationSource)), reasoningSummary: faker.string.alpha({length: {min: 10, max: 20}}), isRemote: faker.datatype.boolean(), isRemoteSource: faker.helpers.arrayElement(Object.values(DeterminationSource)), reasonings: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({field: faker.helpers.arrayElement(Object.values(AiJobDataField)), reasoning: faker.string.alpha({length: {min: 10, max: 20}})})), issues: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({field: faker.helpers.arrayElement(Object.values(AiJobDataField)), message: faker.string.alpha({length: {min: 10, max: 20}}), suggestion: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null])}))}, sections: {title: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), opening: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), duties: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), requirements: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), benefitsAndPerks: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), closing: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null])}, locations: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}}), geolocation: {latitude: faker.number.float({fractionDigits: 2}), longitude: faker.number.float({fractionDigits: 2})}})), ...overrideResponse})

export const getExtractVacancyFromPageResponseMock = (overrideResponse: Partial<Extract<ExtractVacancyFromPageResult, object>> = {}): ExtractVacancyFromPageResult => ({vacancyText: faker.string.alpha({length: {min: 10, max: 20}}), title: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), pageTitle: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), ...overrideResponse})

export const getDetermineJobFunctionResponseMock = (overrideResponse: Partial<Extract<DetermineJobFunctionResult, object>> = {}): DetermineJobFunctionResult => ({jobFunctionId: faker.number.int(), jobCategoryId: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}}), ...overrideResponse})

export const getDetermineAiJobDataResponseMock = (overrideResponse: Partial<Extract<DetermineAiJobDataResult, object>> = {}): DetermineAiJobDataResult => ({aiJobId: faker.number.int(), data: {functionTitle: faker.string.alpha({length: {min: 10, max: 20}}), jobFunction: faker.helpers.arrayElement([{id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), jobCategories: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})})), locations: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})})), locationsSource: faker.helpers.arrayElement(Object.values(DeterminationSource)), hoursLower: faker.number.int(), hoursUpper: faker.number.int(), hoursSource: faker.helpers.arrayElement(Object.values(DeterminationSource)), experienceLevel: faker.helpers.arrayElement(Object.values(ExperienceLevel)), experienceLevelSource: faker.helpers.arrayElement(Object.values(DeterminationSource)), educationLevels: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})})), educationLevelsSource: faker.helpers.arrayElement(Object.values(DeterminationSource)), salary: faker.helpers.arrayElement([{lower: faker.number.float({fractionDigits: 2}), upper: faker.number.float({fractionDigits: 2}), periodicity: faker.helpers.arrayElement(Object.values(Periodicity))}, undefined]), salarySource: faker.helpers.arrayElement(Object.values(DeterminationSource)), hardSkills: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})})), certificates: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})})), languages: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})})), personalityColor: faker.helpers.arrayElement(Object.values(CharacteristicColor)), personalityColorSource: faker.helpers.arrayElement(Object.values(DeterminationSource)), reasoningSummary: faker.string.alpha({length: {min: 10, max: 20}}), isRemote: faker.datatype.boolean(), isRemoteSource: faker.helpers.arrayElement(Object.values(DeterminationSource)), reasonings: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({field: faker.helpers.arrayElement(Object.values(AiJobDataField)), reasoning: faker.string.alpha({length: {min: 10, max: 20}})})), issues: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({field: faker.helpers.arrayElement(Object.values(AiJobDataField)), message: faker.string.alpha({length: {min: 10, max: 20}}), suggestion: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null])}))}, locations: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}}), geolocation: {latitude: faker.number.float({fractionDigits: 2}), longitude: faker.number.float({fractionDigits: 2})}})), ...overrideResponse})

export const getWriteAiJobSectionsResponseMock = (overrideResponse: Partial<Extract<WriteAiJobSectionsResult, object>> = {}): WriteAiJobSectionsResult => ({sections: {title: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), opening: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), duties: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), requirements: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), benefitsAndPerks: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), closing: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null])}, ...overrideResponse})

export const getChatWithJobAgentResponseMock = (overrideResponse: Partial<Extract<ChatWithJobAgentResult, object>> = {}): ChatWithJobAgentResult => ({reply: faker.string.alpha({length: {min: 10, max: 20}}), updatedData: faker.helpers.arrayElement([{functionTitle: faker.string.alpha({length: {min: 10, max: 20}}), jobFunction: faker.helpers.arrayElement([{id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), jobCategories: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})})), locations: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})})), locationsSource: faker.helpers.arrayElement(Object.values(DeterminationSource)), hoursLower: faker.number.int(), hoursUpper: faker.number.int(), hoursSource: faker.helpers.arrayElement(Object.values(DeterminationSource)), experienceLevel: faker.helpers.arrayElement(Object.values(ExperienceLevel)), experienceLevelSource: faker.helpers.arrayElement(Object.values(DeterminationSource)), educationLevels: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})})), educationLevelsSource: faker.helpers.arrayElement(Object.values(DeterminationSource)), salary: faker.helpers.arrayElement([{lower: faker.number.float({fractionDigits: 2}), upper: faker.number.float({fractionDigits: 2}), periodicity: faker.helpers.arrayElement(Object.values(Periodicity))}, undefined]), salarySource: faker.helpers.arrayElement(Object.values(DeterminationSource)), hardSkills: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})})), certificates: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})})), languages: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})})), personalityColor: faker.helpers.arrayElement(Object.values(CharacteristicColor)), personalityColorSource: faker.helpers.arrayElement(Object.values(DeterminationSource)), reasoningSummary: faker.string.alpha({length: {min: 10, max: 20}}), isRemote: faker.datatype.boolean(), isRemoteSource: faker.helpers.arrayElement(Object.values(DeterminationSource)), reasonings: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({field: faker.helpers.arrayElement(Object.values(AiJobDataField)), reasoning: faker.string.alpha({length: {min: 10, max: 20}})})), issues: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({field: faker.helpers.arrayElement(Object.values(AiJobDataField)), message: faker.string.alpha({length: {min: 10, max: 20}}), suggestion: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null])}))}, undefined]), updatedLocations: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}}), geolocation: {latitude: faker.number.float({fractionDigits: 2}), longitude: faker.number.float({fractionDigits: 2})}})), null]), updatedSections: faker.helpers.arrayElement([{title: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), opening: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), duties: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), requirements: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), benefitsAndPerks: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), closing: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null])}, undefined]), toolCalls: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({tool: faker.string.alpha({length: {min: 10, max: 20}}), arguments: faker.string.alpha({length: {min: 10, max: 20}})})), ...overrideResponse})

export const getRewriteJobSectionResponseMock = (overrideResponse: Partial<Extract<RewriteJobSectionResult, object>> = {}): RewriteJobSectionResult => ({text: faker.string.alpha({length: {min: 10, max: 20}}), toolCalls: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({tool: faker.string.alpha({length: {min: 10, max: 20}}), arguments: faker.string.alpha({length: {min: 10, max: 20}})})), ...overrideResponse})

export const getReviewAiJobResponseMock = (): boolean => (faker.datatype.boolean())

export const getListEducationLevelsResponseMock = (overrideResponse: Partial<Extract<ListEducationLevelsResult, object>> = {}): ListEducationLevelsResult => ({educationLevels: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})})), ...overrideResponse})

export const getListPersonalCharacteristicsResponseMock = (overrideResponse: Partial<Extract<ListPersonalCharacteristicsResult, object>> = {}): ListPersonalCharacteristicsResult => ({personalCharacteristics: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}}), color: faker.helpers.arrayElement(Object.values(CharacteristicColor))})), ...overrideResponse})

export const getListNewJobReasonsResponseMock = (overrideResponse: Partial<Extract<ListNewJobReasonsResult, object>> = {}): ListNewJobReasonsResult => ({newJobReasons: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})})), ...overrideResponse})

export const getListPersonalityTypesResponseMock = (overrideResponse: Partial<Extract<ListPersonalityTypesResult, object>> = {}): ListPersonalityTypesResult => ({personalityTypes: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}}), summary: faker.string.alpha({length: {min: 10, max: 20}}), energizers: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), drainers: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}})))})), ...overrideResponse})

export const getGetAutoCompleteLocationsResponseMock = (overrideResponse: Partial<Extract<GetAutoCompleteLocationsResult, object>> = {}): GetAutoCompleteLocationsResult => ({sessionToken: faker.string.uuid(), locations: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({placeId: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}})})), ...overrideResponse})

export const getGetLocationDetailsResponseMock = (overrideResponse: Partial<Extract<GetLocationDetailsResult, object>> = {}): GetLocationDetailsResult => ({location: {id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}}), geolocation: {latitude: faker.number.float({fractionDigits: 2}), longitude: faker.number.float({fractionDigits: 2})}}, ...overrideResponse})

export const getGetLocationGeocodeResponseMock = (overrideResponse: Partial<Extract<GetLocationGeocodeResult, object>> = {}): GetLocationGeocodeResult => ({coordinates: {latitude: faker.number.float({fractionDigits: 2}), longitude: faker.number.float({fractionDigits: 2})}, name: faker.string.alpha({length: {min: 10, max: 20}}), placeId: faker.string.alpha({length: {min: 10, max: 20}}), ...overrideResponse})

export const getListSkillsCertificatesAndLanguagesResponseMock = (overrideResponse: Partial<Extract<ListSkillsCertificatesAndLanguagesResult, object>> = {}): ListSkillsCertificatesAndLanguagesResult => ({languages: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(SkillType)), name: faker.string.alpha({length: {min: 10, max: 20}}), tag: faker.string.alpha({length: {min: 10, max: 20}})})), skills: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(SkillType)), name: faker.string.alpha({length: {min: 10, max: 20}}), tag: faker.string.alpha({length: {min: 10, max: 20}})})), certificates: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(SkillType)), name: faker.string.alpha({length: {min: 10, max: 20}}), tag: faker.string.alpha({length: {min: 10, max: 20}})})), ...overrideResponse})

export const getListAllSkillsResponseMock = (overrideResponse: Partial<Extract<ListAllSkillsResult, object>> = {}): ListAllSkillsResult => ({softSkills: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(SkillType)), name: faker.string.alpha({length: {min: 10, max: 20}}), tag: faker.string.alpha({length: {min: 10, max: 20}})})), languages: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(SkillType)), name: faker.string.alpha({length: {min: 10, max: 20}}), tag: faker.string.alpha({length: {min: 10, max: 20}})})), hardSkills: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(SkillType)), name: faker.string.alpha({length: {min: 10, max: 20}}), tag: faker.string.alpha({length: {min: 10, max: 20}}), jobCategoryIds: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.number.int()))})), ...overrideResponse})

export const getListSkillsForJobCategoriesResponseMock = (overrideResponse: Partial<Extract<ListSkillsForJobCategoriesResult, object>> = {}): ListSkillsForJobCategoriesResult => ({skills: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(SkillType)), name: faker.string.alpha({length: {min: 10, max: 20}}), tag: faker.string.alpha({length: {min: 10, max: 20}})})), ...overrideResponse})

export const getListCertificatesResponseMock = (overrideResponse: Partial<Extract<ListCertificatesResult, object>> = {}): ListCertificatesResult => ({certificates: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), type: faker.helpers.arrayElement(Object.values(SkillType)), name: faker.string.alpha({length: {min: 10, max: 20}}), tag: faker.string.alpha({length: {min: 10, max: 20}}), jobCategoryIds: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.number.int()))})), ...overrideResponse})

export const getListJobFunctionsResponseMock = (overrideResponse: Partial<Extract<JobFunctionCrudListResult, object>> = {}): JobFunctionCrudListResult => ({jobFunctions: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})})), ...overrideResponse})

export const getListSimilarJobFunctionsResponseMock = (overrideResponse: Partial<Extract<ListSimilarJobFunctionsResult, object>> = {}): ListSimilarJobFunctionsResult => ({groups: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({sourceJobFunction: {id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})}, relatedFunctions: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})}))})), ...overrideResponse})

export const getListJobCategoriesResponseMock = (overrideResponse: Partial<Extract<JobCategoryCrudListResult, object>> = {}): JobCategoryCrudListResult => ({jobCategories: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}}), categoryCode: faker.string.alpha({length: {min: 10, max: 20}}), defaultSalaryPeriodicity: faker.helpers.arrayElement(Object.values(Periodicity)), salaryConversionFactor: faker.number.float({fractionDigits: 2}), jobFunctions: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})}))})), ...overrideResponse})

export const getGetJobCategoryResponseMock = (overrideResponse: Partial<Extract<JobCategoryCrudJobCategoryDto, object>> = {}): JobCategoryCrudJobCategoryDto => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}}), categoryCode: faker.string.alpha({length: {min: 10, max: 20}}), defaultSalaryPeriodicity: faker.helpers.arrayElement(Object.values(Periodicity)), salaryConversionFactor: faker.number.float({fractionDigits: 2}), jobFunctions: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})})), ...overrideResponse})

export const getListInterestsResponseMock = (overrideResponse: Partial<Extract<ListInterestsResult, object>> = {}): ListInterestsResult => ({interests: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.number.int(), name: faker.string.alpha({length: {min: 10, max: 20}})})), ...overrideResponse})

export const getGetRoleResponseMock = (overrideResponse: Partial<Extract<GetRoleResult, object>> = {}): GetRoleResult => ({role: faker.helpers.arrayElement(Object.values(Role)), ...overrideResponse})


export const getAddUserCommentMockHandler = (overrideResponse?: void | ((info: Parameters<HttpResponseResolver<PathParams, AddUserCommentCommandDto>>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post<PathParams, AddUserCommentCommandDto>('*/v1/employer/user/comments', async (info: Parameters<HttpResponseResolver<PathParams, AddUserCommentCommandDto>>[0]) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 201
      })
  }, options)
}

export const getGetUserCommentsMockHandler = (overrideResponse?: GetUserCommentsResult | ((info: Parameters<HttpResponseResolver<{ userId: string }>>[0]) => Promise<GetUserCommentsResult> | GetUserCommentsResult), options?: RequestHandlerOptions) => {
  return http.get<{ userId: string }>('*/v1/employer/user/comments/:userId', async (info: Parameters<HttpResponseResolver<{ userId: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetUserCommentsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getEditUserCommentMockHandler = (overrideResponse?: void | ((info: Parameters<HttpResponseResolver<{ commentId: string }, EditUserCommentCommandDto>>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.put<{ commentId: string }, EditUserCommentCommandDto>('*/v1/employer/user/comments/:commentId', async (info: Parameters<HttpResponseResolver<{ commentId: string }, EditUserCommentCommandDto>>[0]) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getDeleteUserCommentMockHandler = (overrideResponse?: void | ((info: Parameters<HttpResponseResolver<{ commentId: string }>>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete<{ commentId: string }>('*/v1/employer/user/comments/:commentId', async (info: Parameters<HttpResponseResolver<{ commentId: string }>>[0]) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 204
      })
  }, options)
}

export const getResetEmployerAccountForTestingMockHandler = (overrideResponse?: void | ((info: Parameters<HttpResponseResolver>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post('*/testing-employer/reset', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 200
      })
  }, options)
}

export const getListEducationLevelsWithTrackCategoryMockHandler = (overrideResponse?: ListEducationLevelsWithTrackCategoryResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<ListEducationLevelsWithTrackCategoryResult> | ListEducationLevelsWithTrackCategoryResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/static-data/education-levels', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListEducationLevelsWithTrackCategoryResponseMock(),
      { status: 200
      })
  }, options)
}

export const getCreateCompanyForEmployerMockHandler = (overrideResponse?: void | ((info: Parameters<HttpResponseResolver<PathParams, CreateCompanyForEmployerCommandDto>>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post<PathParams, CreateCompanyForEmployerCommandDto>('*/employer/employer-onboarding/create-company', async (info: Parameters<HttpResponseResolver<PathParams, CreateCompanyForEmployerCommandDto>>[0]) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 200
      })
  }, options)
}

export const getListPaymentOptionsMockHandler = (overrideResponse?: ListPaymentOptionsResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<ListPaymentOptionsResult> | ListPaymentOptionsResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/employer-onboarding/payment-options', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListPaymentOptionsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getCreateEmployerMockHandler = (overrideResponse?: CreateEmployerResponse | ((info: Parameters<HttpResponseResolver<PathParams, CreateEmployerCommandDto>>[0]) => Promise<CreateEmployerResponse> | CreateEmployerResponse), options?: RequestHandlerOptions) => {
  return http.post<PathParams, CreateEmployerCommandDto>('*/employer/v2/onboarding/register', async (info: Parameters<HttpResponseResolver<PathParams, CreateEmployerCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getCreateEmployerResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetEmployerOnboardingStatusMockHandler = (overrideResponse?: GetEmployerOnboardingStatusResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<GetEmployerOnboardingStatusResult> | GetEmployerOnboardingStatusResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/v2/onboarding', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetEmployerOnboardingStatusResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListAllMatchesMockHandler = (overrideResponse?: ListMatchesResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<ListMatchesResult> | ListMatchesResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/match', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListAllMatchesResponseMock(),
      { status: 200
      })
  }, options)
}

export const getHasUnreadMatchesMockHandler = (overrideResponse?: boolean | ((info: Parameters<HttpResponseResolver>[0]) => Promise<boolean> | boolean), options?: RequestHandlerOptions) => {
  return http.get('*/employer/match/has-unread', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getHasUnreadMatchesResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetMatchedUserMockHandler = (overrideResponse?: GetMatchedUserResult | ((info: Parameters<HttpResponseResolver<{ id: string }>>[0]) => Promise<GetMatchedUserResult> | GetMatchedUserResult), options?: RequestHandlerOptions) => {
  return http.get<{ id: string }>('*/employer/match/:id/user', async (info: Parameters<HttpResponseResolver<{ id: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetMatchedUserResponseMock(),
      { status: 200
      })
  }, options)
}

export const getDownloadCandidatePdfMockHandler = (overrideResponse?: Blob | ((info: Parameters<HttpResponseResolver<{ id: string }>>[0]) => Promise<Blob> | Blob), options?: RequestHandlerOptions) => {
  return http.get<{ id: string }>('*/employer/match/:id/candidate-pdf', async (info: Parameters<HttpResponseResolver<{ id: string }>>[0]) => {await delay(100);

  const binaryBody = overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getDownloadCandidatePdfResponseMock();
    return new HttpResponse(binaryBody,
      { status: 200,
        headers: { 'Content-Type': 'application/pdf' }
      })
  }, options)
}

export const getCreatePhoneContactAttemptMockHandler = (overrideResponse?: void | ((info: Parameters<HttpResponseResolver<PathParams, CreatePhoneContactAttemptCommandDto>>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post<PathParams, CreatePhoneContactAttemptCommandDto>('*/employer/match/phone-contact-attempt', async (info: Parameters<HttpResponseResolver<PathParams, CreatePhoneContactAttemptCommandDto>>[0]) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 200
      })
  }, options)
}

export const getCloseMatchMockHandler = (overrideResponse?: void | ((info: Parameters<HttpResponseResolver<PathParams, CloseMatchCommandDto>>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post<PathParams, CloseMatchCommandDto>('*/employer/match/close', async (info: Parameters<HttpResponseResolver<PathParams, CloseMatchCommandDto>>[0]) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 200
      })
  }, options)
}

export const getUpdateMatchMockHandler = (overrideResponse?: void | ((info: Parameters<HttpResponseResolver<PathParams, UpdateMatchCommandDto>>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.put<PathParams, UpdateMatchCommandDto>('*/employer/match/status', async (info: Parameters<HttpResponseResolver<PathParams, UpdateMatchCommandDto>>[0]) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 200
      })
  }, options)
}

export const getListMatchesByStageMockHandler = (overrideResponse?: ListMatchesByStageResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<ListMatchesByStageResult> | ListMatchesByStageResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/match/dashboard', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListMatchesByStageResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetMatchChatWithMessagesForEmployerMockHandler = (overrideResponse?: GetMatchChatWithMessagesResult | ((info: Parameters<HttpResponseResolver<{ id: string }>>[0]) => Promise<GetMatchChatWithMessagesResult> | GetMatchChatWithMessagesResult), options?: RequestHandlerOptions) => {
  return http.get<{ id: string }>('*/employer/match/:id/chat', async (info: Parameters<HttpResponseResolver<{ id: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetMatchChatWithMessagesForEmployerResponseMock(),
      { status: 200
      })
  }, options)
}

export const getSendMatchChatMessageForEmployerMockHandler = (overrideResponse?: ChatMessageDto | ((info: Parameters<HttpResponseResolver<PathParams, SendMessageCommandDto>>[0]) => Promise<ChatMessageDto> | ChatMessageDto), options?: RequestHandlerOptions) => {
  return http.post<PathParams, SendMessageCommandDto>('*/employer/match/chat', async (info: Parameters<HttpResponseResolver<PathParams, SendMessageCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getSendMatchChatMessageForEmployerResponseMock(),
      { status: 200
      })
  }, options)
}

export const getSendPollMockHandler = (overrideResponse?: SendPollResult | ((info: Parameters<HttpResponseResolver<PathParams, SendPollCommandDto>>[0]) => Promise<SendPollResult> | SendPollResult), options?: RequestHandlerOptions) => {
  return http.post<PathParams, SendPollCommandDto>('*/employer/match/poll', async (info: Parameters<HttpResponseResolver<PathParams, SendPollCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getSendPollResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetLeadEmployerMockHandler = (overrideResponse?: GetLeadEmployerResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<GetLeadEmployerResult> | GetLeadEmployerResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/lead/account', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetLeadEmployerResponseMock(),
      { status: 200
      })
  }, options)
}

export const getCreateFirebaseAccountForLeadMockHandler = (overrideResponse?: CreateFirebaseAccountForLeadResult | ((info: Parameters<HttpResponseResolver<PathParams, CreateFirebaseAccountForLeadCommandDto>>[0]) => Promise<CreateFirebaseAccountForLeadResult> | CreateFirebaseAccountForLeadResult), options?: RequestHandlerOptions) => {
  return http.post<PathParams, CreateFirebaseAccountForLeadCommandDto>('*/employer/lead/account', async (info: Parameters<HttpResponseResolver<PathParams, CreateFirebaseAccountForLeadCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getCreateFirebaseAccountForLeadResponseMock(),
      { status: 200
      })
  }, options)
}

export const getConvertLeadCompanyToRegularMockHandler = (overrideResponse?: void | ((info: Parameters<HttpResponseResolver<PathParams, ConvertLeadCompanyToCustomerCommandDto>>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post<PathParams, ConvertLeadCompanyToCustomerCommandDto>('*/employer/lead/company', async (info: Parameters<HttpResponseResolver<PathParams, ConvertLeadCompanyToCustomerCommandDto>>[0]) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 200
      })
  }, options)
}

export const getListJobsMockHandler = (overrideResponse?: ListJobsInPortalResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<ListJobsInPortalResult> | ListJobsInPortalResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/job', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListJobsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getCreateJobMockHandler = (overrideResponse?: number | ((info: Parameters<HttpResponseResolver<PathParams, CreateJobCommandDto>>[0]) => Promise<number> | number), options?: RequestHandlerOptions) => {
  return http.post<PathParams, CreateJobCommandDto>('*/employer/job', async (info: Parameters<HttpResponseResolver<PathParams, CreateJobCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getCreateJobResponseMock(),
      { status: 200
      })
  }, options)
}

export const getUpdateJobMockHandler = (overrideResponse?: number | ((info: Parameters<HttpResponseResolver<PathParams, UpdateJobCommandDto>>[0]) => Promise<number> | number), options?: RequestHandlerOptions) => {
  return http.put<PathParams, UpdateJobCommandDto>('*/employer/job', async (info: Parameters<HttpResponseResolver<PathParams, UpdateJobCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getUpdateJobResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetJobMockHandler = (overrideResponse?: GetJobResult | ((info: Parameters<HttpResponseResolver<{ id: string }>>[0]) => Promise<GetJobResult> | GetJobResult), options?: RequestHandlerOptions) => {
  return http.get<{ id: string }>('*/employer/job/:id', async (info: Parameters<HttpResponseResolver<{ id: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetJobResponseMock(),
      { status: 200
      })
  }, options)
}

export const getRepublishJobMockHandler = (overrideResponse?: number | ((info: Parameters<HttpResponseResolver<PathParams, RepublishJobCommandDto>>[0]) => Promise<number> | number), options?: RequestHandlerOptions) => {
  return http.post<PathParams, RepublishJobCommandDto>('*/employer/job/republish', async (info: Parameters<HttpResponseResolver<PathParams, RepublishJobCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getRepublishJobResponseMock(),
      { status: 200
      })
  }, options)
}

export const getUpdateJobPublishedMockHandler = (overrideResponse?: UpdateJobPublishedResult | ((info: Parameters<HttpResponseResolver<PathParams, UpdateJobPublishedCommandDto>>[0]) => Promise<UpdateJobPublishedResult> | UpdateJobPublishedResult), options?: RequestHandlerOptions) => {
  return http.patch<PathParams, UpdateJobPublishedCommandDto>('*/employer/job/update-published', async (info: Parameters<HttpResponseResolver<PathParams, UpdateJobPublishedCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getUpdateJobPublishedResponseMock(),
      { status: 200
      })
  }, options)
}

export const getUpdateJobCandidatePoolMockHandler = (overrideResponse?: Unit | ((info: Parameters<HttpResponseResolver<PathParams, UpdateJobCandidatePoolCommandDto>>[0]) => Promise<Unit> | Unit), options?: RequestHandlerOptions) => {
  return http.patch<PathParams, UpdateJobCandidatePoolCommandDto>('*/employer/job/update-candidate-pool', async (info: Parameters<HttpResponseResolver<PathParams, UpdateJobCandidatePoolCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getUpdateJobCandidatePoolResponseMock(),
      { status: 200
      })
  }, options)
}

export const getCloseJobMockHandler = (overrideResponse?: void | ((info: Parameters<HttpResponseResolver<PathParams, CloseJobCommandDto>>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.patch<PathParams, CloseJobCommandDto>('*/employer/job/close', async (info: Parameters<HttpResponseResolver<PathParams, CloseJobCommandDto>>[0]) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 200
      })
  }, options)
}

export const getFindBestCandidateMockHandler = (overrideResponse?: FindBestCandidateResult | ((info: Parameters<HttpResponseResolver<{ jobId: string }>>[0]) => Promise<FindBestCandidateResult> | FindBestCandidateResult), options?: RequestHandlerOptions) => {
  return http.get<{ jobId: string }>('*/employer/job/:jobId/find-best-candidate', async (info: Parameters<HttpResponseResolver<{ jobId: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getFindBestCandidateResponseMock(),
      { status: 200
      })
  }, options)
}

export const getReactToBestCandidateMockHandler = (overrideResponse?: ReactToCandidateResult | ((info: Parameters<HttpResponseResolver<PathParams, ReactToCandidateCommandDto>>[0]) => Promise<ReactToCandidateResult> | ReactToCandidateResult), options?: RequestHandlerOptions) => {
  return http.post<PathParams, ReactToCandidateCommandDto>('*/employer/job/react-best-candidate', async (info: Parameters<HttpResponseResolver<PathParams, ReactToCandidateCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getReactToBestCandidateResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetJobNotificationSettingsMockHandler = (overrideResponse?: GetJobNotificationSettingsResult | ((info: Parameters<HttpResponseResolver<{ jobId: string }>>[0]) => Promise<GetJobNotificationSettingsResult> | GetJobNotificationSettingsResult), options?: RequestHandlerOptions) => {
  return http.get<{ jobId: string }>('*/employer/job/:jobId/notification-settings', async (info: Parameters<HttpResponseResolver<{ jobId: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetJobNotificationSettingsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetCompanyJobsNotificationSettingsMockHandler = (overrideResponse?: GetCompanyJobsNotificationSettingsResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<GetCompanyJobsNotificationSettingsResult> | GetCompanyJobsNotificationSettingsResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/job/notification-settings', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetCompanyJobsNotificationSettingsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getUpdateJobNotificationSettingsMockHandler = (overrideResponse?: void | ((info: Parameters<HttpResponseResolver<PathParams, UpdateJobNotificationSettingsCommandDto>>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post<PathParams, UpdateJobNotificationSettingsCommandDto>('*/employer/job/notification-settings', async (info: Parameters<HttpResponseResolver<PathParams, UpdateJobNotificationSettingsCommandDto>>[0]) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 200
      })
  }, options)
}

export const getUpdateJobsNotificationSettingsMockHandler = (overrideResponse?: void | ((info: Parameters<HttpResponseResolver<PathParams, UpdateJobsNotificationSettingsCommandDto>>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post<PathParams, UpdateJobsNotificationSettingsCommandDto>('*/employer/job/notification-settings/bulk', async (info: Parameters<HttpResponseResolver<PathParams, UpdateJobsNotificationSettingsCommandDto>>[0]) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 200
      })
  }, options)
}

export const getGetJobApplicationMockHandler = (overrideResponse?: GetJobApplicationResult | ((info: Parameters<HttpResponseResolver<{ jobApplicationId: string }>>[0]) => Promise<GetJobApplicationResult> | GetJobApplicationResult), options?: RequestHandlerOptions) => {
  return http.get<{ jobApplicationId: string }>('*/employer/job-application/:jobApplicationId', async (info: Parameters<HttpResponseResolver<{ jobApplicationId: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetJobApplicationResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetJobApplicationTabCountsMockHandler = (overrideResponse?: GetJobApplicationTabCountsResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<GetJobApplicationTabCountsResult> | GetJobApplicationTabCountsResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/job-application/tab-counts', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetJobApplicationTabCountsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListJobApplicationCandidatesMockHandler = (overrideResponse?: ListJobApplicationCandidatesResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<ListJobApplicationCandidatesResult> | ListJobApplicationCandidatesResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/job-application/candidates', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListJobApplicationCandidatesResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListJobApplicationRejectionReasonsMockHandler = (overrideResponse?: ListJobApplicationRejectionReasonsResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<ListJobApplicationRejectionReasonsResult> | ListJobApplicationRejectionReasonsResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/job-application/rejection-reasons', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListJobApplicationRejectionReasonsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getRejectJobApplicationMockHandler = (overrideResponse?: RejectJobApplicationResult | ((info: Parameters<HttpResponseResolver<PathParams, RejectJobApplicationCommandDto>>[0]) => Promise<RejectJobApplicationResult> | RejectJobApplicationResult), options?: RequestHandlerOptions) => {
  return http.put<PathParams, RejectJobApplicationCommandDto>('*/employer/job-application/reject', async (info: Parameters<HttpResponseResolver<PathParams, RejectJobApplicationCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getRejectJobApplicationResponseMock(),
      { status: 200
      })
  }, options)
}

export const getStartMatchMockHandler = (overrideResponse?: StartMatchResult | ((info: Parameters<HttpResponseResolver<PathParams, StartMatchCommandDto>>[0]) => Promise<StartMatchResult> | StartMatchResult), options?: RequestHandlerOptions) => {
  return http.post<PathParams, StartMatchCommandDto>('*/employer/job-application/start-match', async (info: Parameters<HttpResponseResolver<PathParams, StartMatchCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getStartMatchResponseMock(),
      { status: 200
      })
  }, options)
}

export const getSendCompleteProfileRequestMockHandler = (overrideResponse?: void | ((info: Parameters<HttpResponseResolver<PathParams, SendCompleteProfileRequestCommandDto>>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post<PathParams, SendCompleteProfileRequestCommandDto>('*/employer/job-application/complete-profile-request', async (info: Parameters<HttpResponseResolver<PathParams, SendCompleteProfileRequestCommandDto>>[0]) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 200
      })
  }, options)
}

export const getBuyCreditsMockHandler = (overrideResponse?: void | ((info: Parameters<HttpResponseResolver<PathParams, BuyCreditsCommandDto>>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post<PathParams, BuyCreditsCommandDto>('*/employer/invoice/credits', async (info: Parameters<HttpResponseResolver<PathParams, BuyCreditsCommandDto>>[0]) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 200
      })
  }, options)
}

export const getListCreditTransactionsMockHandler = (overrideResponse?: ListCreditTransactionsResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<ListCreditTransactionsResult> | ListCreditTransactionsResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/invoice/credits', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListCreditTransactionsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetSubscriptionMockHandler = (overrideResponse?: GetSubscriptionResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<GetSubscriptionResult> | GetSubscriptionResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/invoice/subscription', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetSubscriptionResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListCompanySubscriptionsMockHandler = (overrideResponse?: ListCompanySubscriptionsResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<ListCompanySubscriptionsResult> | ListCompanySubscriptionsResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/invoice/subscriptions', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListCompanySubscriptionsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListInvoicesForCompanyMockHandler = (overrideResponse?: ListInvoicesForCompanyResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<ListInvoicesForCompanyResult> | ListInvoicesForCompanyResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/invoice', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListInvoicesForCompanyResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListCreditNotesForCompanyMockHandler = (overrideResponse?: ListCreditNotesForCompanyResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<ListCreditNotesForCompanyResult> | ListCreditNotesForCompanyResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/invoice/credit-notes', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListCreditNotesForCompanyResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetInvoiceFileUrlMockHandler = (overrideResponse?: GetInvoiceFileUrlResult | ((info: Parameters<HttpResponseResolver<{ fileId: string }>>[0]) => Promise<GetInvoiceFileUrlResult> | GetInvoiceFileUrlResult), options?: RequestHandlerOptions) => {
  return http.get<{ fileId: string }>('*/employer/invoice/:fileId', async (info: Parameters<HttpResponseResolver<{ fileId: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetInvoiceFileUrlResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetCreditNoteFileUrlMockHandler = (overrideResponse?: GetCreditNoteFileUrlResult | ((info: Parameters<HttpResponseResolver<{ creditNoteId: string }>>[0]) => Promise<GetCreditNoteFileUrlResult> | GetCreditNoteFileUrlResult), options?: RequestHandlerOptions) => {
  return http.get<{ creditNoteId: string }>('*/employer/invoice/credit-notes/:creditNoteId', async (info: Parameters<HttpResponseResolver<{ creditNoteId: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetCreditNoteFileUrlResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListIntegrationsMockHandler = (overrideResponse?: ListIntegrationsResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<ListIntegrationsResult> | ListIntegrationsResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/integration', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListIntegrationsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getConnectCarerixIntegrationMockHandler = (overrideResponse?: IntegrationConnectionDto | ((info: Parameters<HttpResponseResolver<PathParams, GetOrCreateAtsIntegrationConnectionCommandDtoCarerixConnectionSecrets>>[0]) => Promise<IntegrationConnectionDto> | IntegrationConnectionDto), options?: RequestHandlerOptions) => {
  return http.post<PathParams, GetOrCreateAtsIntegrationConnectionCommandDtoCarerixConnectionSecrets>('*/employer/carerix-connection', async (info: Parameters<HttpResponseResolver<PathParams, GetOrCreateAtsIntegrationConnectionCommandDtoCarerixConnectionSecrets>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getConnectCarerixIntegrationResponseMock(),
      { status: 200
      })
  }, options)
}

export const getUpdateCarerixConnectionMockHandler = (overrideResponse?: Unit | ((info: Parameters<HttpResponseResolver<{ connectionId: string }, UpdateAtsIntegrationConnectionCommandDtoCarerixConnectionConfig>>[0]) => Promise<Unit> | Unit), options?: RequestHandlerOptions) => {
  return http.put<{ connectionId: string }, UpdateAtsIntegrationConnectionCommandDtoCarerixConnectionConfig>('*/employer/carerix-connection/carerix/:connectionId', async (info: Parameters<HttpResponseResolver<{ connectionId: string }, UpdateAtsIntegrationConnectionCommandDtoCarerixConnectionConfig>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getUpdateCarerixConnectionResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetCarerixConnectionMockHandler = (overrideResponse?: GetAtsIntegrationConnectionResultCarerixConnectionConfig | ((info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => Promise<GetAtsIntegrationConnectionResultCarerixConnectionConfig> | GetAtsIntegrationConnectionResultCarerixConnectionConfig), options?: RequestHandlerOptions) => {
  return http.get<{ connectionId: string }>('*/employer/carerix-connection/carerix/:connectionId', async (info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetCarerixConnectionResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListCarerixStatusInfosMockHandler = (overrideResponse?: ListCarerixStatusInfosResult | ((info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => Promise<ListCarerixStatusInfosResult> | ListCarerixStatusInfosResult), options?: RequestHandlerOptions) => {
  return http.get<{ connectionId: string }>('*/employer/carerix-connection/carerix/:connectionId/status-infos', async (info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListCarerixStatusInfosResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListCarerixSourceNodesMockHandler = (overrideResponse?: ListCarerixSourceNodesResult | ((info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => Promise<ListCarerixSourceNodesResult> | ListCarerixSourceNodesResult), options?: RequestHandlerOptions) => {
  return http.get<{ connectionId: string }>('*/employer/carerix-connection/carerix/:connectionId/source-nodes', async (info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListCarerixSourceNodesResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListCarerixOwnersMockHandler = (overrideResponse?: ListCarerixOwnersResult | ((info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => Promise<ListCarerixOwnersResult> | ListCarerixOwnersResult), options?: RequestHandlerOptions) => {
  return http.get<{ connectionId: string }>('*/employer/carerix-connection/carerix/:connectionId/owners', async (info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListCarerixOwnersResponseMock(),
      { status: 200
      })
  }, options)
}

export const getUpdateCarerixJobMappingMockHandler = (overrideResponse?: Unit | ((info: Parameters<HttpResponseResolver<{ connectionId: string; jobId: string }, UpdateCarerixJobMappingCommandDto>>[0]) => Promise<Unit> | Unit), options?: RequestHandlerOptions) => {
  return http.put<{ connectionId: string; jobId: string }, UpdateCarerixJobMappingCommandDto>('*/employer/carerix-connection/carerix/:connectionId/job-mappings/:jobId', async (info: Parameters<HttpResponseResolver<{ connectionId: string; jobId: string }, UpdateCarerixJobMappingCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getUpdateCarerixJobMappingResponseMock(),
      { status: 200
      })
  }, options)
}

export const getConnectHomerunIntegrationMockHandler = (overrideResponse?: IntegrationConnectionDto | ((info: Parameters<HttpResponseResolver<PathParams, GetOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecrets>>[0]) => Promise<IntegrationConnectionDto> | IntegrationConnectionDto), options?: RequestHandlerOptions) => {
  return http.post<PathParams, GetOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecrets>('*/employer/homerun-connection', async (info: Parameters<HttpResponseResolver<PathParams, GetOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecrets>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getConnectHomerunIntegrationResponseMock(),
      { status: 200
      })
  }, options)
}

export const getUpdateHomerunConnectionMockHandler = (overrideResponse?: Unit | ((info: Parameters<HttpResponseResolver<{ connectionId: string }, UpdateAtsIntegrationConnectionCommandDtoHomerunConnectionConfig>>[0]) => Promise<Unit> | Unit), options?: RequestHandlerOptions) => {
  return http.put<{ connectionId: string }, UpdateAtsIntegrationConnectionCommandDtoHomerunConnectionConfig>('*/employer/homerun-connection/:connectionId', async (info: Parameters<HttpResponseResolver<{ connectionId: string }, UpdateAtsIntegrationConnectionCommandDtoHomerunConnectionConfig>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getUpdateHomerunConnectionResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetHomerunConnectionMockHandler = (overrideResponse?: GetAtsIntegrationConnectionResultHomerunConnectionConfig | ((info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => Promise<GetAtsIntegrationConnectionResultHomerunConnectionConfig> | GetAtsIntegrationConnectionResultHomerunConnectionConfig), options?: RequestHandlerOptions) => {
  return http.get<{ connectionId: string }>('*/employer/homerun-connection/:connectionId', async (info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetHomerunConnectionResponseMock(),
      { status: 200
      })
  }, options)
}

export const getDeleteIntegrationConnectionMockHandler = (overrideResponse?: Unit | ((info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => Promise<Unit> | Unit), options?: RequestHandlerOptions) => {
  return http.delete<{ connectionId: string }>('*/employer/integration-connection/:connectionId', async (info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getDeleteIntegrationConnectionResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListAtsJobsMockHandler = (overrideResponse?: ListAtsJobsResult | ((info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => Promise<ListAtsJobsResult> | ListAtsJobsResult), options?: RequestHandlerOptions) => {
  return http.get<{ connectionId: string }>('*/employer/integration-connection/ats-jobs/:connectionId', async (info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListAtsJobsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getMapJobWithAtsJobMockHandler = (overrideResponse?: Unit | ((info: Parameters<HttpResponseResolver<{ connectionId: string }, MapJobWithAtsJobCommandDto>>[0]) => Promise<Unit> | Unit), options?: RequestHandlerOptions) => {
  return http.post<{ connectionId: string }, MapJobWithAtsJobCommandDto>('*/employer/integration-connection/ats-jobs/:connectionId', async (info: Parameters<HttpResponseResolver<{ connectionId: string }, MapJobWithAtsJobCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getMapJobWithAtsJobResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListAtsVacanciesMockHandler = (overrideResponse?: ListAtsVacanciesResult | ((info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => Promise<ListAtsVacanciesResult> | ListAtsVacanciesResult), options?: RequestHandlerOptions) => {
  return http.get<{ connectionId: string }>('*/employer/integration-connection/ats-vacancies/:connectionId', async (info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListAtsVacanciesResponseMock(),
      { status: 200
      })
  }, options)
}

export const getImportAtsJobMockHandler = (overrideResponse?: number | ((info: Parameters<HttpResponseResolver<{ connectionId: string }, ImportAtsJobCommandDto>>[0]) => Promise<number> | number), options?: RequestHandlerOptions) => {
  return http.post<{ connectionId: string }, ImportAtsJobCommandDto>('*/employer/integration-connection/ats-vacancies/:connectionId/import', async (info: Parameters<HttpResponseResolver<{ connectionId: string }, ImportAtsJobCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getImportAtsJobResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetAtsConnectionSyncStatusMockHandler = (overrideResponse?: GetAtsConnectionSyncStatusResult | ((info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => Promise<GetAtsConnectionSyncStatusResult> | GetAtsConnectionSyncStatusResult), options?: RequestHandlerOptions) => {
  return http.get<{ connectionId: string }>('*/employer/integration-connection/ats-sync-status/:connectionId', async (info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetAtsConnectionSyncStatusResponseMock(),
      { status: 200
      })
  }, options)
}

export const getResendOwnAtsJobApplicationsMockHandler = (overrideResponse?: ResendAtsJobApplicationsResult | ((info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => Promise<ResendAtsJobApplicationsResult> | ResendAtsJobApplicationsResult), options?: RequestHandlerOptions) => {
  return http.post<{ connectionId: string }>('*/employer/integration-connection/:connectionId/resend-open-candidates', async (info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getResendOwnAtsJobApplicationsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getConnectMySolutionIntegrationMockHandler = (overrideResponse?: ConnectMySolutionIntegrationResult | ((info: Parameters<HttpResponseResolver<PathParams, ConnectMySolutionIntegrationDto>>[0]) => Promise<ConnectMySolutionIntegrationResult> | ConnectMySolutionIntegrationResult), options?: RequestHandlerOptions) => {
  return http.post<PathParams, ConnectMySolutionIntegrationDto>('*/employer/my-solution-connection', async (info: Parameters<HttpResponseResolver<PathParams, ConnectMySolutionIntegrationDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getConnectMySolutionIntegrationResponseMock(),
      { status: 200
      })
  }, options)
}

export const getUpdateMySolutionConnectionMockHandler = (overrideResponse?: Unit | ((info: Parameters<HttpResponseResolver<{ connectionId: string }, UpdateAtsIntegrationConnectionCommandDtoMySolutionConnectionConfig>>[0]) => Promise<Unit> | Unit), options?: RequestHandlerOptions) => {
  return http.put<{ connectionId: string }, UpdateAtsIntegrationConnectionCommandDtoMySolutionConnectionConfig>('*/employer/my-solution-connection/mysolution/:connectionId', async (info: Parameters<HttpResponseResolver<{ connectionId: string }, UpdateAtsIntegrationConnectionCommandDtoMySolutionConnectionConfig>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getUpdateMySolutionConnectionResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetMySolutionConnectionMockHandler = (overrideResponse?: GetAtsIntegrationConnectionResultMySolutionConnectionConfig | ((info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => Promise<GetAtsIntegrationConnectionResultMySolutionConnectionConfig> | GetAtsIntegrationConnectionResultMySolutionConnectionConfig), options?: RequestHandlerOptions) => {
  return http.get<{ connectionId: string }>('*/employer/my-solution-connection/mysolution/:connectionId', async (info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetMySolutionConnectionResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetMySolutionApplyConfigurationMockHandler = (overrideResponse?: GetMySolutionApplyConfigurationResult | ((info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => Promise<GetMySolutionApplyConfigurationResult> | GetMySolutionApplyConfigurationResult), options?: RequestHandlerOptions) => {
  return http.get<{ connectionId: string }>('*/employer/my-solution-connection/mysolution/:connectionId/apply-configuration', async (info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetMySolutionApplyConfigurationResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetMySolutionWebhookInfoMockHandler = (overrideResponse?: GetMySolutionWebhookInfoResult | ((info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => Promise<GetMySolutionWebhookInfoResult> | GetMySolutionWebhookInfoResult), options?: RequestHandlerOptions) => {
  return http.get<{ connectionId: string }>('*/employer/my-solution-connection/mysolution/:connectionId/webhook-info', async (info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetMySolutionWebhookInfoResponseMock(),
      { status: 200
      })
  }, options)
}

export const getConnectOtysIntegrationMockHandler = (overrideResponse?: IntegrationConnectionDto | ((info: Parameters<HttpResponseResolver<PathParams, GetOrCreateAtsIntegrationConnectionCommandDtoOtysConnectionSecrets>>[0]) => Promise<IntegrationConnectionDto> | IntegrationConnectionDto), options?: RequestHandlerOptions) => {
  return http.post<PathParams, GetOrCreateAtsIntegrationConnectionCommandDtoOtysConnectionSecrets>('*/employer/otys-connection', async (info: Parameters<HttpResponseResolver<PathParams, GetOrCreateAtsIntegrationConnectionCommandDtoOtysConnectionSecrets>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getConnectOtysIntegrationResponseMock(),
      { status: 200
      })
  }, options)
}

export const getUpdateOtysConnectionMockHandler = (overrideResponse?: Unit | ((info: Parameters<HttpResponseResolver<{ connectionId: string }, UpdateAtsIntegrationConnectionCommandDtoOtysConnectionConfig>>[0]) => Promise<Unit> | Unit), options?: RequestHandlerOptions) => {
  return http.put<{ connectionId: string }, UpdateAtsIntegrationConnectionCommandDtoOtysConnectionConfig>('*/employer/otys-connection/otys/:connectionId', async (info: Parameters<HttpResponseResolver<{ connectionId: string }, UpdateAtsIntegrationConnectionCommandDtoOtysConnectionConfig>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getUpdateOtysConnectionResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetOtysConnectionMockHandler = (overrideResponse?: GetAtsIntegrationConnectionResultOtysConnectionConfig | ((info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => Promise<GetAtsIntegrationConnectionResultOtysConnectionConfig> | GetAtsIntegrationConnectionResultOtysConnectionConfig), options?: RequestHandlerOptions) => {
  return http.get<{ connectionId: string }>('*/employer/otys-connection/otys/:connectionId', async (info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetOtysConnectionResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListOtysPortalsMockHandler = (overrideResponse?: ListOtysPortalsResult | ((info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => Promise<ListOtysPortalsResult> | ListOtysPortalsResult), options?: RequestHandlerOptions) => {
  return http.get<{ connectionId: string }>('*/employer/otys-connection/otys/:connectionId/portals', async (info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListOtysPortalsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getUpdateOtysPortalMockHandler = (overrideResponse?: Unit | ((info: Parameters<HttpResponseResolver<{ connectionId: string }, UpdateOtysPortalCommandDto>>[0]) => Promise<Unit> | Unit), options?: RequestHandlerOptions) => {
  return http.put<{ connectionId: string }, UpdateOtysPortalCommandDto>('*/employer/otys-connection/otys/:connectionId/portal', async (info: Parameters<HttpResponseResolver<{ connectionId: string }, UpdateOtysPortalCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getUpdateOtysPortalResponseMock(),
      { status: 200
      })
  }, options)
}

export const getConnectRecruiteeIntegrationMockHandler = (overrideResponse?: IntegrationConnectionDto | ((info: Parameters<HttpResponseResolver<PathParams, GetOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecrets>>[0]) => Promise<IntegrationConnectionDto> | IntegrationConnectionDto), options?: RequestHandlerOptions) => {
  return http.post<PathParams, GetOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecrets>('*/employer/recruitee-connection', async (info: Parameters<HttpResponseResolver<PathParams, GetOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecrets>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getConnectRecruiteeIntegrationResponseMock(),
      { status: 200
      })
  }, options)
}

export const getUpdateRecruiteeConnectionMockHandler = (overrideResponse?: Unit | ((info: Parameters<HttpResponseResolver<{ connectionId: string }, UpdateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfig>>[0]) => Promise<Unit> | Unit), options?: RequestHandlerOptions) => {
  return http.put<{ connectionId: string }, UpdateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfig>('*/employer/recruitee-connection/recruitee/:connectionId', async (info: Parameters<HttpResponseResolver<{ connectionId: string }, UpdateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfig>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getUpdateRecruiteeConnectionResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetRecruiteeConnectionMockHandler = (overrideResponse?: GetAtsIntegrationConnectionResultRecruiteeConnectionConfig | ((info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => Promise<GetAtsIntegrationConnectionResultRecruiteeConnectionConfig> | GetAtsIntegrationConnectionResultRecruiteeConnectionConfig), options?: RequestHandlerOptions) => {
  return http.get<{ connectionId: string }>('*/employer/recruitee-connection/recruitee/:connectionId', async (info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetRecruiteeConnectionResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetRecruiteeJobLocationsMockHandler = (overrideResponse?: GetRecruiteeJobLocationsResult | ((info: Parameters<HttpResponseResolver<{ connectionId: string; atsJobId: string }>>[0]) => Promise<GetRecruiteeJobLocationsResult> | GetRecruiteeJobLocationsResult), options?: RequestHandlerOptions) => {
  return http.get<{ connectionId: string; atsJobId: string }>('*/employer/recruitee-connection/recruitee/:connectionId/jobs/:atsJobId/locations', async (info: Parameters<HttpResponseResolver<{ connectionId: string; atsJobId: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetRecruiteeJobLocationsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getConnectRecruitNowIntegrationMockHandler = (overrideResponse?: IntegrationConnectionDto | ((info: Parameters<HttpResponseResolver<PathParams, GetOrCreateAtsIntegrationConnectionCommandDtoRecruitNowConnectionSecrets>>[0]) => Promise<IntegrationConnectionDto> | IntegrationConnectionDto), options?: RequestHandlerOptions) => {
  return http.post<PathParams, GetOrCreateAtsIntegrationConnectionCommandDtoRecruitNowConnectionSecrets>('*/employer/recruit-now-connection', async (info: Parameters<HttpResponseResolver<PathParams, GetOrCreateAtsIntegrationConnectionCommandDtoRecruitNowConnectionSecrets>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getConnectRecruitNowIntegrationResponseMock(),
      { status: 200
      })
  }, options)
}

export const getUpdateRecruitNowConnectionMockHandler = (overrideResponse?: Unit | ((info: Parameters<HttpResponseResolver<{ connectionId: string }, UpdateAtsIntegrationConnectionCommandDtoRecruitNowConnectionConfig>>[0]) => Promise<Unit> | Unit), options?: RequestHandlerOptions) => {
  return http.put<{ connectionId: string }, UpdateAtsIntegrationConnectionCommandDtoRecruitNowConnectionConfig>('*/employer/recruit-now-connection/recruitnow/:connectionId', async (info: Parameters<HttpResponseResolver<{ connectionId: string }, UpdateAtsIntegrationConnectionCommandDtoRecruitNowConnectionConfig>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getUpdateRecruitNowConnectionResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetRecruitNowConnectionMockHandler = (overrideResponse?: GetAtsIntegrationConnectionResultRecruitNowConnectionConfig | ((info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => Promise<GetAtsIntegrationConnectionResultRecruitNowConnectionConfig> | GetAtsIntegrationConnectionResultRecruitNowConnectionConfig), options?: RequestHandlerOptions) => {
  return http.get<{ connectionId: string }>('*/employer/recruit-now-connection/recruitnow/:connectionId', async (info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetRecruitNowConnectionResponseMock(),
      { status: 200
      })
  }, options)
}

export const getUpdateRecruitNowJobMappingMockHandler = (overrideResponse?: Unit | ((info: Parameters<HttpResponseResolver<{ connectionId: string; jobId: string }>>[0]) => Promise<Unit> | Unit), options?: RequestHandlerOptions) => {
  return http.put<{ connectionId: string; jobId: string }>('*/employer/recruit-now-connection/recruitnow/:connectionId/job-mappings/:jobId', async (info: Parameters<HttpResponseResolver<{ connectionId: string; jobId: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getUpdateRecruitNowJobMappingResponseMock(),
      { status: 200
      })
  }, options)
}

export const getConnectUbeeoIntegrationMockHandler = (overrideResponse?: IntegrationConnectionDto | ((info: Parameters<HttpResponseResolver<PathParams, GetOrCreateAtsIntegrationConnectionCommandDtoUbeeoConnectionSecrets>>[0]) => Promise<IntegrationConnectionDto> | IntegrationConnectionDto), options?: RequestHandlerOptions) => {
  return http.post<PathParams, GetOrCreateAtsIntegrationConnectionCommandDtoUbeeoConnectionSecrets>('*/employer/ubeeo-connection', async (info: Parameters<HttpResponseResolver<PathParams, GetOrCreateAtsIntegrationConnectionCommandDtoUbeeoConnectionSecrets>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getConnectUbeeoIntegrationResponseMock(),
      { status: 200
      })
  }, options)
}

export const getUpdateUbeeoConnectionMockHandler = (overrideResponse?: Unit | ((info: Parameters<HttpResponseResolver<{ connectionId: string }, UpdateAtsIntegrationConnectionCommandDtoUbeeoConnectionConfig>>[0]) => Promise<Unit> | Unit), options?: RequestHandlerOptions) => {
  return http.put<{ connectionId: string }, UpdateAtsIntegrationConnectionCommandDtoUbeeoConnectionConfig>('*/employer/ubeeo-connection/:connectionId', async (info: Parameters<HttpResponseResolver<{ connectionId: string }, UpdateAtsIntegrationConnectionCommandDtoUbeeoConnectionConfig>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getUpdateUbeeoConnectionResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetUbeeoConnectionMockHandler = (overrideResponse?: GetAtsIntegrationConnectionResultUbeeoConnectionConfig | ((info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => Promise<GetAtsIntegrationConnectionResultUbeeoConnectionConfig> | GetAtsIntegrationConnectionResultUbeeoConnectionConfig), options?: RequestHandlerOptions) => {
  return http.get<{ connectionId: string }>('*/employer/ubeeo-connection/:connectionId', async (info: Parameters<HttpResponseResolver<{ connectionId: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetUbeeoConnectionResponseMock(),
      { status: 200
      })
  }, options)
}

export const getRequestPasswordResetMockHandler = (overrideResponse?: void | ((info: Parameters<HttpResponseResolver<PathParams, SendPasswordResetEmailCommandDto>>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post<PathParams, SendPasswordResetEmailCommandDto>('*/employer/auth/request-password-reset', async (info: Parameters<HttpResponseResolver<PathParams, SendPasswordResetEmailCommandDto>>[0]) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 200
      })
  }, options)
}

export const getCreateEmployerInviteMockHandler = (overrideResponse?: void | ((info: Parameters<HttpResponseResolver<PathParams, CreateEmployerInviteCommandDto>>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post<PathParams, CreateEmployerInviteCommandDto>('*/admin/employer/create-employer-invite/employer', async (info: Parameters<HttpResponseResolver<PathParams, CreateEmployerInviteCommandDto>>[0]) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 200
      })
  }, options)
}

export const getCreateTeammateInviteMockHandler = (overrideResponse?: void | ((info: Parameters<HttpResponseResolver<PathParams, CreateTeammateInviteCommandDto>>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post<PathParams, CreateTeammateInviteCommandDto>('*/admin/employer/create-teammate-invite/teammate', async (info: Parameters<HttpResponseResolver<PathParams, CreateTeammateInviteCommandDto>>[0]) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 200
      })
  }, options)
}

export const getListReferralInvitesMockHandler = (overrideResponse?: ListReferralInvitesResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<ListReferralInvitesResult> | ListReferralInvitesResult), options?: RequestHandlerOptions) => {
  return http.get('*/admin/employer/list-referral-invites', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListReferralInvitesResponseMock(),
      { status: 200
      })
  }, options)
}

export const getDeleteTeammateMockHandler = (overrideResponse?: void | ((info: Parameters<HttpResponseResolver<PathParams, DeleteEmployerCommandDto>>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete<PathParams, DeleteEmployerCommandDto>('*/admin/employer/delete-teammate/teammate', async (info: Parameters<HttpResponseResolver<PathParams, DeleteEmployerCommandDto>>[0]) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 200
      })
  }, options)
}

export const getGetEmployerAccessMockHandler = (overrideResponse?: GetEmployerAccessResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<GetEmployerAccessResult> | GetEmployerAccessResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/profile/access', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetEmployerAccessResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetProfileMockHandler = (overrideResponse?: GetEmployerProfileResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<GetEmployerProfileResult> | GetEmployerProfileResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/profile', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetProfileResponseMock(),
      { status: 200
      })
  }, options)
}

export const getUpdateProfileMockHandler = (overrideResponse?: number | ((info: Parameters<HttpResponseResolver<PathParams, UpdateEmployerProfileCommandDto>>[0]) => Promise<number> | number), options?: RequestHandlerOptions) => {
  return http.patch<PathParams, UpdateEmployerProfileCommandDto>('*/employer/profile', async (info: Parameters<HttpResponseResolver<PathParams, UpdateEmployerProfileCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getUpdateProfileResponseMock(),
      { status: 200
      })
  }, options)
}

export const getUploadEmployerProfilePictureMockHandler = (overrideResponse?: ImageDto | ((info: Parameters<HttpResponseResolver<PathParams, UploadEmployerProfilePictureBody>>[0]) => Promise<ImageDto> | ImageDto), options?: RequestHandlerOptions) => {
  return http.post<PathParams, UploadEmployerProfilePictureBody>('*/employer/profile/picture', async (info: Parameters<HttpResponseResolver<PathParams, UploadEmployerProfilePictureBody>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getUploadEmployerProfilePictureResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetStatisticsMockHandler = (overrideResponse?: GetCompanyStatisticsResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<GetCompanyStatisticsResult> | GetCompanyStatisticsResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/dashboard/statistics', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetStatisticsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListUnhandledJobsMockHandler = (overrideResponse?: ListUnhandledJobsResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<ListUnhandledJobsResult> | ListUnhandledJobsResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/dashboard/unhandled-jobs', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListUnhandledJobsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetConferenceInfoMockHandler = (overrideResponse?: GetConferenceInfoResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<GetConferenceInfoResult> | GetConferenceInfoResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/conference', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetConferenceInfoResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListConferenceChatsEmployerMockHandler = (overrideResponse?: ListConferenceChatsResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<ListConferenceChatsResult> | ListConferenceChatsResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/conference/chat', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListConferenceChatsEmployerResponseMock(),
      { status: 200
      })
  }, options)
}

export const getSendConferenceChatMessageEmployerMockHandler = (overrideResponse?: ChatMessageDto | ((info: Parameters<HttpResponseResolver<PathParams, SendMessageCommandDto>>[0]) => Promise<ChatMessageDto> | ChatMessageDto), options?: RequestHandlerOptions) => {
  return http.post<PathParams, SendMessageCommandDto>('*/employer/conference/chat', async (info: Parameters<HttpResponseResolver<PathParams, SendMessageCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getSendConferenceChatMessageEmployerResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListUnreadConferenceChatsEmployerMockHandler = (overrideResponse?: ListUnreadConferenceChatsResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<ListUnreadConferenceChatsResult> | ListUnreadConferenceChatsResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/conference/chat-unread', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListUnreadConferenceChatsEmployerResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetConferenceChatWithMessagesForEmployerMockHandler = (overrideResponse?: GetConferenceChatWithMessagesForEmployerResult | ((info: Parameters<HttpResponseResolver<{ chatId: string }>>[0]) => Promise<GetConferenceChatWithMessagesForEmployerResult> | GetConferenceChatWithMessagesForEmployerResult), options?: RequestHandlerOptions) => {
  return http.get<{ chatId: string }>('*/employer/conference/chat/:chatId', async (info: Parameters<HttpResponseResolver<{ chatId: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetConferenceChatWithMessagesForEmployerResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListManagedCompaniesMockHandler = (overrideResponse?: ListManagedCompaniesResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<ListManagedCompaniesResult> | ListManagedCompaniesResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/managed-company', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListManagedCompaniesResponseMock(),
      { status: 200
      })
  }, options)
}

export const getUpdateManagedCompanyMockHandler = (overrideResponse?: void | ((info: Parameters<HttpResponseResolver<PathParams, number>>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post<PathParams, number>('*/employer/managed-company/update', async (info: Parameters<HttpResponseResolver<PathParams, number>>[0]) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 200
      })
  }, options)
}

export const getResetManagedCompanyMockHandler = (overrideResponse?: void | ((info: Parameters<HttpResponseResolver>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post('*/employer/managed-company/reset', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 200
      })
  }, options)
}

export const getGetMyCompanyMockHandler = (overrideResponse?: GetCompanyFromPortalResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<GetCompanyFromPortalResult> | GetCompanyFromPortalResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/company', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetMyCompanyResponseMock(),
      { status: 200
      })
  }, options)
}

export const getUpdateMyCompanyMockHandler = (overrideResponse?: number | ((info: Parameters<HttpResponseResolver<PathParams, UpdateCompanyFromPortalCommandDto>>[0]) => Promise<number> | number), options?: RequestHandlerOptions) => {
  return http.put<PathParams, UpdateCompanyFromPortalCommandDto>('*/employer/company', async (info: Parameters<HttpResponseResolver<PathParams, UpdateCompanyFromPortalCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getUpdateMyCompanyResponseMock(),
      { status: 200
      })
  }, options)
}

export const getDeleteMyCompanyMockHandler = (overrideResponse?: number | ((info: Parameters<HttpResponseResolver>[0]) => Promise<number> | number), options?: RequestHandlerOptions) => {
  return http.delete('*/employer/company', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getDeleteMyCompanyResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetMyCompanyPlanMockHandler = (overrideResponse?: GetCompanyPlanResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<GetCompanyPlanResult> | GetCompanyPlanResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/company/plan', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetMyCompanyPlanResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListEmployersForCompanyMockHandler = (overrideResponse?: ListOtherEmployersForCompanyResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<ListOtherEmployersForCompanyResult> | ListOtherEmployersForCompanyResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/company/employers', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListEmployersForCompanyResponseMock(),
      { status: 200
      })
  }, options)
}

export const getUpdateEmployerCompanyAccessMockHandler = (overrideResponse?: UpdateEmployerCompanyAccessResult | ((info: Parameters<HttpResponseResolver<PathParams, UpdateEmployerCompanyAccessCommandDto>>[0]) => Promise<UpdateEmployerCompanyAccessResult> | UpdateEmployerCompanyAccessResult), options?: RequestHandlerOptions) => {
  return http.post<PathParams, UpdateEmployerCompanyAccessCommandDto>('*/employer/company/employer-company-access', async (info: Parameters<HttpResponseResolver<PathParams, UpdateEmployerCompanyAccessCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getUpdateEmployerCompanyAccessResponseMock(),
      { status: 200
      })
  }, options)
}

export const getAddOrUpdateDefaultMessageMockHandler = (overrideResponse?: AddOrUpdateDefaultMessageResult | ((info: Parameters<HttpResponseResolver<PathParams, AddOrUpdateDefaultMessageCommandDto>>[0]) => Promise<AddOrUpdateDefaultMessageResult> | AddOrUpdateDefaultMessageResult), options?: RequestHandlerOptions) => {
  return http.post<PathParams, AddOrUpdateDefaultMessageCommandDto>('*/employer/company/default-messages', async (info: Parameters<HttpResponseResolver<PathParams, AddOrUpdateDefaultMessageCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getAddOrUpdateDefaultMessageResponseMock(),
      { status: 200
      })
  }, options)
}

export const getDeleteDefaultMessageMockHandler = (overrideResponse?: DeleteDefaultMessageResult | ((info: Parameters<HttpResponseResolver<{ id: string }>>[0]) => Promise<DeleteDefaultMessageResult> | DeleteDefaultMessageResult), options?: RequestHandlerOptions) => {
  return http.delete<{ id: string }>('*/employer/company/default-messages/:id', async (info: Parameters<HttpResponseResolver<{ id: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getDeleteDefaultMessageResponseMock(),
      { status: 200
      })
  }, options)
}

export const getUploadProvisionalImageMockHandler = (overrideResponse?: ImageDto | ((info: Parameters<HttpResponseResolver<PathParams, UploadProvisionalImageBody>>[0]) => Promise<ImageDto> | ImageDto), options?: RequestHandlerOptions) => {
  return http.post<PathParams, UploadProvisionalImageBody>('*/employer/company/provisional-image', async (info: Parameters<HttpResponseResolver<PathParams, UploadProvisionalImageBody>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getUploadProvisionalImageResponseMock(),
      { status: 200
      })
  }, options)
}

export const getSendRequestToAccountManagerMockHandler = (overrideResponse?: Unit | ((info: Parameters<HttpResponseResolver<PathParams, SendRequestToAccountManagerCommandDto>>[0]) => Promise<Unit> | Unit), options?: RequestHandlerOptions) => {
  return http.post<PathParams, SendRequestToAccountManagerCommandDto>('*/employer/company/send-account-manager-request', async (info: Parameters<HttpResponseResolver<PathParams, SendRequestToAccountManagerCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getSendRequestToAccountManagerResponseMock(),
      { status: 200
      })
  }, options)
}

export const getUpdateDefaultCandidatePoolMockHandler = (overrideResponse?: Unit | ((info: Parameters<HttpResponseResolver<PathParams, UpdateDefaultCandidatePoolCommandDto>>[0]) => Promise<Unit> | Unit), options?: RequestHandlerOptions) => {
  return http.patch<PathParams, UpdateDefaultCandidatePoolCommandDto>('*/employer/company/update-default-candidate-pool', async (info: Parameters<HttpResponseResolver<PathParams, UpdateDefaultCandidatePoolCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getUpdateDefaultCandidatePoolResponseMock(),
      { status: 200
      })
  }, options)
}

export const getUpdateCalendarInviteBodyMockHandler = (overrideResponse?: Unit | ((info: Parameters<HttpResponseResolver<PathParams, UpdateCalendarInviteBodyCommandDto>>[0]) => Promise<Unit> | Unit), options?: RequestHandlerOptions) => {
  return http.patch<PathParams, UpdateCalendarInviteBodyCommandDto>('*/employer/company/update-calendar-invite-body', async (info: Parameters<HttpResponseResolver<PathParams, UpdateCalendarInviteBodyCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getUpdateCalendarInviteBodyResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetCompanyHireReportInfoMockHandler = (overrideResponse?: GetCompanyHireReportInfoResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<GetCompanyHireReportInfoResult> | GetCompanyHireReportInfoResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/hire-report', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetCompanyHireReportInfoResponseMock(),
      { status: 200
      })
  }, options)
}

export const getCreateCompanyHireReportMockHandler = (overrideResponse?: CreateCompanyHireReport | ((info: Parameters<HttpResponseResolver<PathParams, CreateCompanyHireReportCommandDto>>[0]) => Promise<CreateCompanyHireReport> | CreateCompanyHireReport), options?: RequestHandlerOptions) => {
  return http.post<PathParams, CreateCompanyHireReportCommandDto>('*/employer/hire-report', async (info: Parameters<HttpResponseResolver<PathParams, CreateCompanyHireReportCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getCreateCompanyHireReportResponseMock(),
      { status: 200
      })
  }, options)
}

export const getSetMatchingConfigurationMockHandler = (overrideResponse?: void | ((info: Parameters<HttpResponseResolver<PathParams, SetCompanyMatchingConfigurationCommandDto>>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.put<PathParams, SetCompanyMatchingConfigurationCommandDto>('*/employer/company-matching-configuration', async (info: Parameters<HttpResponseResolver<PathParams, SetCompanyMatchingConfigurationCommandDto>>[0]) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 200
      })
  }, options)
}

export const getResetMatchingConfigurationMockHandler = (overrideResponse?: void | ((info: Parameters<HttpResponseResolver>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/employer/company-matching-configuration', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 200
      })
  }, options)
}

export const getGetMatchingConfigurationMockHandler = (overrideResponse?: GetCompanyMatchingConfigurationResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<GetCompanyMatchingConfigurationResult> | GetCompanyMatchingConfigurationResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/company-matching-configuration', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetMatchingConfigurationResponseMock(),
      { status: 200
      })
  }, options)
}

export const getRequestLoginLinkMockHandler = (overrideResponse?: void | ((info: Parameters<HttpResponseResolver<PathParams, string>>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post<PathParams, string>('*/employer/authentication/login-link', async (info: Parameters<HttpResponseResolver<PathParams, string>>[0]) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }

    return new HttpResponse(null,
      { status: 200
      })
  }, options)
}

export const getComposeAiJobMockHandler = (overrideResponse?: ComposeAiJobResult | ((info: Parameters<HttpResponseResolver<PathParams, ComposeAiJobCommandDto>>[0]) => Promise<ComposeAiJobResult> | ComposeAiJobResult), options?: RequestHandlerOptions) => {
  return http.post<PathParams, ComposeAiJobCommandDto>('*/employer/ai-jobs/compose', async (info: Parameters<HttpResponseResolver<PathParams, ComposeAiJobCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getComposeAiJobResponseMock(),
      { status: 200
      })
  }, options)
}

export const getExtractVacancyFromPageMockHandler = (overrideResponse?: ExtractVacancyFromPageResult | ((info: Parameters<HttpResponseResolver<PathParams, ExtractVacancyFromPageCommandDto>>[0]) => Promise<ExtractVacancyFromPageResult> | ExtractVacancyFromPageResult), options?: RequestHandlerOptions) => {
  return http.post<PathParams, ExtractVacancyFromPageCommandDto>('*/employer/ai-jobs/extract-page', async (info: Parameters<HttpResponseResolver<PathParams, ExtractVacancyFromPageCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getExtractVacancyFromPageResponseMock(),
      { status: 200
      })
  }, options)
}

export const getDetermineJobFunctionMockHandler = (overrideResponse?: DetermineJobFunctionResult | ((info: Parameters<HttpResponseResolver<PathParams, DetermineJobFunctionCommandDto>>[0]) => Promise<DetermineJobFunctionResult> | DetermineJobFunctionResult), options?: RequestHandlerOptions) => {
  return http.post<PathParams, DetermineJobFunctionCommandDto>('*/employer/ai-jobs/job-function', async (info: Parameters<HttpResponseResolver<PathParams, DetermineJobFunctionCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getDetermineJobFunctionResponseMock(),
      { status: 200
      })
  }, options)
}

export const getDetermineAiJobDataMockHandler = (overrideResponse?: DetermineAiJobDataResult | ((info: Parameters<HttpResponseResolver<PathParams, DetermineAiJobDataCommandDto>>[0]) => Promise<DetermineAiJobDataResult> | DetermineAiJobDataResult), options?: RequestHandlerOptions) => {
  return http.post<PathParams, DetermineAiJobDataCommandDto>('*/employer/ai-jobs/determine', async (info: Parameters<HttpResponseResolver<PathParams, DetermineAiJobDataCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getDetermineAiJobDataResponseMock(),
      { status: 200
      })
  }, options)
}

export const getWriteAiJobSectionsMockHandler = (overrideResponse?: WriteAiJobSectionsResult | ((info: Parameters<HttpResponseResolver<{ id: string }>>[0]) => Promise<WriteAiJobSectionsResult> | WriteAiJobSectionsResult), options?: RequestHandlerOptions) => {
  return http.post<{ id: string }>('*/employer/ai-jobs/:id/write', async (info: Parameters<HttpResponseResolver<{ id: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getWriteAiJobSectionsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getChatWithJobAgentMockHandler = (overrideResponse?: ChatWithJobAgentResult | ((info: Parameters<HttpResponseResolver<PathParams, ChatWithJobAgentCommandDto>>[0]) => Promise<ChatWithJobAgentResult> | ChatWithJobAgentResult), options?: RequestHandlerOptions) => {
  return http.post<PathParams, ChatWithJobAgentCommandDto>('*/employer/ai-jobs/chat', async (info: Parameters<HttpResponseResolver<PathParams, ChatWithJobAgentCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getChatWithJobAgentResponseMock(),
      { status: 200
      })
  }, options)
}

export const getRewriteJobSectionMockHandler = (overrideResponse?: RewriteJobSectionResult | ((info: Parameters<HttpResponseResolver<PathParams, RewriteJobSectionCommandDto>>[0]) => Promise<RewriteJobSectionResult> | RewriteJobSectionResult), options?: RequestHandlerOptions) => {
  return http.post<PathParams, RewriteJobSectionCommandDto>('*/employer/ai-jobs/rewrite-section', async (info: Parameters<HttpResponseResolver<PathParams, RewriteJobSectionCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getRewriteJobSectionResponseMock(),
      { status: 200
      })
  }, options)
}

export const getReviewAiJobMockHandler = (overrideResponse?: boolean | ((info: Parameters<HttpResponseResolver<{ id: string }, ReviewAiJobCommandDto>>[0]) => Promise<boolean> | boolean), options?: RequestHandlerOptions) => {
  return http.put<{ id: string }, ReviewAiJobCommandDto>('*/employer/ai-jobs/:id/review', async (info: Parameters<HttpResponseResolver<{ id: string }, ReviewAiJobCommandDto>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getReviewAiJobResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListEducationLevelsMockHandler = (overrideResponse?: ListEducationLevelsResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<ListEducationLevelsResult> | ListEducationLevelsResult), options?: RequestHandlerOptions) => {
  return http.get('*/education-level', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListEducationLevelsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListPersonalCharacteristicsMockHandler = (overrideResponse?: ListPersonalCharacteristicsResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<ListPersonalCharacteristicsResult> | ListPersonalCharacteristicsResult), options?: RequestHandlerOptions) => {
  return http.get('*/personal-characteristics', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListPersonalCharacteristicsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListNewJobReasonsMockHandler = (overrideResponse?: ListNewJobReasonsResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<ListNewJobReasonsResult> | ListNewJobReasonsResult), options?: RequestHandlerOptions) => {
  return http.get('*/new-job-reasons', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListNewJobReasonsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListPersonalityTypesMockHandler = (overrideResponse?: ListPersonalityTypesResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<ListPersonalityTypesResult> | ListPersonalityTypesResult), options?: RequestHandlerOptions) => {
  return http.get('*/personality-types', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListPersonalityTypesResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetAutoCompleteLocationsMockHandler = (overrideResponse?: GetAutoCompleteLocationsResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<GetAutoCompleteLocationsResult> | GetAutoCompleteLocationsResult), options?: RequestHandlerOptions) => {
  return http.get('*/location/auto-complete', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetAutoCompleteLocationsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetLocationDetailsMockHandler = (overrideResponse?: GetLocationDetailsResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<GetLocationDetailsResult> | GetLocationDetailsResult), options?: RequestHandlerOptions) => {
  return http.get('*/location/details/v2', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetLocationDetailsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetLocationGeocodeMockHandler = (overrideResponse?: GetLocationGeocodeResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<GetLocationGeocodeResult> | GetLocationGeocodeResult), options?: RequestHandlerOptions) => {
  return http.get('*/location/location-geocode', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetLocationGeocodeResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListSkillsCertificatesAndLanguagesMockHandler = (overrideResponse?: ListSkillsCertificatesAndLanguagesResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<ListSkillsCertificatesAndLanguagesResult> | ListSkillsCertificatesAndLanguagesResult), options?: RequestHandlerOptions) => {
  return http.get('*/skill/v2', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListSkillsCertificatesAndLanguagesResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListAllSkillsMockHandler = (overrideResponse?: ListAllSkillsResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<ListAllSkillsResult> | ListAllSkillsResult), options?: RequestHandlerOptions) => {
  return http.get('*/skill/v2/list-all-skills', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListAllSkillsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListSkillsForJobCategoriesMockHandler = (overrideResponse?: ListSkillsForJobCategoriesResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<ListSkillsForJobCategoriesResult> | ListSkillsForJobCategoriesResult), options?: RequestHandlerOptions) => {
  return http.get('*/skill/v2/list-for-job-categories', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListSkillsForJobCategoriesResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListCertificatesMockHandler = (overrideResponse?: ListCertificatesResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<ListCertificatesResult> | ListCertificatesResult), options?: RequestHandlerOptions) => {
  return http.get('*/skill/v2/list-certificates', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListCertificatesResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListJobFunctionsMockHandler = (overrideResponse?: JobFunctionCrudListResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<JobFunctionCrudListResult> | JobFunctionCrudListResult), options?: RequestHandlerOptions) => {
  return http.get('*/job-function', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListJobFunctionsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListSimilarJobFunctionsMockHandler = (overrideResponse?: ListSimilarJobFunctionsResult | ((info: Parameters<HttpResponseResolver<PathParams, ItemInput[]>>[0]) => Promise<ListSimilarJobFunctionsResult> | ListSimilarJobFunctionsResult), options?: RequestHandlerOptions) => {
  return http.post<PathParams, ItemInput[]>('*/job-function/similar', async (info: Parameters<HttpResponseResolver<PathParams, ItemInput[]>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListSimilarJobFunctionsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListJobCategoriesMockHandler = (overrideResponse?: JobCategoryCrudListResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<JobCategoryCrudListResult> | JobCategoryCrudListResult), options?: RequestHandlerOptions) => {
  return http.get('*/job-category/v2', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListJobCategoriesResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetJobCategoryMockHandler = (overrideResponse?: JobCategoryCrudJobCategoryDto | ((info: Parameters<HttpResponseResolver<{ id: string }>>[0]) => Promise<JobCategoryCrudJobCategoryDto> | JobCategoryCrudJobCategoryDto), options?: RequestHandlerOptions) => {
  return http.get<{ id: string }>('*/job-category/v2/:id', async (info: Parameters<HttpResponseResolver<{ id: string }>>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetJobCategoryResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListInterestsMockHandler = (overrideResponse?: ListInterestsResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<ListInterestsResult> | ListInterestsResult), options?: RequestHandlerOptions) => {
  return http.get('*/interest', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListInterestsResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetRoleMockHandler = (overrideResponse?: GetRoleResult | ((info: Parameters<HttpResponseResolver>[0]) => Promise<GetRoleResult> | GetRoleResult), options?: RequestHandlerOptions) => {
  return http.get('*/user/account/role', async (info: Parameters<HttpResponseResolver>[0]) => {await delay(100);


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetRoleResponseMock(),
      { status: 200
      })
  }, options)
}
export const getSwipe4WorkEmployerAPIMock = () => [
  getAddUserCommentMockHandler(),
  getGetUserCommentsMockHandler(),
  getEditUserCommentMockHandler(),
  getDeleteUserCommentMockHandler(),
  getResetEmployerAccountForTestingMockHandler(),
  getListEducationLevelsWithTrackCategoryMockHandler(),
  getCreateCompanyForEmployerMockHandler(),
  getListPaymentOptionsMockHandler(),
  getCreateEmployerMockHandler(),
  getGetEmployerOnboardingStatusMockHandler(),
  getListAllMatchesMockHandler(),
  getHasUnreadMatchesMockHandler(),
  getGetMatchedUserMockHandler(),
  getDownloadCandidatePdfMockHandler(),
  getCreatePhoneContactAttemptMockHandler(),
  getCloseMatchMockHandler(),
  getUpdateMatchMockHandler(),
  getListMatchesByStageMockHandler(),
  getGetMatchChatWithMessagesForEmployerMockHandler(),
  getSendMatchChatMessageForEmployerMockHandler(),
  getSendPollMockHandler(),
  getGetLeadEmployerMockHandler(),
  getCreateFirebaseAccountForLeadMockHandler(),
  getConvertLeadCompanyToRegularMockHandler(),
  getListJobsMockHandler(),
  getCreateJobMockHandler(),
  getUpdateJobMockHandler(),
  getGetJobMockHandler(),
  getRepublishJobMockHandler(),
  getUpdateJobPublishedMockHandler(),
  getUpdateJobCandidatePoolMockHandler(),
  getCloseJobMockHandler(),
  getFindBestCandidateMockHandler(),
  getReactToBestCandidateMockHandler(),
  getGetJobNotificationSettingsMockHandler(),
  getGetCompanyJobsNotificationSettingsMockHandler(),
  getUpdateJobNotificationSettingsMockHandler(),
  getUpdateJobsNotificationSettingsMockHandler(),
  getGetJobApplicationMockHandler(),
  getGetJobApplicationTabCountsMockHandler(),
  getListJobApplicationCandidatesMockHandler(),
  getListJobApplicationRejectionReasonsMockHandler(),
  getRejectJobApplicationMockHandler(),
  getStartMatchMockHandler(),
  getSendCompleteProfileRequestMockHandler(),
  getBuyCreditsMockHandler(),
  getListCreditTransactionsMockHandler(),
  getGetSubscriptionMockHandler(),
  getListCompanySubscriptionsMockHandler(),
  getListInvoicesForCompanyMockHandler(),
  getListCreditNotesForCompanyMockHandler(),
  getGetInvoiceFileUrlMockHandler(),
  getGetCreditNoteFileUrlMockHandler(),
  getListIntegrationsMockHandler(),
  getConnectCarerixIntegrationMockHandler(),
  getUpdateCarerixConnectionMockHandler(),
  getGetCarerixConnectionMockHandler(),
  getListCarerixStatusInfosMockHandler(),
  getListCarerixSourceNodesMockHandler(),
  getListCarerixOwnersMockHandler(),
  getUpdateCarerixJobMappingMockHandler(),
  getConnectHomerunIntegrationMockHandler(),
  getUpdateHomerunConnectionMockHandler(),
  getGetHomerunConnectionMockHandler(),
  getDeleteIntegrationConnectionMockHandler(),
  getListAtsJobsMockHandler(),
  getMapJobWithAtsJobMockHandler(),
  getListAtsVacanciesMockHandler(),
  getImportAtsJobMockHandler(),
  getGetAtsConnectionSyncStatusMockHandler(),
  getResendOwnAtsJobApplicationsMockHandler(),
  getConnectMySolutionIntegrationMockHandler(),
  getUpdateMySolutionConnectionMockHandler(),
  getGetMySolutionConnectionMockHandler(),
  getGetMySolutionApplyConfigurationMockHandler(),
  getGetMySolutionWebhookInfoMockHandler(),
  getConnectOtysIntegrationMockHandler(),
  getUpdateOtysConnectionMockHandler(),
  getGetOtysConnectionMockHandler(),
  getListOtysPortalsMockHandler(),
  getUpdateOtysPortalMockHandler(),
  getConnectRecruiteeIntegrationMockHandler(),
  getUpdateRecruiteeConnectionMockHandler(),
  getGetRecruiteeConnectionMockHandler(),
  getGetRecruiteeJobLocationsMockHandler(),
  getConnectRecruitNowIntegrationMockHandler(),
  getUpdateRecruitNowConnectionMockHandler(),
  getGetRecruitNowConnectionMockHandler(),
  getUpdateRecruitNowJobMappingMockHandler(),
  getConnectUbeeoIntegrationMockHandler(),
  getUpdateUbeeoConnectionMockHandler(),
  getGetUbeeoConnectionMockHandler(),
  getRequestPasswordResetMockHandler(),
  getCreateEmployerInviteMockHandler(),
  getCreateTeammateInviteMockHandler(),
  getListReferralInvitesMockHandler(),
  getDeleteTeammateMockHandler(),
  getGetEmployerAccessMockHandler(),
  getGetProfileMockHandler(),
  getUpdateProfileMockHandler(),
  getUploadEmployerProfilePictureMockHandler(),
  getGetStatisticsMockHandler(),
  getListUnhandledJobsMockHandler(),
  getGetConferenceInfoMockHandler(),
  getListConferenceChatsEmployerMockHandler(),
  getSendConferenceChatMessageEmployerMockHandler(),
  getListUnreadConferenceChatsEmployerMockHandler(),
  getGetConferenceChatWithMessagesForEmployerMockHandler(),
  getListManagedCompaniesMockHandler(),
  getUpdateManagedCompanyMockHandler(),
  getResetManagedCompanyMockHandler(),
  getGetMyCompanyMockHandler(),
  getUpdateMyCompanyMockHandler(),
  getDeleteMyCompanyMockHandler(),
  getGetMyCompanyPlanMockHandler(),
  getListEmployersForCompanyMockHandler(),
  getUpdateEmployerCompanyAccessMockHandler(),
  getAddOrUpdateDefaultMessageMockHandler(),
  getDeleteDefaultMessageMockHandler(),
  getUploadProvisionalImageMockHandler(),
  getSendRequestToAccountManagerMockHandler(),
  getUpdateDefaultCandidatePoolMockHandler(),
  getUpdateCalendarInviteBodyMockHandler(),
  getGetCompanyHireReportInfoMockHandler(),
  getCreateCompanyHireReportMockHandler(),
  getSetMatchingConfigurationMockHandler(),
  getResetMatchingConfigurationMockHandler(),
  getGetMatchingConfigurationMockHandler(),
  getRequestLoginLinkMockHandler(),
  getComposeAiJobMockHandler(),
  getExtractVacancyFromPageMockHandler(),
  getDetermineJobFunctionMockHandler(),
  getDetermineAiJobDataMockHandler(),
  getWriteAiJobSectionsMockHandler(),
  getChatWithJobAgentMockHandler(),
  getRewriteJobSectionMockHandler(),
  getReviewAiJobMockHandler(),
  getListEducationLevelsMockHandler(),
  getListPersonalCharacteristicsMockHandler(),
  getListNewJobReasonsMockHandler(),
  getListPersonalityTypesMockHandler(),
  getGetAutoCompleteLocationsMockHandler(),
  getGetLocationDetailsMockHandler(),
  getGetLocationGeocodeMockHandler(),
  getListSkillsCertificatesAndLanguagesMockHandler(),
  getListAllSkillsMockHandler(),
  getListSkillsForJobCategoriesMockHandler(),
  getListCertificatesMockHandler(),
  getListJobFunctionsMockHandler(),
  getListSimilarJobFunctionsMockHandler(),
  getListJobCategoriesMockHandler(),
  getGetJobCategoryMockHandler(),
  getListInterestsMockHandler(),
  getGetRoleMockHandler()
]
